import { e as _taggedTemplateLiteral, c as _slicedToArray, a as _toConsumableArray, b as _objectWithoutProperties, _ as _objectSpread2, f as _asyncToGenerator, g as _defineProperty } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useResponsiveParams, Text, Button, Grid, DataGrid, RadioGroup, Modal, GridItem, NotificationList, Checkbox, Toggle, Paper, Label, Select, QuantaFormik, useQuantaFormikContext, QuantaSelect, QuantaLookupDateInput, QuantaForm, InputGridGroup, Wizard, QuantaCheckbox, QuantaInput, Chip, SearchResultsAdvanced, MixedTabbedDataGroup, QuantaVoiceActions, CircleButton, Card, SummaryLayout } from 'quanta-ui';
import { Layout, ClientService } from './layout.js';
import { gql, useQuery, useMutation } from '@apollo/client';
import { updateHealthQuote, updateHealthQuotePlansPremium, updateSelectedPlans, toggleAddOn, updateHealthQuotePlans, resetPlansChanged, updateCustomerInformation, updateQuotationDetails, initHealthPlansState, init_state_quote, initHealthQuoteState } from './quote/health/state.js';
import moment from 'moment';
import { L as Loading } from './loading-c16d3bd3.js';
import { E as Error$1 } from './error-ee5266a9.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faSpinner, faInfoCircle, faCheck, faChevronRight, faChevronCircleUp, faChevronCircleDown, faCheckCircle, faPlus, faTrashAlt, faUsers, faFileAlt, faEnvelope, faSms, faUserTag, faBuilding, faSearch, faUniversity, faUser, faMapMarkerAlt, faMobileAlt, faUserCheck, faUserPlus, faExclamationTriangle, faSave, faExclamationCircle, faTimesCircle, faDownload, faHeartbeat } from '@fortawesome/free-solid-svg-icons';
import { updateBuyHealthPolicy, initBuyHealthPolicyVar } from './proposal/health/state.js';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { P as Parse } from './CurrencyFormater-d288bc4f.js';
import { M as ModalViewBreakup } from './view-breakup-99284a36.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { u as useMutationQuery } from './useMutationQuery-42b53d8d.js';
import './exports-166cdf01.js';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import 'react-helmet';
import './queries-3df8abcc.js';
import './queries-a3e6305b.js';
import { I as IconIdle } from './icon-search-idle-a2977e92.js';
import ModalDownloadQuote from './ModalDownloadQuote.js';
import { initBuyMotorPolicyVar } from './proposal/motor/state.js';
import { i as initBuyIpaPolicyVar } from './state-cd3cac59.js';

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;
var QUERY_STATE = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  query healthQuotePlans {\n    healthQuote @client\n    healthPlans @client\n    selectedIntermediary @client\n  }\n"])));
var PIN_CODE_LOOKUP = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query pinCodeLookup($filter: PincodeFilter) {\n    pincodeInfo(filter: $filter) {\n      city\n      district\n      pinCode\n      state\n    }\n  }\n"])));
var GET_PRODUCT_DETAILS = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query getProductDetails($input: productDetailsInput) {\n    productDetails(input: $input) {\n      applicableZones {\n        code\n        value\n      }\n      applicableTenures {\n        code\n        value\n      }\n      applicableCoverTypes {\n        code\n        value\n      }\n      applicableSumInsureds\n      applicableMemberTypes {\n        label\n        gender\n        selectGender\n        maxAllowed\n      }\n      defaultSumInsured {\n        coverType\n        value\n      }\n    }\n    genderList {\n      code\n      value\n    }\n  }\n"])));
var GET_PLAN_COVER_DETAILS = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query getPlanCoverDetails($input: planAndCoversInput) {\n    planAndCovers(input: $input) {\n      name\n      code\n      covers {\n        name\n        index\n      }\n      packs {\n        name\n        index\n        addOnCovers {\n          name\n          index\n          selected\n        }\n      }\n    }\n  }\n"])));
var CALCULATE_PREMIUM = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  query calculatePremiumForQuote($input: CalculatePremiumQuote) {\n    calculatePremium(input: $input) {\n      basePremium\n      loadingDiscount\n      netPremium\n      gst\n      stampDuty\n      totalPremium\n      loading {\n        name\n        amount\n      }\n      discount {\n        name\n        amount\n      }\n      breakup {\n        relationship\n        gender\n        age\n        premium\n      }\n      CustID\n      CustType\n      warningMsg\n    }\n  }\n"])));
var SAVE_QUOTE = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  mutation saveQuote($input: QuoteInput) {\n    saveQuote(input: $input) {\n      quoteNumber\n      quoteCreationDate\n      status\n    }\n  }\n"])));
var SAVE_PLAN_PREDICTION_DATA = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  mutation savePlanPredictionData($input: PredictionDataInput) {\n    savePlanPredictionData(input: $input) {\n      isSuccess\n    }\n  }\n"])));
var PREDICT_HEALTH_PLAN = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  query predictHealthPlan($filter: PredictHealthPlaInput) {\n    predictHealthPlan(filter: $filter) {\n      plan\n    }\n  }\n"])));
var SEARCH_CUSTOMERS = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  query searchCustomers($filter: CustomerFilter) {\n    _customer_meta(filter: $filter) {\n      resultCount\n      maxRow\n      infoMessages\n      metaMessage {\n        type\n        header\n        message\n      }\n    }\n    customers(filter: $filter) {\n      cust_type {\n        code\n        value\n      }\n      cust_number\n      indv_detail {\n        full_name\n      }\n      org_detail {\n        org_name\n      }\n      contact {\n        email\n        mobile\n      }\n      permanent_address {\n        location\n      }\n    }\n  }\n"])));
var SEARCH_CUSTOMER_BY_NUMBER = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  query searchCustomerByNumber($input: ViewCustInput) {\n    customer(input: $input) {\n      cust_number\n      cust_ref_number\n      cust_type {\n        code\n        value\n      }\n      bank_detail {\n        name\n        branch_name\n        ifsc_code\n        acc_number\n        acc_holder\n        micr_code\n      }\n      permanent_address {\n        address_line1\n        address_line2\n        address_line3\n        land_mark\n        city\n        district\n        state\n        pin_code\n      }\n      comm_equal_perm\n      communication_address {\n        address_line1\n        address_line2\n        address_line3\n        land_mark\n        city\n        district\n        state\n        pin_code\n      }\n      indv_detail {\n        title {\n          code\n          value\n        }\n        first_name\n        middle_name\n        full_name\n        surname\n        date_of_birth\n        id_proof_type {\n          code\n          value\n        }\n        id_proof_number\n        pan_card_number\n        nationality {\n          code\n          value\n        }\n        occupation {\n          code\n          value\n        }\n        gender {\n          code\n          value\n        }\n        marital_status {\n          code\n          value\n        }\n      }\n      org_detail {\n        org_name\n        org_type {\n          code\n          value\n        }\n        reg_number\n        tan_number\n        gst_number\n        contact_mob\n        contact_name\n        contact_email\n      }\n      contact {\n        email\n        mobile\n      }\n    }\n  }\n"])));
var GET_CUSTOMER_TYPE_DOMAIN = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  query getCustomerTypeDomain {\n    customerTypeList {\n      code\n      value\n    }\n  }\n"])));
var CUSTOMER_DROPDOWN_DETAILS = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  query customerOrganisationDetails {\n    organisationList {\n      code\n      value\n    }\n    salutationList {\n      code\n      value\n    }\n    businessTypeList {\n      code\n      value\n    }\n    genderList {\n      code\n      value\n    }\n  }\n"])));
var SEND_QUOTE_EMAIL_ALERT = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  mutation sendQuoteEmail(\n    $input: QuoteInput\n    $email: String\n    $quoteNumber: String\n    $ccEmailIds: [String]\n  ) {\n    sendQuoteEmail(\n      input: $input\n      email: $email\n      quoteNumber: $quoteNumber\n      ccEmailIds: $ccEmailIds\n    ) {\n      message\n    }\n  }\n"])));
var SEND_QUOTE_SMS_ALERT = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  mutation sendQuoteSMS(\n    $input: QuoteInput\n    $mobile: String\n    $quoteNumber: String\n    $alternateMobileNos: [String]\n    $whatsappNo: String\n    $modes: [String]\n  ) {\n    sendQuoteSMS(\n      input: $input\n      mobile: $mobile\n      quoteNumber: $quoteNumber\n      alternateMobileNos: $alternateMobileNos\n      whatsappNo: $whatsappNo\n      modes: $modes\n    ) {\n      message\n    }\n  }\n"])));
var SEND_QUOTE_PDF = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  mutation sendQuotePDF($input: QuoteInput, $quoteNumber: String) {\n    sendQuotePDF(input: $input, quoteNumber: $quoteNumber) {\n      base64Pdf\n    }\n  }\n"])));
var PRODUCT_TYPE_LIST = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  query productTypeList {\n    lobProductList {\n      lob_name\n      lob_code\n      products {\n        product_name\n        product_code\n        product_types {\n          code\n          value\n        }\n        linkTo\n      }\n    }\n  }\n"])));
gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  query getSelectedIntermediary {\n    selectedIntermediary @client\n  }\n"])));
var INTERMEDIARY_LIST = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  query IntermediaryList {\n    myIntermediaries {\n      intermediaryName\n      intermediaryCode\n      isSelected\n      businessLocations {\n        code\n        name\n      }\n    }\n  }\n"])));
var LOOKUP_FIELDUSER = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  query lookupFieldUser($filter: UserSearchFilter) {\n    associatedEntityLookup(filter: $filter) {\n      fieldUserName\n    }\n  }\n"])));
var CHARACTER_LIMIT_LIST = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  query characterLimitList {\n    characterLimitList {\n      code\n      value\n    }\n  }\n"])));
var MOBILE_NUMBER_STARTING_WITH$1 = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  query mobileNumberStartingWith {\n    mobileNumberStartingWith {\n      code\n      value\n    }\n  }\n"])));
var COVER_TYPE_LIMIT = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  query maxInsuredLimitList {\n    maxInsuredLimitList {\n      code\n      value\n    }\n  }\n"])));
var SEARCH_QUOTES = gql(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  query searchQuotes($filter: Quote) {\n    searchQuotes(filter: $filter) {\n      lob {\n        lobCode\n        lobName\n      }\n      product {\n        productCode\n        productName\n      }\n      maternitySelectedCover\n      quoteCreationDate\n      customer {\n        indv_detail {\n          first_name\n          surname\n          full_name\n          middle_name\n        }\n        org_detail {\n          org_name\n        }\n        contact {\n          mobile\n          email\n        }\n      }\n      quoteNumber\n      quotationType\n      quoteStatus\n      members {\n        relationship\n        gender\n        age\n        maternitySelected\n      }\n      location {\n        city\n        state\n        zone\n      }\n      cover {\n        type\n        tenure\n        sumInsured\n      }\n      maternityMembers {\n        planName\n        members {\n        relationship\n        gender\n        age\n        dob\n        maternitySelected\n        }\n      }\n      plans {\n        name\n        premium {\n          totalPremium\n        }\n      }\n    }\n    _quote_meta(filter: $filter) {\n      maxRow\n      resultCount\n      infoMessages\n      metaMessage {\n        type\n        header\n        message\n      }\n    }\n  }\n"])));
var QUOTE_STATUS_LIST = gql(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  query {\n    quoteStatusList {\n      code\n      value\n    }\n  }\n"])));
var DATE_RANGE = gql(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  query dateRange($type: String) {\n    dateRange(type: $type) {\n      min\n      max\n    }\n  }\n"])));
var LOB_PRODUCT_LIST = gql(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  query lobProductList {\n    lobProductList {\n      lob_name\n      lob_code\n      products {\n        product_name\n        product_code\n        product_types {\n          code\n          value\n        }\n        linkTo\n      }\n    }\n  }\n"])));
var FETCH_ROLE = gql(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  query fetchRole {\n    checkAuth {\n      role {\n        roleName\n      }\n    }\n  }\n"])));
var VIEW_QUOTE_HEALTH = gql(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  query viewQuote($input: viewQuoteInput) {\n    viewQuote(input: $input) {\n      existingPolicyNumber\n      isExistingEmployee\n      maternitySelectedCover\n      lob {\n        lobCode\n        lobName\n      }\n      product {\n        productCode\n        productName\n      }\n      intermediaryDetails {\n        code\n        location\n        fieldUserCode\n        fieldUserName\n      }\n      quoteCreationDate\n      quoteStatus\n      proposalNumber\n      customer {\n        bank_detail {\n          ifsc_code\n          branch_name\n          name\n          acc_holder\n          micr_code\n          acc_number\n        }\n        cust_number\n        cust_ref_number\n        cust_type {\n          code\n          value\n        }\n        indv_detail {\n          title {\n            code\n            value\n          }\n          gender {\n            code\n            value\n          }\n          occupation {\n            code\n            value\n          }\n          nationality {\n            code\n            value\n          }\n          marital_status {\n            code\n            value\n          }\n          first_name\n          surname\n          middle_name\n          full_name\n          date_of_birth\n          id_proof_type {\n            code\n            value\n          }\n          id_proof_number\n          pan_card_number\n          gst_number\n        }\n        org_detail {\n          org_name\n          org_type {\n            code\n            value\n          }\n          contact_name\n          reg_number\n          tan_number\n          gst_number\n        }\n        permanent_address {\n          address_line1\n          address_line2\n          address_line3\n          land_mark\n          state\n          district\n          city\n          pin_code\n        }\n        communication_address {\n          address_line1\n          address_line2\n          address_line3\n          land_mark\n          city\n          district\n          state\n          pin_code\n        }\n        comm_equal_perm\n        contact {\n          mobile\n          email\n          fax_number\n          telephone\n          alt_telephone\n          alt_mobile\n        }\n      }\n      quotationType\n      quoteNumber\n      members {\n        relationship\n        gender\n        age\n        dob\n        maternitySelected\n      }\n      location {\n        pincode\n        city\n        state\n        zone\n        district\n      }\n      cover {\n        type\n        tenure\n        sumInsured\n      }\n      plans {\n        name\n        code\n        covers {\n          name\n          index\n        }\n        packs {\n          name\n          index\n          addOnCovers {\n            name\n            index\n            selected\n          }\n        }\n        premium {\n          basePremium\n          loadingDiscount\n          netPremium\n          gst\n          stampDuty\n          totalPremium\n          loading {\n            name\n            amount\n          }\n          discount {\n            name\n            amount\n          }\n          breakup {\n            relationship\n            age\n            gender\n            premium\n          }\n        }\n      }\n      deductSumInsured\n    }\n    genderList {\n      code\n      value\n    }\n  }\n"])));
var SAVE_QUOTE_TYPE = gql(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  mutation SaveQuoteTypeList($productCode: String) {\n    SaveQuoteTypeList(poductCode: $productCode) {\n      quoteNumber\n      quoteCreationDate\n      status\n    }\n  }\n"])));
var CROSS_SELL_ROLE_LIMIT = gql(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  query crossSellDiscLimit($productCode: StrictNumber) {\n    CrossSellRoleLimits(productCode: $productCode) {\n      hp_tenure\n      product\n      ipa_policy_min_si\n      min_net_premium {\n        product\n        min\n      }\n    }\n  }\n"])));
var EXCEPTION_ROLE_LIMIT = gql(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  query exceptionRoleLimits($name: String) {\n    exceptionRoleLimits(name: $name) {\n    name\n    limits {\n      key\n      rolename\n      isException\n    }\n    totalSumInsuredLimit{\n      value\n      digit\n      isActive\n    }\n  }\n}\n"])));
var EXISTING_POLICY_DTLS = gql(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  query ExistingPolicyDtls($policyNo:String){\n    ExistingPolicyDtls(policyNo: $policyNo){\n      productCode\n      coverSI\n      netPremium\n    }\n  }\n"])));

function QuoteData(_ref) {
  var _healthPlans$plans, _healthPlans$plans$fi;

  var goToStep = _ref.goToStep,
      genderList = _ref.genderList;
      _ref.productCode;
      _ref.productName;
      _ref.lobCode;
      _ref.quoteNumber;
      var setStartStep = _ref.setStartStep;
  var repeatForMobile = 2;
  var repeatForDesktop = 4;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error$1, null);
  var healthQuote = state.healthQuote,
      healthPlans = state.healthPlans;

  var resolveGender = function resolveGender(code) {
    var gender = genderList.find(function (gender) {
      return gender.code === code;
    }) ? genderList.find(function (gender) {
      return gender.code === code;
    }).value : code;
    return gender;
  };

  var data = [{
    title: 'Members',
    grid_data: [{
      text: healthQuote.members.filter(function (mem) {
        return mem.selected;
      }).map(function (mem, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx
        }, /*#__PURE__*/React.createElement(Text, {
          type: repeat === repeatForMobile ? 'label' : 'normal'
        }, mem.relationship, ", ", resolveGender(mem.gender), ",", ' ', mem.age + ' Years'));
      })
    }]
  }, {
    title: 'Customer Location',
    grid_data: [{
      text: /*#__PURE__*/React.createElement("div", null, healthQuote.location.zone, ", ", healthQuote.location.city, ' ', healthQuote.location.pincode)
    }]
  }, {
    title: 'Cover',
    grid_data: [{
      text: /*#__PURE__*/React.createElement("div", null, healthQuote.cover.type, ", ", healthQuote.cover.tenure)
    }]
  }, {
    title: '',
    grid_data: [{
      label: /*#__PURE__*/React.createElement(Text, null, "\xA0"),
      text: !healthQuote.quotationNo ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        flat: true,
        className: "w-full md:w-48 md:pr-4 max-h-10 -ml-0.5",
        onClick: function onClick(e) {
          goToStep(0);
          setStartStep(0);
          updateHealthQuote({
            currentTab: 'members'
          });
        },
        disabled: healthQuote.quotationNo !== null && healthQuote.quotationNo !== '' || (healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.isQuoteSaving) || (healthPlans === null || healthPlans === void 0 ? void 0 : (_healthPlans$plans = healthPlans.plans) === null || _healthPlans$plans === void 0 ? void 0 : (_healthPlans$plans$fi = _healthPlans$plans.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isCalculatingPremium;
        })) === null || _healthPlans$plans$fi === void 0 ? void 0 : _healthPlans$plans$fi.length) > 0 || (healthPlans === null || healthPlans === void 0 ? void 0 : healthPlans.isCoversLoading)
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faChevronLeft,
        className: '-ml-4 mr-4'
      }), "Change")) : /*#__PURE__*/React.createElement(Button, {
        flat: true,
        className: "w-full md:w-48 max-h-10 -ml-0.5",
        onClick: function onClick(e) {
          goToStep(0);
        },
        iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faChevronLeft,
          className: "-ml-1 ".concat(repeat === repeatForMobile ? 'mr-2' : '')
        })
      }, "View Members")
    }]
  }];
  return /*#__PURE__*/React.createElement(Grid, {
    repeat: repeat,
    gap: 4,
    className: "w-full"
  }, data.map(function (dt, idx) {
    return /*#__PURE__*/React.createElement(DataGrid, {
      key: idx,
      title: dt.title,
      titleType: "title",
      titleSeverity: "info",
      gap: 1,
      repeat: 1,
      data: dt.grid_data,
      textType: repeat === repeatForMobile ? 'label' : 'normal'
    });
  }));
}

function ShowPremium(_ref) {
  var planName = _ref.planName,
      loading = _ref.loading,
      error = _ref.error,
      setShowViewBreakup = _ref.setShowViewBreakup,
      setSelectedPlanTypeView = _ref.setSelectedPlanTypeView;
  var repeatForMobile = 2;
  var repeatForDesktop = 4;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var _useQuery = useQuery(QUERY_STATE),
      data = _useQuery.data;

  var healthPlans = data.healthPlans;
  var premium = healthPlans.plans.find(function (plan) {
    return plan.name === planName;
  }) ? healthPlans.plans.find(function (plan) {
    return plan.name === planName;
  }).premium : null;
  if (loading) return /*#__PURE__*/React.createElement(Text, {
    severity: "info"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true,
    className: "mr-1"
  })), repeat === repeatForMobile ? 'Calculating' : 'Calculating Premium');
  if (error) return /*#__PURE__*/React.createElement(Text, {
    severity: "error"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoCircle,
    className: "mr-1"
  })), repeat === repeatForMobile ? 'Error' : 'Error calculating Premium');
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row"
  }, error && /*#__PURE__*/React.createElement(Text, {
    severity: 'error',
    className: 'flex space-x-2'
  }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoCircle
  })), /*#__PURE__*/React.createElement(Text, null, " Error Calculating Premium")), !error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, premium &&
  /*#__PURE__*/
  // <Text type="larger" severity="info">
  React.createElement(Text, {
    type: "subtitle",
    severity: "info"
  }, Parse(premium.totalPremium, true, false, branding, true))), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary -mt-1 md:mt-1"
  }, premium && /*#__PURE__*/React.createElement(Text, {
    severity: "action",
    type: "title",
    className: "text-secondary -ml-2 quanta_link md:mt-2 md:ml-1 cursor-pointer",
    onClick: function onClick(e) {
      setShowViewBreakup(true);
      setSelectedPlanTypeView(planName);
    }
  }, "View Breakup"))));
}

var _excluded$4 = ["packs"],
    _excluded2$1 = ["addOnCovers"],
    _excluded3$1 = ["selected"];

function RenderPlan(_ref) {
  var _quote$intermediaryDe, _quote$intermediaryDe2, _quote$intermediaryDe3, _quote$isExistingEmpl, _quote$location, _ref2, _ref3, _plan$covers, _healthQuote$maternit3, _healthQuote$maternit4, _healthQuote$maternit5, _healthQuote$maternit6, _healthQuote$maternit7;

  var id = _ref.id,
      plan = _ref.plan,
      plans = _ref.plans,
      quote = _ref.quote,
      plansChanged = _ref.plansChanged,
      setShowViewBreakup = _ref.setShowViewBreakup,
      alerts = _ref.alerts,
      setAlerts = _ref.setAlerts,
      setSelectedPlanTypeView = _ref.setSelectedPlanTypeView,
      quoteNumber = _ref.quoteNumber,
      productName = _ref.productName,
      productCode = _ref.productCode,
      lobCode = _ref.lobCode,
      selectedIntermediary = _ref.selectedIntermediary,
      setShowViewBaseCovers = _ref.setShowViewBaseCovers,
      setCurrentPlan = _ref.setCurrentPlan;
      _ref.recommendedPlanData;
      var isDocAvailable = _ref.isDocAvailable,
      productDetails = _ref.productDetails;
      _ref.saveProceedDisplay;
  var repeatForMobile = 2;
  var repeatForDesktop = 4;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });
  var fetchQuery = useFetchQuery();
  useMutationQuery();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      initLoad = _useState4[0],
      setInitLoad = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      flags = _useState6[0],
      setflag = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      resultPremiumError = _useState8[0],
      setResultPremiumError = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isProceeding = _useState10[0],
      setProceeding = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      isPASelected = _useState12[0],
      setPASelected = _useState12[1];

  var _useState13 = useState((quote === null || quote === void 0 ? void 0 : quote.maternitySelectedCover) == true ? true : false),
      _useState14 = _slicedToArray(_useState13, 2),
      isMBSelected = _useState14[0],
      setMBSelected = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2);
      _useState16[0];
      _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      disableProceed = _useState18[0],
      setDisableProcced = _useState18[1]; // const [hide, setHide]=useState(true);


  var history = useHistory();

  var maternitySelected = [];

  var updatematernitycover = function updatematernitycover(val, member, ki, plan) {
    var _healthQuote$maternit, _healthQuote$maternit2;

    var planidx = healthQuote.maternityMembers.findIndex(function (mem) {
      return mem.planName == plan;
    });
    updateHealthQuote({
      maternityMembers: [].concat(_toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$maternit = healthQuote.maternityMembers) === null || _healthQuote$maternit === void 0 ? void 0 : _healthQuote$maternit.slice(0, planidx)), [{
        planName: plan,
        members: _toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.maternityMembers[planidx].members.map(function (k) {
          if (k.relationship == ki.relationship) {
            var _k$age;

            return {
              relationship: k === null || k === void 0 ? void 0 : k.relationship,
              gender: k === null || k === void 0 ? void 0 : k.gender,
              dob: k === null || k === void 0 ? void 0 : k.dob,
              age: k === null || k === void 0 ? void 0 : (_k$age = k.age) === null || _k$age === void 0 ? void 0 : _k$age.toString(),
              selected: k === null || k === void 0 ? void 0 : k.selected,
              disabled: k === null || k === void 0 ? void 0 : k.disabled,
              maternitySelected: val
            };
          } else {
            var _k$age2;

            return {
              relationship: k === null || k === void 0 ? void 0 : k.relationship,
              gender: k === null || k === void 0 ? void 0 : k.gender,
              dob: k === null || k === void 0 ? void 0 : k.dob,
              age: k === null || k === void 0 ? void 0 : (_k$age2 = k.age) === null || _k$age2 === void 0 ? void 0 : _k$age2.toString(),
              selected: k === null || k === void 0 ? void 0 : k.selected,
              disabled: k === null || k === void 0 ? void 0 : k.disabled,
              maternitySelected: k.maternitySelected
            };
          }
        }))
      }], _toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$maternit2 = healthQuote.maternityMembers) === null || _healthQuote$maternit2 === void 0 ? void 0 : _healthQuote$maternit2.slice(planidx + 1)))
    });
  };

  var updatematernitycovermem = function updatematernitycovermem(val, member, k) {
    var maternitySelected = [];
    member.forEach(function (e) {
      //  if(val==true &&k.relationship==e.relationship)
      //  {
      maternitySelected.push({
        age: e.age,
        dob: e.dob,
        gender: e.gender,
        maternitySelected: e.relationship == k.relationship ? val : e.maternitySelected,
        relationship: e.relationship,
        selected: e.selected
      }); //  }
    });
    return maternitySelected;
  };

  var updatematernitycovermember = function updatematernitycovermember(member, filteredValue) {
    console.log("filteredvalue", filteredValue.length);
    var maternitySelected = [];
    member.forEach(function (e) {
      var _filteredValue$, _filteredValue$2, _filteredValue$3, _filteredValue$4;

      maternitySelected.push({
        age: e.age,
        dob: e.dob,
        gender: e.gender,
        maternitySelected: ((filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$ = filteredValue[0]) === null || _filteredValue$ === void 0 ? void 0 : _filteredValue$.maternitySelected) == false || (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$2 = filteredValue[0]) === null || _filteredValue$2 === void 0 ? void 0 : _filteredValue$2.maternitySelected) == undefined) && e.relationship == (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$3 = filteredValue[0]) === null || _filteredValue$3 === void 0 ? void 0 : _filteredValue$3.relationship) ? true : e.maternitySelected,
        relationship: e.relationship,
        selected: e.selected,
        disabled: (filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) == 1 && e.relationship == (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$4 = filteredValue[0]) === null || _filteredValue$4 === void 0 ? void 0 : _filteredValue$4.relationship) ? true : false
      }); // })
      //  }
    });
    return maternitySelected;
  };

  var _useContext = useContext(ConfigContext);
      _useContext.branding;

  plans.plans.find(function (p) {
    return plan.name === (p === null || p === void 0 ? void 0 : p.name);
  }) ? plans.plans.find(function (p) {
    return plan.name === (p === null || p === void 0 ? void 0 : p.name);
  }).premium : null;

  var getGraphQLErrorMessage = function getGraphQLErrorMessage(error) {
    return error.graphQLErrors.length > 0 ? error.graphQLErrors.map(function (gerr) {
      return gerr && gerr.message ? gerr.message : 'Internal Error Occurred';
    })[0] : error.message //Unexpected Token
    ? error.message.includes("Unexpected token") ? 'Please try again after sometime' : error.message : 'Internal Error Occurred'; //Unexpected Token
  };
  /**SA : CR_P2_577 : Added Validation for copyQuote*/


  useEffect(function () {
    if (!(quote !== null && quote !== void 0 && quote.quotationNo) && (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && productDetails !== null && productDetails !== void 0 && productDetails.defaultSumInsured) {
      var _quote$cover, _productDetails$defau;

      if (parseInt(quote === null || quote === void 0 ? void 0 : (_quote$cover = quote.cover) === null || _quote$cover === void 0 ? void 0 : _quote$cover.sum_insured) < (productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$defau = productDetails.defaultSumInsured.find(function (d) {
        return d.coverType === (quote === null || quote === void 0 ? void 0 : quote.cover.type);
      })) === null || _productDetails$defau === void 0 ? void 0 : _productDetails$defau.value)) {
        var _productDetails$defau2, _productDetails$defau3;

        setDisableProcced(true);
        setAlerts([].concat(_toConsumableArray(alerts), [{
          header: 'Warning',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, /*#__PURE__*/React.createElement("span", null, "Sum Insured cannot be less than \n                    ".concat(productDetails === null || productDetails === void 0 ? void 0 : (_productDetails$defau2 = productDetails.defaultSumInsured) === null || _productDetails$defau2 === void 0 ? void 0 : (_productDetails$defau3 = _productDetails$defau2.find(function (d) {
            return d.coverType === (quote === null || quote === void 0 ? void 0 : quote.cover.type);
          })) === null || _productDetails$defau3 === void 0 ? void 0 : _productDetails$defau3.value))),
          type: 'warning',
          timeout: null,
          disableClose: false
        }]));
      } else {
        setDisableProcced(false);
      }
    }
  }, [quote === null || quote === void 0 ? void 0 : quote.cover]);
  /**EA : CR_P2_577 : set default Value for copyQuote */

  var getAddOnCovers = function getAddOnCovers(rel, maternitySelected) {
    var addOnCoverArr = [];
    plan === null || plan === void 0 ? void 0 : plan.packs.forEach(function (pack) {
      if (pack.index.includes(rel)) {
        pack.addOnCovers.forEach(function (addOn) {
          if (addOn !== null && addOn !== void 0 && addOn.selected) {
            if (addOn.name !== 'Maternity Benefit' && addOn.name !== 'New Born Baby Cover' && addOn.name !== 'Vaccination Expenses') {
              addOnCoverArr.push({
                name: addOn.name,
                index: addOn.index
              });
            }

            if (addOn.name == 'New Born Baby Cover' && maternitySelected == true) {
              addOnCoverArr.push({
                name: addOn.name,
                index: addOn.index
              });
            }

            if (addOn.name == 'Vaccination Expenses' && maternitySelected == true) {
              addOnCoverArr.push({
                name: addOn.name,
                index: addOn.index
              });
            }

            if (addOn.name == 'Maternity Benefit' && maternitySelected == true) {
              addOnCoverArr.push({
                name: addOn.name,
                index: addOn.index
              });
            }
          }
        });
      }
    });
    return addOnCoverArr;
  };

  var updateAddOn = function updateAddOn(planName) {
    var _plans$plans;

    var PlanAndcoversList = plans === null || plans === void 0 ? void 0 : (_plans$plans = plans.plans) === null || _plans$plans === void 0 ? void 0 : _plans$plans.map(function (p) {
      var packs = p.packs,
          restobj = _objectWithoutProperties(p, _excluded$4);

      var packsList = packs.map(function (e) {
        var addOnCovers = e.addOnCovers,
            restPackobj = _objectWithoutProperties(e, _excluded2$1);

        var AddOnList = addOnCovers === null || addOnCovers === void 0 ? void 0 : addOnCovers.map(function (f) {
          var _sessionStorage, _sessionStorage$getIt, _sessionStorage$getIt2;

          if ((f === null || f === void 0 ? void 0 : f.name) === 'Personal Accident Cover' && productCode === '2883' && ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage$getIt = _sessionStorage.getItem('roleName')) === null || _sessionStorage$getIt === void 0 ? void 0 : (_sessionStorage$getIt2 = _sessionStorage$getIt.toString()) === null || _sessionStorage$getIt2 === void 0 ? void 0 : _sessionStorage$getIt2.toLowerCase()) === 'non bancassurance - apc' && (p === null || p === void 0 ? void 0 : p.name) === planName //&& ( !skipPACover || 
          && !isPASelected //)
          //p?.name === 'Edge' || p?.name === 'Total' )
          ) {
              f.selected;
                  var restaddondtl = _objectWithoutProperties(f, _excluded3$1);

              return _objectSpread2(_objectSpread2({}, restaddondtl), {}, {
                selected: true
              });
            } else {
            return f;
          }
        });
        return _objectSpread2(_objectSpread2({}, restPackobj), {}, {
          addOnCovers: AddOnList
        });
      });
      return _objectSpread2(_objectSpread2({}, restobj), {}, {
        packs: packsList
      });
    });
    updateHealthQuotePlans(PlanAndcoversList);
  };

  var variables = {
    input: {
      members: quote.members.filter(function (m) {
        return m.selected;
      }).map(function (mem) {
        return {
          // relationship: mem.relationship,
          relationship: (mem === null || mem === void 0 ? void 0 : mem.relationship) === 'Brother 1' ? 'Brother' : (mem === null || mem === void 0 ? void 0 : mem.relationship) === 'Sister 1' ? 'Sister' : mem === null || mem === void 0 ? void 0 : mem.relationship,
          gender: mem.gender,
          dob: mem.dob,
          age: mem.age.toString(),
          maternitySelected: isMBSelected == true ? mem.maternitySelected : false,
          addOnCovers: getAddOnCovers(mem.relationship, mem.maternitySelected)
        };
      }),
      businessType: quote.quotationType,
      intermediary: {
        intermediaryCode: (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe = quote.intermediaryDetails) === null || _quote$intermediaryDe === void 0 ? void 0 : _quote$intermediaryDe.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode),
        locationCode: (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe2 = quote.intermediaryDetails) === null || _quote$intermediaryDe2 === void 0 ? void 0 : _quote$intermediaryDe2.location) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode),
        fieldUserCode: (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe3 = quote.intermediaryDetails) === null || _quote$intermediaryDe3 === void 0 ? void 0 : _quote$intermediaryDe3.fieldUserCode) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode)
      },
      startDate: moment().format('DD/MM/YYYY').toString(),
      startTime: '00:00',
      plan: {
        name: plan === null || plan === void 0 ? void 0 : plan.name,
        code: plan === null || plan === void 0 ? void 0 : plan.code
      },
      zone: quote.location.zone,
      coverType: quote.cover.type,
      sumInsured: parseInt(quote.cover.sum_insured),
      tenure: quote.cover.tenure,
      productCode: productCode,
      existingPolicyNumber: quote === null || quote === void 0 ? void 0 : quote.existingPolicyNumber,
      isExistingEmployee: (quote === null || quote === void 0 ? void 0 : (_quote$isExistingEmpl = quote.isExistingEmployee) === null || _quote$isExistingEmpl === void 0 ? void 0 : _quote$isExistingEmpl.toLowerCase()) === 'yes' ? true : false,
      proposerPincode: quote === null || quote === void 0 ? void 0 : (_quote$location = quote.location) === null || _quote$location === void 0 ? void 0 : _quote$location.pincode
    }
  };

  var updatefunction = function updatefunction(maternityData) {
    var flag = maternityData.filter(function (e) {
      return e.maternitySelected == true;
    });
    console.log("1234444444", flag);

    if (flag.length == 0 && healthQuote.maternitySelectedCover) {
      setflag(true);
      setAlerts([].concat(_toConsumableArray(alerts), [{
        header: 'Error',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, /*#__PURE__*/React.createElement("span", null, "Please select Maternity insured member")),
        type: 'error',
        timeout: null,
        disableClose: false
      }]));
    } else {
      setflag(false);
    }
  };

  var _useQuery = useQuery(CALCULATE_PREMIUM, {
    variables: variables,
    skip: (quoteNumber ? true : initLoad ? false : !(plansChanged !== null && plansChanged !== void 0 && plansChanged.includes(plan === null || plan === void 0 ? void 0 : plan.name))) || (quote === null || quote === void 0 ? void 0 : quote.quotationNo) !== '',
    onCompleted: function onCompleted(data) {
      var _sessionStorage2, _sessionStorage2$getI, _sessionStorage2$getI2, _data$calculatePremiu2, _data$calculatePremiu3;

      setInitLoad(false);
      setResultPremiumError(false);

      if (((plan === null || plan === void 0 ? void 0 : plan.name) === 'Total' || (plan === null || plan === void 0 ? void 0 : plan.name) === 'Edge') && productCode === '2883' && ((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : (_sessionStorage2$getI = _sessionStorage2.getItem('roleName')) === null || _sessionStorage2$getI === void 0 ? void 0 : (_sessionStorage2$getI2 = _sessionStorage2$getI.toString()) === null || _sessionStorage2$getI2 === void 0 ? void 0 : _sessionStorage2$getI2.toLowerCase()) === 'non bancassurance - apc') {
        var _data$calculatePremiu, _quote$cover2;

        if (((_data$calculatePremiu = data.calculatePremium) === null || _data$calculatePremiu === void 0 ? void 0 : _data$calculatePremiu.totalPremium) <= 15000 && parseInt(quote === null || quote === void 0 ? void 0 : (_quote$cover2 = quote.cover) === null || _quote$cover2 === void 0 ? void 0 : _quote$cover2.sum_insured) <= 1000000 // && (!skipPACover || 
        && // && (!skipPACover || 
        !isPASelected) {
          updateAddOn(plan === null || plan === void 0 ? void 0 : plan.name);

          if (!isPASelected) {
            setInitLoad(true);
            setPASelected(true);
          }
        }
      }

      updateHealthQuotePlansPremium(plan === null || plan === void 0 ? void 0 : plan.name, data.calculatePremium);

      if (data !== null && data !== void 0 && (_data$calculatePremiu2 = data.calculatePremium) !== null && _data$calculatePremiu2 !== void 0 && _data$calculatePremiu2.warningMsg && (data === null || data === void 0 ? void 0 : (_data$calculatePremiu3 = data.calculatePremium) === null || _data$calculatePremiu3 === void 0 ? void 0 : _data$calculatePremiu3.warningMsg) !== '') {
        var _data$calculatePremiu4;

        setAlerts([].concat(_toConsumableArray(alerts), [{
          header: "Warning for Plan ".concat(plan === null || plan === void 0 ? void 0 : plan.name),
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full text-base"
          }, /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : (_data$calculatePremiu4 = data.calculatePremium) === null || _data$calculatePremiu4 === void 0 ? void 0 : _data$calculatePremiu4.warningMsg)),
          type: 'warning',
          timeout: null,
          disableClose: false
        }]));
      }
    },
    onError: function onError(error) {
      setResultPremiumError(true);
      setAlerts([].concat(_toConsumableArray(alerts), [{
        header: "Error for Plan ".concat(plan === null || plan === void 0 ? void 0 : plan.name),
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full text-base"
        }, /*#__PURE__*/React.createElement("span", null, getGraphQLErrorMessage(error))),
        type: 'error',
        timeout: null,
        disableClose: false
      }]));
      updateSelectedPlans(plan === null || plan === void 0 ? void 0 : plan.name, false); //Unexpected Token

      //Unexpected Token
      if (error !== null && error !== void 0 && error.message) {
        if (error.message.includes("Unexpected token")) {
          error.message = 'Please try again after sometime';
        }
      } //Unexpected Token

    }
  }),
      premiumLoading = _useQuery.loading,
      premiumError = _useQuery.error;

  var _useQuery2 = useQuery(INTERMEDIARY_LIST),
      intermediaryListLoading = _useQuery2.loading,
      intermediaryListError = _useQuery2.error,
      intermediaryListData = _useQuery2.data;

  var myIntermediaries = intermediaryListData ? intermediaryListData.myIntermediaries : null;

  var getIntermediaryName = function getIntermediaryName(code) {
    var _myIntermediaries$fin;

    return myIntermediaries ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin = myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === code;
    })) === null || _myIntermediaries$fin === void 0 ? void 0 : _myIntermediaries$fin.intermediaryName : code;
  };

  var getBusinessLocation = function getBusinessLocation(intermediarycode, locationCode) {
    var _myIntermediaries$fin2, _myIntermediaries$fin3;

    return myIntermediaries && intermediarycode && locationCode ? myIntermediaries !== null && myIntermediaries !== void 0 && myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === intermediarycode;
    }) ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin2 = myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === intermediarycode;
    })) === null || _myIntermediaries$fin2 === void 0 ? void 0 : (_myIntermediaries$fin3 = _myIntermediaries$fin2.businessLocations.find(function (location) {
      return (location === null || location === void 0 ? void 0 : location.code) === locationCode;
    })) === null || _myIntermediaries$fin3 === void 0 ? void 0 : _myIntermediaries$fin3.name : locationCode : '';
  };

  var selectedCount = function selectedCount(pack) {
    var count = 0;
    pack.addOnCovers.forEach(function (add) {
      if (add.selected) {
        count = count + 1;
      }
    });
    return count;
  };

  var addOnCoverDisable = function addOnCoverDisable(add, planName, type) {
    var _plans$plans2, _plans$plans3;

    var premium = plans !== null && plans !== void 0 && (_plans$plans2 = plans.plans) !== null && _plans$plans2 !== void 0 && _plans$plans2.find(function (plan) {
      return plan.name === planName;
    }) ? plans === null || plans === void 0 ? void 0 : (_plans$plans3 = plans.plans) === null || _plans$plans3 === void 0 ? void 0 : _plans$plans3.find(function (plan) {
      return plan.name === planName;
    }).premium : null;

    if (type === "disable") {
      var _sessionStorage3, _sessionStorage3$getI, _sessionStorage3$getI2;

      if ((planName === 'Total' || planName === 'Edge') && (add === null || add === void 0 ? void 0 : add.name) === 'Personal Accident Cover' && productCode === '2883' && ((_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : (_sessionStorage3$getI = _sessionStorage3.getItem('roleName')) === null || _sessionStorage3$getI === void 0 ? void 0 : (_sessionStorage3$getI2 = _sessionStorage3$getI.toString()) === null || _sessionStorage3$getI2 === void 0 ? void 0 : _sessionStorage3$getI2.toLowerCase()) === 'non bancassurance - apc' // && !skipPACover
      ) {
          var _quote$cover3;

          if (premium === null //&& parseInt(quote?.cover?.sum_insured) <= 1000000 
          ) {
              return true;
            } else if ((premium === null || premium === void 0 ? void 0 : premium.totalPremium) <= 15000 && parseInt(quote === null || quote === void 0 ? void 0 : (_quote$cover3 = quote.cover) === null || _quote$cover3 === void 0 ? void 0 : _quote$cover3.sum_insured) <= 1000000 //&& !skipPACover
          ) {
              return true;
            } else {
            return false;
          }
        } else {
        return false;
      }
    }
  };

  var _useQuery3 = useQuery(QUERY_STATE);
      _useQuery3.loading;
      _useQuery3.error;
      var state = _useQuery3.data;

  var healthQuote = state.healthQuote;
      state.healthPlans;
  var planCoverData = (_ref2 = [(quote === null || quote === void 0 ? void 0 : quote.captureMode) === 'create' ? {
    title: '',
    repeat: 1,
    grid_data: [{
      text: /*#__PURE__*/React.createElement(Checkbox, {
        label: /*#__PURE__*/React.createElement(Text, {
          type: 'normal',
          className: 'h-full flex flex-col items-center mt-1'
        }, "Select this plan for quote"),
        labelClassName: 'text-base mb-2',
        checked: plan === null || plan === void 0 ? void 0 : plan.isSelected,
        disabled: premiumError !== null && premiumError !== undefined || (quote === null || quote === void 0 ? void 0 : quote.quotationNo) !== '',
        onChange: function onChange(val) {
          return updateSelectedPlans(plan === null || plan === void 0 ? void 0 : plan.name, val);
        }
      }),
      className: '-mb-2'
    }]
  } : null, {
    repeat: repeat,
    gapX: 4,
    gapY: 4,
    grid_data: (_ref3 = [{
      label: /*#__PURE__*/React.createElement(Text, {
        type: "title",
        severity: "info"
      }, "Plan Name"),
      text: plan === null || plan === void 0 ? void 0 : plan.name,
      severity: 'info',
      type: 'subtitle'
    }, {
      label: /*#__PURE__*/React.createElement(Text, {
        type: "title",
        severity: "info"
      }, "Sum Insured"),
      text: Parse(quote.cover.sum_insured),
      severity: 'info',
      type: 'normal'
    }, {
      label: /*#__PURE__*/React.createElement(Text, {
        type: "title",
        severity: "info"
      }, // repeat === repeatForMobile
      //   ? 'Annual Premium'
      //   : 'Annual Premium (inclusive of all taxes)'
      repeat === repeatForDesktop ? 'Annual Premium (inclusive of all taxes)' : 'Annual Premium'),
      text: /*#__PURE__*/React.createElement(ShowPremium, {
        planName: plan === null || plan === void 0 ? void 0 : plan.name,
        loading: premiumLoading,
        error: premiumError,
        setShowViewBreakup: setShowViewBreakup,
        setSelectedPlanTypeView: setSelectedPlanTypeView
      }),
      className: 'md:-ml-1'
    }, {
      text: /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "md:w-48 md:pr-4 max-h-10",
        size: repeat === repeatForDesktop ? "medium" : "small",
        iconPost: isProceeding ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faSpinner,
          spin: true,
          className: "mr-4"
        }) : repeat === repeatForDesktop ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faChevronRight,
          className: "mr-4"
        }) : null,
        onClick: /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
            var _quote$intermediaryDe4, _quote$customer, _quote$intermediaryDe5, associateEntityLookupQuery, _yield$associateEntit, associateEntityLookupData, associatedEntityLookup, _quote$intermediaryDe6, _quote$intermediaryDe7, _quote$intermediaryDe8, _quote$intermediaryDe9, _quote$intermediaryDe10, _quote$intermediaryDe11, _quote$intermediaryDe12, _quote$intermediaryDe13, _quote$intermediaryDe14, _quote$intermediaryDe15, _quote$customer2, _quote$intermediaryDe16, _quote$intermediaryDe17, _quote$intermediaryDe18, _quote$intermediaryDe19, _quote$intermediaryDe20, _quote$intermediaryDe21, _quote$intermediaryDe22, _quote$intermediaryDe23, _quote$intermediaryDe24, _quote$intermediaryDe25, _intermediaryDetails;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!((selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode) !== '' || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe4 = quote.intermediaryDetails) === null || _quote$intermediaryDe4 === void 0 ? void 0 : _quote$intermediaryDe4.fieldUserCode) !== '')) {
                      _context.next = 10;
                      break;
                    }

                    associateEntityLookupQuery = fetchQuery({
                      query: LOOKUP_FIELDUSER,
                      variables: {
                        filter: {
                          fieldUserID: "".concat((selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe5 = quote.intermediaryDetails) === null || _quote$intermediaryDe5 === void 0 ? void 0 : _quote$intermediaryDe5.fieldUserCode))
                        }
                      }
                    });
                    setProceeding(true);
                    _context.next = 6;
                    return associateEntityLookupQuery;

                  case 6:
                    _yield$associateEntit = _context.sent;
                    associateEntityLookupData = _yield$associateEntit.data;
                    setProceeding(false);
                    associatedEntityLookup = associateEntityLookupData.associatedEntityLookup;

                  case 10:
                    if (quote !== null && quote !== void 0 && (_quote$customer = quote.customer) !== null && _quote$customer !== void 0 && _quote$customer.id) {
                      updateBuyHealthPolicy({
                        insuredDetails: quote.members.filter(function (m) {
                          return m.selected;
                        }).map(function (m) {
                          return {
                            relationship: m.relationship
                          };
                        }),
                        nomineeDetails: quote.members.filter(function (m) {
                          return m.selected;
                        }).map(function (m) {
                          return {
                            relationship: m.relationship
                          };
                        }),
                        proposerDetailsMeta: quote === null || quote === void 0 ? void 0 : quote.customerMeta,
                        proposerDetails: quote === null || quote === void 0 ? void 0 : quote.customer,
                        customerFetchRequiredOnLoad: true,
                        isQuoteSaved: true,
                        quoteData: quote,
                        planData: plans,
                        quotationType: quote.quotationType,
                        quoteNumber: quote.quotationNo,
                        quoteStatus: quote.quotationStatus,
                        existingPolicyNumber: quote.existingPolicyNumber,
                        isExistingEmployee: quote.isExistingEmployee,
                        intermediaryDetails: {
                          code: (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe6 = quote.intermediaryDetails) === null || _quote$intermediaryDe6 === void 0 ? void 0 : _quote$intermediaryDe6.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode),
                          intermediaryName: getIntermediaryName((quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe7 = quote.intermediaryDetails) === null || _quote$intermediaryDe7 === void 0 ? void 0 : _quote$intermediaryDe7.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode)) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryName),
                          location: (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe8 = quote.intermediaryDetails) === null || _quote$intermediaryDe8 === void 0 ? void 0 : _quote$intermediaryDe8.location),
                          branchOfficeName: getBusinessLocation((quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe9 = quote.intermediaryDetails) === null || _quote$intermediaryDe9 === void 0 ? void 0 : _quote$intermediaryDe9.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode), (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe10 = quote.intermediaryDetails) === null || _quote$intermediaryDe10 === void 0 ? void 0 : _quote$intermediaryDe10.location) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode)) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeName),
                          fieldUserCode: (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe11 = quote.intermediaryDetails) === null || _quote$intermediaryDe11 === void 0 ? void 0 : _quote$intermediaryDe11.fieldUserCode),
                          fieldUserName: selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserName || quote !== null && quote !== void 0 && (_quote$intermediaryDe12 = quote.intermediaryDetails) !== null && _quote$intermediaryDe12 !== void 0 && _quote$intermediaryDe12.fieldUserName ? (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserName) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe13 = quote.intermediaryDetails) === null || _quote$intermediaryDe13 === void 0 ? void 0 : _quote$intermediaryDe13.fieldUserName) : selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserCode || quote !== null && quote !== void 0 && (_quote$intermediaryDe14 = quote.intermediaryDetails) !== null && _quote$intermediaryDe14 !== void 0 && _quote$intermediaryDe14.fieldUserCode ? associatedEntityLookup === null || associatedEntityLookup === void 0 ? void 0 : associatedEntityLookup.fieldUserName : (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe15 = quote.intermediaryDetails) === null || _quote$intermediaryDe15 === void 0 ? void 0 : _quote$intermediaryDe15.fieldUserCode) === '' ? '' : ''
                        }
                      });
                    } else {
                      updateBuyHealthPolicy({
                        insuredDetails: quote.members.filter(function (m) {
                          return m.selected;
                        }).map(function (m) {
                          return {
                            relationship: m.relationship
                          };
                        }),
                        nomineeDetails: quote.members.filter(function (m) {
                          return m.selected;
                        }).map(function (m) {
                          return {
                            relationship: m.relationship
                          };
                        }),
                        proposerDetailsMeta: quote === null || quote === void 0 ? void 0 : quote.customerMeta,
                        proposerDetails: quote === null || quote === void 0 ? void 0 : quote.customer,
                        customerFetchRequiredOnLoad: true,
                        isQuoteSaved: quote !== null && quote !== void 0 && (_quote$customer2 = quote.customer) !== null && _quote$customer2 !== void 0 && _quote$customer2.customerType ? true : false,
                        quoteData: quote,
                        planData: plans,
                        quotationType: quote.quotationType,
                        quoteNumber: quote.quotationNo,
                        quoteStatus: quote.quotationStatus,
                        existingPolicyNumber: quote.existingPolicyNumber,
                        isExistingEmployee: quote.isExistingEmployee,
                        intermediaryDetails: (_intermediaryDetails = {
                          code: (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe16 = quote.intermediaryDetails) === null || _quote$intermediaryDe16 === void 0 ? void 0 : _quote$intermediaryDe16.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode),
                          intermediaryName: getIntermediaryName((quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe17 = quote.intermediaryDetails) === null || _quote$intermediaryDe17 === void 0 ? void 0 : _quote$intermediaryDe17.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode)) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryName),
                          location: (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe18 = quote.intermediaryDetails) === null || _quote$intermediaryDe18 === void 0 ? void 0 : _quote$intermediaryDe18.location),
                          branchOfficeName: getBusinessLocation((quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe19 = quote.intermediaryDetails) === null || _quote$intermediaryDe19 === void 0 ? void 0 : _quote$intermediaryDe19.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode), (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe20 = quote.intermediaryDetails) === null || _quote$intermediaryDe20 === void 0 ? void 0 : _quote$intermediaryDe20.location) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode)) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeName),
                          fieldUserCode: (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe21 = quote.intermediaryDetails) === null || _quote$intermediaryDe21 === void 0 ? void 0 : _quote$intermediaryDe21.fieldUserCode)
                        }, _defineProperty(_intermediaryDetails, "fieldUserCode", (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe22 = quote.intermediaryDetails) === null || _quote$intermediaryDe22 === void 0 ? void 0 : _quote$intermediaryDe22.fieldUserCode)), _defineProperty(_intermediaryDetails, "fieldUserName", selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserName || quote !== null && quote !== void 0 && (_quote$intermediaryDe23 = quote.intermediaryDetails) !== null && _quote$intermediaryDe23 !== void 0 && _quote$intermediaryDe23.fieldUserName ? (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserName) || (quote === null || quote === void 0 ? void 0 : (_quote$intermediaryDe24 = quote.intermediaryDetails) === null || _quote$intermediaryDe24 === void 0 ? void 0 : _quote$intermediaryDe24.fieldUserName) : selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserCode || quote !== null && quote !== void 0 && (_quote$intermediaryDe25 = quote.intermediaryDetails) !== null && _quote$intermediaryDe25 !== void 0 && _quote$intermediaryDe25.fieldUserCode ? associatedEntityLookup === null || associatedEntityLookup === void 0 ? void 0 : associatedEntityLookup.fieldUserName : ''), _intermediaryDetails)
                      });
                    }

                    history.push("/quote/health/buy/".concat(lobCode, "/").concat(productName, "/").concat(productCode, "/").concat(plan === null || plan === void 0 ? void 0 : plan.code, "/").concat(plan === null || plan === void 0 ? void 0 : plan.name));
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](0);
                    setProceeding(false);
                    setAlerts([].concat(_toConsumableArray(alerts), [{
                      header: "Intermediary details fetch failed",
                      id: Date.now(),
                      content: /*#__PURE__*/React.createElement("div", {
                        className: "flex flex-row flex-wrap space-y-2 w-full h-full text-base"
                      }, /*#__PURE__*/React.createElement("span", null, getGraphQLErrorMessage(_context.t0))),
                      type: 'error',
                      timeout: null,
                      disableClose: false
                    }]));

                  case 18:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 14]]);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        disabled: (quoteNumber && !(quote !== null && quote !== void 0 && quote.proposalNumber) ? false : quote.proposalNumber ? true : premiumLoading || resultPremiumError ? true : !(plan !== null && plan !== void 0 && plan.isSelected) ? true : false) || (quote === null || quote === void 0 ? void 0 : quote.isQuoteSaving) || isProceeding || !isDocAvailable || disableProceed || flags // || saveProceedDisplay

      }, "Proceed to Buy"))
    }]) === null || _ref3 === void 0 ? void 0 : _ref3.filter(function (d) {
      return d;
    })
  }, {
    title: /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row md:items-center -mb-3"
    }, /*#__PURE__*/React.createElement("span", {
      className: 'h-full flex flex-row space-x-2 items-center'
    }, /*#__PURE__*/React.createElement("span", {
      className: 'bg-primary rounded-full w-8 h-8 text-white flex items-center text-center justify-center'
    }, plan === null || plan === void 0 ? void 0 : (_plan$covers = plan.covers) === null || _plan$covers === void 0 ? void 0 : _plan$covers.length), /*#__PURE__*/React.createElement(Text, {
      severity: 'dark'
    }, "base covers included in this plan")), /*#__PURE__*/React.createElement("span", {
      className: "h-full"
    }, /*#__PURE__*/React.createElement(Text, {
      severity: "action",
      type: "label",
      className: "-ml-2 md:ml-1 quanta_link cursor-pointer h-1",
      onClick: function onClick(e) {
        setCurrentPlan(plan);
        setShowViewBaseCovers(true);
      }
    }, "View Base Covers"))),
    titleType: 'title',
    titleSeverity: 'info',
    grid_data: []
  }, {
    title: (plan === null || plan === void 0 ? void 0 : plan.packs.length) > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "text-secondary text-base cursor-pointer",
      onClick: function onClick(e) {
        return expanded.includes(id) ? setExpanded(expanded.filter(function (exp) {
          return exp !== id;
        })) : setExpanded([].concat(_toConsumableArray(expanded), [id]));
      }
    }, "Add-on Covers", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: expanded.includes(id) ? faChevronCircleUp : faChevronCircleDown,
      className: "text-secondary ml-2 cursor-pointer"
    })) : null,
    titleType: 'normal',
    repeat: 1,
    grid_data: expanded.includes(id) ? plan === null || plan === void 0 ? void 0 : plan.packs.map(function (pack, idx) {
      return {
        label: /*#__PURE__*/React.createElement(Text, null, pack.name, ' ', selectedCount(pack) > 0 ? "(".concat(selectedCount(pack), " selected)") : null),
        text: /*#__PURE__*/React.createElement(Grid, {
          className: "mt-2 font-normal break-normal",
          repeat: repeat,
          gap: 1
        }, pack.addOnCovers.map(function (add, idx) {
          return /*#__PURE__*/React.createElement(Toggle, {
            key: idx,
            label: add.name,
            labelType: "label",
            checked: add.selected,
            disabled: quote.quotationNo !== '' || addOnCoverDisable(add, plan === null || plan === void 0 ? void 0 : plan.name, "disable"),
            onChange: function onChange(val) {
              if ((add === null || add === void 0 ? void 0 : add.name) === 'Maternity Benefit') {
                toggleAddOn('New Born Baby Cover', pack.name, plan === null || plan === void 0 ? void 0 : plan.name);
                toggleAddOn('Vaccination Expenses', pack.name, plan === null || plan === void 0 ? void 0 : plan.name);
              }

              toggleAddOn(add.name, pack.name, plan === null || plan === void 0 ? void 0 : plan.name);

              if ((add === null || add === void 0 ? void 0 : add.name) === 'Maternity Benefit' && val === true) {
                var filteredValue = quote.members.filter(function (k) {
                  return k.selected && k.gender == 'FEMALE' && k.age >= 18;
                });
                var data = updatematernitycovermember(quote.members, filteredValue);
                setMBSelected(true);
                updateHealthQuote({
                  maternitySelectedCover: true,
                  members: data
                });
              }

              if ((add === null || add === void 0 ? void 0 : add.name) === 'Maternity Benefit' && val === false) {
                setMBSelected(false);
                updateHealthQuote({
                  maternitySelectedCover: false
                });
                setflag(false);
              }

              if ((add === null || add === void 0 ? void 0 : add.name) === 'Personal Accident Cover' && ((plan === null || plan === void 0 ? void 0 : plan.name) === 'Total' || (plan === null || plan === void 0 ? void 0 : plan.name) === 'Edge')) {
                setPASelected(!add.selected);
              }
            }
          });
        }))
      };
    }) : []
  }, plans === null || plans === void 0 ? void 0 : plans.plans.forEach(function (pack) {
    pack.packs.forEach(function (plan) {
      plan.addOnCovers.find(function (k) {
        return k.name == 'Maternity Benefit' && k.selected == true ? maternitySelected.push(pack) : '';
      });
    });
  }), isMBSelected && maternitySelected.find(function (e) {
    return e.name == plan.name;
  }) && (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$maternit3 = healthQuote.maternityMembers) === null || _healthQuote$maternit3 === void 0 ? void 0 : _healthQuote$maternit3.length) > 0 && {
    title: 'Select Maternity Insured Name',
    repeat: 1,
    grid_data: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$maternit4 = healthQuote.maternityMembers) === null || _healthQuote$maternit4 === void 0 ? void 0 : (_healthQuote$maternit5 = _healthQuote$maternit4.filter(function (mem) {
      return mem.planName == plan.name;
    })) === null || _healthQuote$maternit5 === void 0 ? void 0 : (_healthQuote$maternit6 = _healthQuote$maternit5[0]) === null || _healthQuote$maternit6 === void 0 ? void 0 : (_healthQuote$maternit7 = _healthQuote$maternit6.members) === null || _healthQuote$maternit7 === void 0 ? void 0 : _healthQuote$maternit7.map(function (k, idx) {
      return {
        name: "maternityMembers[".concat(k.planName, "].members[").concat(idx, "].maternitySelected"),
        label: k.gender === 'FEMALE' && k.age >= 18 ? /*#__PURE__*/React.createElement(Checkbox, {
          label: k.relationship + '  ' + k.gender.charAt(0).toUpperCase() + k.gender.toLowerCase().slice(1) + '  ' + k.dob,
          labelClassName: "text-base",
          checked: k.maternitySelected,
          disabled: (quote === null || quote === void 0 ? void 0 : quote.quotationNo) !== '' || k.disabled,
          onChange: function onChange(val) {
            setInitLoad(true);
            updatematernitycover(val, healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.maternityMembers, k, plan.name);
            var maternityData = updatematernitycovermem(val, quote.members, k);
            updatefunction(maternityData);
            updateHealthQuote({
              members: maternityData
            });
          }
        }) : ''
      };
    })
  }]) === null || _ref2 === void 0 ? void 0 : _ref2.filter(function (d) {
    return d;
  });
  return /*#__PURE__*/React.createElement(Paper, null, intermediaryListLoading && /*#__PURE__*/React.createElement(Loading, null), intermediaryListError && /*#__PURE__*/React.createElement(Error$1, null), !intermediaryListLoading && !intermediaryListError && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Grid, {
    repeat: 1,
    gapY: 2
  }, planCoverData.map(function (planCover, idx) {
    return /*#__PURE__*/React.createElement(DataGrid, {
      key: idx,
      repeat: planCover === null || planCover === void 0 ? void 0 : planCover.repeat,
      gapX: planCover === null || planCover === void 0 ? void 0 : planCover.gapX,
      gapY: planCover === null || planCover === void 0 ? void 0 : planCover.gapY,
      title: planCover === null || planCover === void 0 ? void 0 : planCover.title,
      titleType: planCover === null || planCover === void 0 ? void 0 : planCover.titleType,
      titleSeverity: planCover === null || planCover === void 0 ? void 0 : planCover.titleSeverity,
      textType: planCover === null || planCover === void 0 ? void 0 : planCover.textType,
      data: planCover.grid_data
    });
  }))));
}

function ShowPlans(_ref5) {
  var planLoading = _ref5.planLoading,
      planError = _ref5.planError,
      genderList = _ref5.genderList,
      productName = _ref5.productName,
      productCode = _ref5.productCode,
      lobCode = _ref5.lobCode,
      quoteNumber = _ref5.quoteNumber,
      selectedIntermediary = _ref5.selectedIntermediary,
      productDetails = _ref5.productDetails,
      saveProceedDisplay = _ref5.saveProceedDisplay;
  var repeatForMobile = 1;
  var repeatForDesktop = 2;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useState19 = useState(undefined),
      _useState20 = _slicedToArray(_useState19, 2),
      selectedPlanTypeView = _useState20[0],
      setSelectedPlanTypeView = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showViewBreakup = _useState22[0],
      setShowViewBreakup = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showViewBaseCovers = _useState24[0],
      setShowViewBaseCovers = _useState24[1];

  var _useState25 = useState(),
      _useState26 = _slicedToArray(_useState25, 2),
      currentPlan = _useState26[0],
      setCurrentPlan = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      docAvailable = _useState28[0],
      setDocAvailable = _useState28[1];

  var _useState29 = useState([]),
      _useState30 = _slicedToArray(_useState29, 2),
      alerts = _useState30[0],
      setAlerts = _useState30[1];

  var _useQuery4 = useQuery(QUERY_STATE, {
    onCompleted: function onCompleted(data) {
      var healthQuote = data.healthQuote;

      if (healthQuote.quotationType.toLowerCase() === 'roll over' && productCode === '2883') {
        setDocAvailable(false);
        setAlerts([{
          header: "Roll Over",
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full text-base"
          }, /*#__PURE__*/React.createElement("span", null, "Pls confirm whether all below documents are available for upload as it is Rollover Business:-", /*#__PURE__*/React.createElement("br", null), "a. Previous Policy Document", " ", /*#__PURE__*/React.createElement("br", null), "b. Renewal Notice", " ", /*#__PURE__*/React.createElement("br", null), "c. Portability Form", " ", /*#__PURE__*/React.createElement("br", null), "d. Approval Mail", " ", /*#__PURE__*/React.createElement("br", null))),
          type: 'warning',
          timeout: 50000,
          disableClose: false
        }]);
      } else {
        setDocAvailable(true);
      }
    }
  }),
      queryStateData = _useQuery4.data;

  var healthQuote = queryStateData.healthQuote,
      healthPlans = queryStateData.healthPlans;
  if (planLoading) return /*#__PURE__*/React.createElement("div", {
    className: "min-h-screen"
  }, /*#__PURE__*/React.createElement(Loading, {
    customMessage: "Looking for suitable plans"
  }));

  if (planError) {
    var error = {
      message: "There was an issue fetching the Plan and Cover Details. Please try again after some time..."
    };
    return /*#__PURE__*/React.createElement(Error$1, {
      error: error
    });
  }

  var plans = healthPlans.plans,
      plansChanged = healthPlans.plansChanged;
      healthPlans.selectedPlans;
  return plans.length > 0 ? /*#__PURE__*/React.createElement("div", {
    id: "planSection",
    className: "mt-4 border-t border-neutral-dark"
  }, healthQuote.quotationType.toLowerCase() === 'roll over' && productCode === '2883' ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-start mt-5 mb-4"
  }, /*#__PURE__*/React.createElement(Text, {
    type: "normal",
    severity: 'dark'
  }, "Do you have following Documents- Previous Policy Document, Renewal Notice, Portability Form, Approval Mail? "), /*#__PURE__*/React.createElement(RadioGroup, {
    selected: docAvailable,
    data: [{
      label: 'Yes',
      value: true
    }, {
      label: 'No',
      value: false
    }],
    onChange: function onChange(val) {
      setDocAvailable(val);
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Grid, {
    repeat: 1,
    gapY: 4
  }, plans.map(function (plan, idx) {
    return /*#__PURE__*/React.createElement(RenderPlan, {
      key: idx,
      id: idx,
      plan: plan,
      plans: healthPlans,
      quote: healthQuote,
      plansChanged: plansChanged,
      setShowViewBreakup: setShowViewBreakup,
      alerts: alerts,
      setAlerts: setAlerts,
      setSelectedPlanTypeView: setSelectedPlanTypeView,
      quoteNumber: quoteNumber,
      productName: productName,
      lobCode: lobCode,
      productCode: productCode,
      selectedIntermediary: selectedIntermediary,
      setShowViewBaseCovers: setShowViewBaseCovers,
      setCurrentPlan: setCurrentPlan,
      isDocAvailable: docAvailable,
      productDetails: productDetails,
      saveProceedDisplay: saveProceedDisplay
    });
  })), selectedPlanTypeView ? /*#__PURE__*/React.createElement(ModalViewBreakup, {
    showViewBreakup: showViewBreakup,
    setShowViewBreakup: setShowViewBreakup,
    selectedPlanTypeView: selectedPlanTypeView,
    productName: productName,
    productCode: productCode,
    lobCode: lobCode,
    quoteNumber: quoteNumber,
    genderList: genderList,
    reactive_var_quote: healthQuote,
    reactive_var_plan: healthPlans,
    title: 'Premium Breakup for Quote'
  }) : null, currentPlan ? /*#__PURE__*/React.createElement("div", {
    className: "text-black font-normal"
  }, /*#__PURE__*/React.createElement(Modal, {
    display: showViewBaseCovers,
    size: repeat === repeatForMobile ? 'full' : 'medium',
    className: repeat === repeatForMobile ? 'h-screen flex flex-col' : '',
    title: "Base Covers for ".concat(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.name),
    onClose: function onClose(e) {
      return setShowViewBaseCovers(false);
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    repeat: repeat,
    gap: 2
  }, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.covers.map(function (cover, idx) {
    return /*#__PURE__*/React.createElement(GridItem, {
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row space-x-1 items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-success"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCheck
    })), /*#__PURE__*/React.createElement(Text, {
      type: "label"
    }, cover.name)));
  })))) : null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })) : /*#__PURE__*/React.createElement("div", null);
}

var _excluded$3 = ["packs"],
    _excluded2 = ["addOnCovers"],
    _excluded3 = ["selected"],
    _excluded4 = ["selected"];
function Plans(_ref) {
  var _healthQuote$intermed;

  var productName = _ref.productName,
      productCode = _ref.productCode,
      lobCode = _ref.lobCode,
      quoteNumber = _ref.quoteNumber,
      goToStep = _ref.goToStep,
      genderList = _ref.genderList,
      setStartStep = _ref.setStartStep,
      productDetails = _ref.productDetails,
      saveProceedDisplay = _ref.saveProceedDisplay;

  var _useQuery = useQuery(QUERY_STATE),
      queryStateData = _useQuery.data;

  var healthQuote = queryStateData.healthQuote,
      selectedIntermediary = queryStateData.selectedIntermediary,
      healthPlans = queryStateData.healthPlans;
  console.log("showplans", healthPlans);
  var variables = {
    input: {
      sumInsured: healthQuote.cover.sum_insured,
      startDate: moment().format('DD/MM/YYYY').toString(),
      productCode: productCode,
      imdCode: (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed = healthQuote.intermediaryDetails) === null || _healthQuote$intermed === void 0 ? void 0 : _healthQuote$intermed.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode),
      members: healthQuote.members.filter(function (mem) {
        return mem.selected;
      }).map(function (member) {
        return {
          relationship: member.relationship,
          gender: member.gender,
          dob: member.dob,
          age: member.age.toString(),
          maternitySelected: member.maternitySelected ? member.maternitySelected : false
        };
      })
    }
  };

  var _useQuery2 = useQuery(GET_PLAN_COVER_DETAILS, {
    variables: variables,
    skip: quoteNumber !== undefined || (healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationNo) !== '' || healthQuote === null || healthQuote === undefined || !(healthQuote !== null && healthQuote !== void 0 && healthQuote.isQuoteCopied) || (healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.isCoverPageLoading),
    onCompleted: function onCompleted(data) {
      var planAndCovers = data.planAndCovers;
      var planList = [];
      var maternityMembers = [];
      var PlanAndcoversList = planAndCovers === null || planAndCovers === void 0 ? void 0 : planAndCovers.map(function (p) {
        planList.push(p === null || p === void 0 ? void 0 : p.name);

        var packs = p.packs,
            restobj = _objectWithoutProperties(p, _excluded$3);

        var packsList = packs.map(function (e) {
          var addOnCovers = e.addOnCovers,
              restPackobj = _objectWithoutProperties(e, _excluded2);

          var AddOnList = addOnCovers === null || addOnCovers === void 0 ? void 0 : addOnCovers.map(function (f) {
            var _sessionStorage, _sessionStorage$getIt, _sessionStorage$getIt2;

            if ((f === null || f === void 0 ? void 0 : f.name) === 'Personal Accident Cover' && productCode === '2883' && ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage$getIt = _sessionStorage.getItem('roleName')) === null || _sessionStorage$getIt === void 0 ? void 0 : (_sessionStorage$getIt2 = _sessionStorage$getIt.toString()) === null || _sessionStorage$getIt2 === void 0 ? void 0 : _sessionStorage$getIt2.toLowerCase()) === 'non bancassurance - apc' && ((p === null || p === void 0 ? void 0 : p.name) === 'Edge' || (p === null || p === void 0 ? void 0 : p.name) === 'Total') // &&  parseInt(healthQuote?.cover?.sum_insured) <= 1000000
            ) // &&  parseInt(healthQuote?.cover?.sum_insured) <= 1000000
              {
                f.selected;
                    var restaddondtl = _objectWithoutProperties(f, _excluded3);

                return _objectSpread2(_objectSpread2({}, restaddondtl), {}, {
                  selected: true
                });
              } else {
              var _healthPlans$plans;

              if ((healthPlans === null || healthPlans === void 0 ? void 0 : (_healthPlans$plans = healthPlans.plans) === null || _healthPlans$plans === void 0 ? void 0 : _healthPlans$plans.length) > 0) {
                var _healthPlans$plans$fi, _packsl$packs, _packsl$packs$, _packsl$packs$$addOnC;

                var packsl = (_healthPlans$plans$fi = healthPlans.plans.filter(function (k) {
                  return k.name == p.name;
                })) === null || _healthPlans$plans$fi === void 0 ? void 0 : _healthPlans$plans$fi[0];
                var list1 = packsl === null || packsl === void 0 ? void 0 : (_packsl$packs = packsl.packs) === null || _packsl$packs === void 0 ? void 0 : (_packsl$packs$ = _packsl$packs[0]) === null || _packsl$packs$ === void 0 ? void 0 : (_packsl$packs$$addOnC = _packsl$packs$.addOnCovers) === null || _packsl$packs$$addOnC === void 0 ? void 0 : _packsl$packs$$addOnC.find(function (ki) {
                  return ki.name === f.name;
                });

                f.selected;
                    var _restaddondtl = _objectWithoutProperties(f, _excluded4);

                return _objectSpread2(_objectSpread2({}, _restaddondtl), {}, {
                  selected: list1 !== null && list1 !== void 0 && list1.selected ? true : false
                });
              } else {
                return f;
              }
            }
          });
          return _objectSpread2(_objectSpread2({}, restPackobj), {}, {
            addOnCovers: AddOnList
          });
        });
        return _objectSpread2(_objectSpread2({}, restobj), {}, {
          packs: packsList
        });
      });
      updateHealthQuotePlans(PlanAndcoversList); //data.planAndCovers);

      /**SA Rithika : CR_685 maternity member list */

      //data.planAndCovers);

      /**SA Rithika : CR_685 maternity member list */
      var filteredValue = healthQuote.members.filter(function (k) {
        return k.selected && k.gender == 'FEMALE' && k.age >= 18;
      });
      planList.forEach(function (e) {
        maternityMembers.push({
          planName: e,
          members: healthQuote.members.filter(function (mem) {
            return mem.selected && mem.gender == 'FEMALE' && mem.age >= 18;
          }).map(function (member) {
            var _member$age, _filteredValue$, _filteredValue$2, _filteredValue$3, _filteredValue$4;

            return {
              relationship: member.relationship,
              gender: member.gender,
              dob: member.dob,
              age: (_member$age = member.age) === null || _member$age === void 0 ? void 0 : _member$age.toString(),
              selected: member.selected,
              disabled: (filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue.length) == 1 && member.relationship == (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$ = filteredValue[0]) === null || _filteredValue$ === void 0 ? void 0 : _filteredValue$.relationship) ? true : false,
              maternitySelected: ((filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$2 = filteredValue[0]) === null || _filteredValue$2 === void 0 ? void 0 : _filteredValue$2.maternitySelected) == false || (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$3 = filteredValue[0]) === null || _filteredValue$3 === void 0 ? void 0 : _filteredValue$3.maternitySelected) == undefined) && member.relationship == (filteredValue === null || filteredValue === void 0 ? void 0 : (_filteredValue$4 = filteredValue[0]) === null || _filteredValue$4 === void 0 ? void 0 : _filteredValue$4.relationship) ? true : member.maternitySelected
            };
          })
        });
      });
      updateHealthQuote({
        maternityMembers: maternityMembers,
        isCoverPageLoading: true
      });
      /**EA Rithika : CR_685*/

      /**EA Rithika : CR_685*/
      resetPlansChanged();
    }
  }),
      planLoading = _useQuery2.loading,
      planError = _useQuery2.error;

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuoteData, {
    goToStep: goToStep,
    genderList: genderList,
    productCode: productCode,
    productName: productName,
    lobCode: lobCode,
    quoteNumber: quoteNumber,
    setStartStep: setStartStep
  }), /*#__PURE__*/React.createElement(ShowPlans, {
    planLoading: planLoading,
    planError: planError,
    genderList: genderList,
    productName: productName,
    productCode: productCode,
    lobCode: lobCode,
    quoteNumber: quoteNumber,
    selectedIntermediary: selectedIntermediary,
    productDetails: productDetails,
    saveProceedDisplay: saveProceedDisplay
  }));
}

function ModalAddOthers(_ref) {
  var setShowModalAddOthers = _ref.setShowModalAddOthers,
      showModalAddOthers = _ref.showModalAddOthers,
      applicableMemberTypes = _ref.applicableMemberTypes,
      genderList = _ref.genderList,
      memberList = _ref.memberList,
      setMemberList = _ref.setMemberList,
      values = _ref.values,
      setFieldValue = _ref.setFieldValue;
      _ref.productCode;
      _ref.productName;
      _ref.lobCode;
      _ref.quoteNumber;

  var _useState = useState({
    relationship: '',
    gender: '',
    selectGender: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      otherMember = _useState2[0],
      setOtherMember = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      modalDisplay = _useState4[0],
      setModalDisplay = _useState4[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showModalAddOthers);
    }, 150);
    return function () {
      return clearTimeout(timer);
    };
  }, [showModalAddOthers, setModalDisplay]);

  var isAllowed = function isAllowed(memberType) {
    var isPresent = values.members.filter(function (mem) {
      return memberType.maxAllowed > 1 ? mem.relationship.startsWith(memberType.label) : mem.relationship === memberType.label;
    });
    return isPresent.length < memberType.maxAllowed && memberType.label !== 'Self' && memberType.label !== 'Spouse' ? true : false;
  };

  var getGender = function getGender(label) {
    var _applicableMemberType;

    var gender = (_applicableMemberType = applicableMemberTypes.find(function (addMem) {
      return addMem.label === label;
    })) === null || _applicableMemberType === void 0 ? void 0 : _applicableMemberType.gender;
    return genderList.find(function (g) {
      var _g$code, _g$value;

      return ((_g$code = g.code) === null || _g$code === void 0 ? void 0 : _g$code.toLowerCase()) === (gender === null || gender === void 0 ? void 0 : gender.toLowerCase()) || ((_g$value = g.value) === null || _g$value === void 0 ? void 0 : _g$value.toLowerCase()) === (gender === null || gender === void 0 ? void 0 : gender.toLowerCase());
    }) ? gender : '';
  };

  var getSelectGender = function getSelectGender(label) {
    return applicableMemberTypes.find(function (addMem) {
      return addMem.label === label;
    }).selectGender;
  };

  var findNextLabel = function findNextLabel(label) {
    var maxxNumber = 0;

    for (var i = 0; i < memberList.length; i++) {
      if (memberList[i].label.startsWith(label) && memberList[i].label.split(label)[1] !== '') {
        maxxNumber = Math.max(maxxNumber, parseInt(memberList[i].label.split(label)[1]));
      }
    }

    return maxxNumber + 1;
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "small",
    title: "Add Other Members",
    severity: "action",
    onClose: function onClose() {
      setShowModalAddOthers(false);
    }
  }, /*#__PURE__*/React.createElement(Label, {
    className: "mb-2",
    text: "Relationship"
  }), /*#__PURE__*/React.createElement(Select, {
    data: applicableMemberTypes.filter(function (applicable) {
      return isAllowed(applicable);
    }).map(function (mem) {
      return {
        label: mem.label,
        value: mem.label
      };
    }),
    value: otherMember.relationship,
    onChange: function onChange(e) {
      setOtherMember(_objectSpread2(_objectSpread2({}, otherMember), {}, {
        relationship: e.target.value,
        gender: getGender(e.target.value),
        selectGender: getSelectGender(e.target.value)
      }));
    },
    size: "full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 flex flex-row justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    type: "button",
    disabled: otherMember.relationship === '',
    onClick: function onClick() {
      var _otherMember$gender;

      var nextMemberIndex = values.members.length;
      var selectedRelationship = "".concat(applicableMemberTypes.find(function (applicable) {
        return applicable.label === otherMember.relationship;
      }).maxAllowed > 1 ? otherMember.relationship + ' ' + findNextLabel(otherMember.relationship) : otherMember.relationship);
      setFieldValue("members[".concat(nextMemberIndex, "].selected"), true);
      setFieldValue("members[".concat(nextMemberIndex, "].relationship"), selectedRelationship);
      setFieldValue("members[".concat(nextMemberIndex, "].gender"), (_otherMember$gender = otherMember.gender) === null || _otherMember$gender === void 0 ? void 0 : _otherMember$gender.toUpperCase());
      setMemberList([].concat(_toConsumableArray(memberList), [{
        gender: otherMember.gender,
        selectGender: otherMember.selectGender,
        label: selectedRelationship
      }]));
      setOtherMember({
        relationship: '',
        gender: '',
        select_gender: false
      });
      setShowModalAddOthers(false);
      document.body.classList.remove('overflow-y-hidden');
    }
  }, "Add")));
}

var _excluded$2 = ["setProceedToPlanPage", "setAlerts", "alerts", "productDetails", "genderList", "quoteNumber", "productCode", "productName", "lobCode", "setStartStep", "setDisableProcced"];
function Members(_ref) {
  var _businessTypeList$, _healthQuote$location, _healthQuote$location2, _healthQuote$location3, _healthQuote$location4, _healthQuote$location5, _healthQuote$location6, _applicableZones$, _healthQuote$cover, _healthQuote$cover2, _healthQuote$cover3, _healthQuote$cover4, _defaultSumInsured$fi5, _defaultSumInsured$fi6, _healthQuote$cover5, _healthQuote$cover6, _applicableTenures$;

  var setProceedToPlanPage = _ref.setProceedToPlanPage,
      setAlerts = _ref.setAlerts;
      _ref.alerts;
      var productDetails = _ref.productDetails,
      genderList = _ref.genderList,
      quoteNumber = _ref.quoteNumber,
      productCode = _ref.productCode,
      productName = _ref.productName,
      lobCode = _ref.lobCode,
      setStartStep = _ref.setStartStep;
      _ref.setDisableProcced;
      var props = _objectWithoutProperties(_ref, _excluded$2);

  var fetchQuery = useFetchQuery();
  var repeatForMobile = 1;
  var repeatForDesktop = 4;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loadingPinCode = _useState2[0],
      setLoadingPinCode = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showModalAddOthers = _useState4[0],
      setShowModalAddOthers = _useState4[1];

  var initialMemberList = [{
    label: 'Self',
    gender: null,
    selectGender: true,
    maxAllowed: 1,
    selected: false
  }, {
    label: 'Spouse',
    gender: null,
    selectGender: true,
    maxAllowed: 1,
    selected: false
  }, {
    label: 'Father',
    gender: 'MALE',
    selectGender: false,
    maxAllowed: 1,
    selected: false
  }, {
    label: 'Mother',
    gender: 'FEMALE',
    selectGender: false,
    maxAllowed: 1,
    selected: false
  }];

  var _useState5 = useState(initialMemberList),
      _useState6 = _slicedToArray(_useState5, 2),
      memberList = _useState6[0],
      setMemberList = _useState6[1];

  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });
  var screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop'
  });

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useQuery2 = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first'
  }),
      loadingBusinessType = _useQuery2.loading,
      errorBusinessType = _useQuery2.error,
      businessTypeData = _useQuery2.data;

  var _useQuery3 = useQuery(COVER_TYPE_LIMIT, {
    fetchPolicy: 'cache-first'
  }),
      loadingCoverType = _useQuery3.loading,
      errorCoverType = _useQuery3.error,
      coverTypeData = _useQuery3.data;
  /**SA CR P2_613: enable cross sell discount for ROle Limit*/


  var _useQuery4 = useQuery(CROSS_SELL_ROLE_LIMIT, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: productCode
    }
  });
      _useQuery4.loading;
      _useQuery4.error;
      var HideFieldListData = _useQuery4.data;
  /**EA CR P2_613: enable cross sell discount for ROle Limit */


  var applicableMemberTypes = productDetails.applicableMemberTypes,
      applicableZones = productDetails.applicableZones,
      applicableCoverTypes = productDetails.applicableCoverTypes,
      applicableSumInsureds = productDetails.applicableSumInsureds,
      applicableTenures = productDetails.applicableTenures,
      defaultSumInsured = productDetails.defaultSumInsured;
  useEffect(function () {
    if (data) {
      var _healthQuote = data === null || data === void 0 ? void 0 : data.healthQuote;

      var membersListCopy = _toConsumableArray(memberList);

      if (_healthQuote !== null && _healthQuote !== void 0 && _healthQuote.quotationNo) {
        membersListCopy = [];

        _healthQuote.members.forEach(function (mem) {
          membersListCopy.push({
            label: mem.relationship,
            gender: genderList.find(function (g) {
              return g.code.toLowerCase() === mem.gender.toLowerCase() || g.value.toLowerCase() === mem.gender.toLowerCase();
            }) ? mem.gender : '',
            selectGender: false
          });
        });
      } else {
        _healthQuote.members.forEach(function (mem) {
          if (mem.relationship !== 'Self' && mem.relationship !== 'Spouse' && mem.relationship !== 'Father' && mem.relationship !== 'Mother') {
            var _membersListCopy;

            if ((_membersListCopy = membersListCopy) !== null && _membersListCopy !== void 0 && _membersListCopy.find(function (memCopy) {
              var _memCopy$label, _memCopy$label$toStri, _mem$relationship, _mem$relationship$toS;

              return (memCopy === null || memCopy === void 0 ? void 0 : (_memCopy$label = memCopy.label) === null || _memCopy$label === void 0 ? void 0 : (_memCopy$label$toStri = _memCopy$label.toString()) === null || _memCopy$label$toStri === void 0 ? void 0 : _memCopy$label$toStri.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$relationship = mem.relationship) === null || _mem$relationship === void 0 ? void 0 : (_mem$relationship$toS = _mem$relationship.toString()) === null || _mem$relationship$toS === void 0 ? void 0 : _mem$relationship$toS.toLowerCase());
            })) {
              var _membersListCopy2, _membersListCopy3, _membersListCopy4;

              var memCopyIndex = (_membersListCopy2 = membersListCopy) === null || _membersListCopy2 === void 0 ? void 0 : _membersListCopy2.findIndex(function (memCopy) {
                var _memCopy$label2, _memCopy$label2$toStr, _mem$relationship2, _mem$relationship2$to;

                return (memCopy === null || memCopy === void 0 ? void 0 : (_memCopy$label2 = memCopy.label) === null || _memCopy$label2 === void 0 ? void 0 : (_memCopy$label2$toStr = _memCopy$label2.toString()) === null || _memCopy$label2$toStr === void 0 ? void 0 : _memCopy$label2$toStr.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$relationship2 = mem.relationship) === null || _mem$relationship2 === void 0 ? void 0 : (_mem$relationship2$to = _mem$relationship2.toString()) === null || _mem$relationship2$to === void 0 ? void 0 : _mem$relationship2$to.toLowerCase());
              });
              membersListCopy = [].concat(_toConsumableArray((_membersListCopy3 = membersListCopy) === null || _membersListCopy3 === void 0 ? void 0 : _membersListCopy3.slice(0, memCopyIndex)), [_objectSpread2({}, membersListCopy[memCopyIndex])], _toConsumableArray((_membersListCopy4 = membersListCopy) === null || _membersListCopy4 === void 0 ? void 0 : _membersListCopy4.slice(memCopyIndex + 1)));
            } else {
              var _applicableMemberType;

              membersListCopy.push({
                label: mem.relationship,
                gender: genderList.find(function (g) {
                  return g.code.toLowerCase() === mem.gender.toLowerCase() || g.value.toLowerCase() === mem.gender.toLowerCase();
                }) ? mem.gender : '',
                selectGender: applicableMemberTypes === null || applicableMemberTypes === void 0 ? void 0 : (_applicableMemberType = applicableMemberTypes.find(function (addMem) {
                  var _mem$relationship3;

                  return mem === null || mem === void 0 ? void 0 : (_mem$relationship3 = mem.relationship) === null || _mem$relationship3 === void 0 ? void 0 : _mem$relationship3.startsWith(addMem === null || addMem === void 0 ? void 0 : addMem.label);
                })) === null || _applicableMemberType === void 0 ? void 0 : _applicableMemberType.selectGender
              });
            }
          }
        });
      }

      setMemberList(membersListCopy);
    }
  }, [data]);

  if (loadingBusinessType || loadingCoverType || loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (errorBusinessType || errorCoverType || error) {
    return /*#__PURE__*/React.createElement(Error$1, {
      error: errorBusinessType || errorCoverType || error
    });
  }

  var businessTypeList = businessTypeData.businessTypeList;
  var maxInsuredLimitList = coverTypeData.maxInsuredLimitList;
  var MINOR_THRESHOLD_AGE = 18;
  var healthQuote = data.healthQuote;

  var validate = function validate(values) {
    var _values$cover, _values$cover2, _values$existingPolic;

    var errors = {};
    var maxInsuredIndividualValue = maxInsuredLimitList === null || maxInsuredLimitList === void 0 ? void 0 : maxInsuredLimitList.find(function (maxLimit) {
      return maxLimit.code.toLowerCase() === 'individual basis';
    });
    var maxInsuredFloaterValue = maxInsuredLimitList === null || maxInsuredLimitList === void 0 ? void 0 : maxInsuredLimitList.find(function (maxLimit) {
      return maxLimit.code.toLowerCase() === 'floater basis';
    });

    if (!values.quotationType || values.quotationType === '') {
      errors.quotationType = '* Required';
    } //     if (values.members[1].gender===values.members[0].gender)
    // {
    // errors.members = [{},{ gender: '* Self and Spouse Gender cannot be same' }];
    // }


    if (values.members[1].gender === values.members[0].gender && values.members[0].gender && values.members[1].gender) {
      errors.members = [{}, {
        gender: '* Self and Spouse Gender cannot be same'
      }];
    }

    if (values.members.filter(function (mem) {
      return mem.selected;
    }).length === 0) {
      errors.allMembers = 'Please select atleast 1 member'; // errors.members = [{ selected: '* Please select a member' }];
    } else if (values.members.filter(function (mem) {
      return mem.selected && (!mem.gender || mem.gender === '' || !mem.dob || mem.dob === '');
    }).length > 0) {
      errors.members = values.members.map(function (mem) {
        return {
          gender: mem.selected && (!mem.gender || mem.gender === '') ? '* Required' : '',
          dob: mem.selected && (!mem.dob || mem.dob === '') ? '* Required' : ''
        };
      });
    } else if (values.members.filter(function (mem) {
      return mem.selected && mem.dob !== '' && moment(mem.dob, 'DD/MM/YYYY').isAfter();
    }).length > 0) {
      errors.members = values.members.map(function (mem) {
        return {
          dob: mem.selected && mem.dob !== '' && moment(mem.dob, 'DD/MM/YYYY').isAfter() ? '* Date of Birth cannot be in the future' : ''
        };
      });
    } else if (values.members.filter(function (mem) {
      return mem.selected && mem.relationship.toString() === 'Self' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE;
    }).length > 0) {
      errors.members = values.members.map(function (mem) {
        // console.log("mem ", mem);
        return {
          dob: mem.selected && mem.relationship.toString() === 'Self' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE ? '* Date of Birth cannot be less than 18' : ''
        };
      });
    } else if (values.members.filter(function (mem) {
      return mem.selected && mem.relationship.toString() === 'Adult Son' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE;
    }).length > 0) {
      errors.members = values.members.map(function (mem) {
        // console.log("mem ", mem);
        return {
          dob: mem.selected && mem.relationship.toString() === 'Adult Son' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE ? '* Date of Birth cannot be less than 18' : ''
        };
      });
    } else if (values.members.filter(function (mem) {
      return mem.selected && mem.relationship.toString() === 'Adult Daughter' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE;
    }).length > 0) {
      errors.members = values.members.map(function (mem) {
        // console.log("mem ", mem);
        return {
          dob: mem.selected && mem.relationship.toString() === 'Adult Daughter' && mem.dob !== '' && moment(new Date(), 'DD/MM/YYYY').diff(moment(mem.dob, 'DD/MM/YYYY'), 'years') < MINOR_THRESHOLD_AGE ? '* Date of Birth cannot be less than 18' : ''
        };
      });
    }

    if ((maxInsuredIndividualValue === null || maxInsuredIndividualValue === void 0 ? void 0 : maxInsuredIndividualValue.code) === (values === null || values === void 0 ? void 0 : (_values$cover = values.cover) === null || _values$cover === void 0 ? void 0 : _values$cover.type)) {
      if (!isNaN(parseInt(maxInsuredIndividualValue === null || maxInsuredIndividualValue === void 0 ? void 0 : maxInsuredIndividualValue.value)) && values.members.filter(function (mem) {
        return mem.selected;
      }).length > parseInt(maxInsuredIndividualValue === null || maxInsuredIndividualValue === void 0 ? void 0 : maxInsuredIndividualValue.value)) {
        errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
          type: "* Insured members cannot be more than ".concat(maxInsuredIndividualValue === null || maxInsuredIndividualValue === void 0 ? void 0 : maxInsuredIndividualValue.value)
        });
      }
    }

    if ((maxInsuredFloaterValue === null || maxInsuredFloaterValue === void 0 ? void 0 : maxInsuredFloaterValue.code) === (values === null || values === void 0 ? void 0 : (_values$cover2 = values.cover) === null || _values$cover2 === void 0 ? void 0 : _values$cover2.type)) {
      if (!isNaN(parseInt(maxInsuredFloaterValue === null || maxInsuredFloaterValue === void 0 ? void 0 : maxInsuredFloaterValue.value)) && values.members.filter(function (mem) {
        return mem.selected;
      }).length > parseInt(maxInsuredFloaterValue === null || maxInsuredFloaterValue === void 0 ? void 0 : maxInsuredFloaterValue.value)) {
        errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
          type: "* Insured members cannot be more than ".concat(maxInsuredFloaterValue === null || maxInsuredFloaterValue === void 0 ? void 0 : maxInsuredFloaterValue.value)
        });
      }
    }

    if (!values.location.pincode || values.location.pincode === '') {
      errors.location = _objectSpread2(_objectSpread2({}, errors.location), {}, {
        pincode: '* Required'
      });
    } else if (values.location.pincode.toString().length !== 6 || !values.location.pincode.toString().match(/^[0-9]+$/)) {
      errors.location = _objectSpread2(_objectSpread2({}, errors.location), {}, {
        pincode: '* Pincode must be of 6 digits'
      });
    } else if (values.location.pincode && (!values.location.city || !values.location.district || !values.location.state)) {
      errors.location = _objectSpread2(_objectSpread2({}, errors.location), {}, {
        pincode: '* Please click on the Pincode Search Icon'
      });
    }

    if (!values.location.zone || values.location.zone === '') {
      errors.location = _objectSpread2(_objectSpread2({}, errors.location), {}, {
        zone: '* Required'
      });
    }

    if (!values.cover.type || values.cover.type === '') {
      errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
        type: '* Required'
      });
    }

    if (!values.cover.sum_insured || values.cover.sum_insured === '') {
      errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
        sum_insured: '* Required'
      });
    }
    /**SA : CR_P2_577 : SI validation For HP */


    if ((productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && defaultSumInsured) {
      var _defaultSumInsured$fi;

      if (values.cover.sum_insured && values.cover.type && parseInt(values.cover.sum_insured) < parseInt(defaultSumInsured === null || defaultSumInsured === void 0 ? void 0 : (_defaultSumInsured$fi = defaultSumInsured.find(function (d) {
        var _d$coverType, _values$cover$type;

        return ((_d$coverType = d.coverType) === null || _d$coverType === void 0 ? void 0 : _d$coverType.toLowerCase()) === ((_values$cover$type = values.cover.type) === null || _values$cover$type === void 0 ? void 0 : _values$cover$type.toLowerCase());
      })) === null || _defaultSumInsured$fi === void 0 ? void 0 : _defaultSumInsured$fi.value)) {
        var _defaultSumInsured$fi2;

        //setDisableProcced(true);
        errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
          suminsured: "For ".concat(values.cover.type, ", Sum Insured cannot be less than\n          ").concat(Parse(defaultSumInsured === null || defaultSumInsured === void 0 ? void 0 : (_defaultSumInsured$fi2 = defaultSumInsured.find(function (d) {
            return d.coverType === values.cover.type;
          })) === null || _defaultSumInsured$fi2 === void 0 ? void 0 : _defaultSumInsured$fi2.value, false, true, branding, false), ".")
        });
      }
    }
    /**EA : CR_P2_577 : SI validation For HP  */


    if (!values.cover.tenure || values.cover.tenure === '') {
      errors.cover = _objectSpread2(_objectSpread2({}, errors.cover), {}, {
        tenure: '* Required'
      });
    }

    if (values !== null && values !== void 0 && values.existingPolicyNumber && !(values !== null && values !== void 0 && (_values$existingPolic = values.existingPolicyNumber) !== null && _values$existingPolic !== void 0 && _values$existingPolic.match(/^[a-zA-Z0-9]+$/))) {
      errors.existingPolicyNumber = '* Policy Number can be alphanumeric only';
    }

    return errors;
  };

  var checkExistingPolicyNo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var _values$cover3, _values$cover3$tenure, _HideFieldListData$Cr, _ExistingPolicyDtls$p, _HideFieldListData$Cr3, _HideFieldListData$Cr5, _HideFieldListData$Cr6, _HideFieldListData$Cr7, _HideFieldListData$Cr8, _HideFieldListData$Cr9, queryOutput, _yield$queryOutput, queryData, ExistingPolicyDtls, _HideFieldListData$Cr2, _HideFieldListData$Cr4, _HideFieldListData$Cr10, _HideFieldListData$Cr11, _HideFieldListData$Cr12;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              queryOutput = fetchQuery({
                query: EXISTING_POLICY_DTLS,
                variables: {
                  policyNo: values === null || values === void 0 ? void 0 : values.existingPolicyNumber
                }
              });
              _context.next = 4;
              return queryOutput;

            case 4:
              _yield$queryOutput = _context.sent;
              queryData = _yield$queryOutput.data;
              ExistingPolicyDtls = queryData.ExistingPolicyDtls;

              if (ExistingPolicyDtls !== null && ExistingPolicyDtls !== void 0 && ExistingPolicyDtls.productCode) {
                _context.next = 12;
                break;
              }

              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, "Enter a valid policy number")),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 12:
              if (!((productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && parseInt(values === null || values === void 0 ? void 0 : (_values$cover3 = values.cover) === null || _values$cover3 === void 0 ? void 0 : (_values$cover3$tenure = _values$cover3.tenure) === null || _values$cover3$tenure === void 0 ? void 0 : _values$cover3$tenure.split(" ")[0]) < parseInt(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr === void 0 ? void 0 : _HideFieldListData$Cr.hp_tenure))) {
                _context.next = 15;
                break;
              }

              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, "Cross Sell Discount cannot be availed as tenure is less than ".concat(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr2 = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr2 === void 0 ? void 0 : _HideFieldListData$Cr2.hp_tenure))),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 15:
              if (!((ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : (_ExistingPolicyDtls$p = ExistingPolicyDtls.productCode) === null || _ExistingPolicyDtls$p === void 0 ? void 0 : _ExistingPolicyDtls$p.toString()) === '4201' && parseInt(ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : ExistingPolicyDtls.coverSI) < parseInt(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr3 = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr3 === void 0 ? void 0 : _HideFieldListData$Cr3.ipa_policy_min_si))) {
                _context.next = 18;
                break;
              }

              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, "Cross Sell Discount cannot be availed as IPA Policy AD Sum Insured is\n                 less than \n                 ".concat(Parse(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr4 = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr4 === void 0 ? void 0 : _HideFieldListData$Cr4.ipa_policy_min_si, false, true, branding, false), "\n                 "))),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 18:
              if (HideFieldListData !== null && HideFieldListData !== void 0 && (_HideFieldListData$Cr5 = HideFieldListData.CrossSellRoleLimits) !== null && _HideFieldListData$Cr5 !== void 0 && (_HideFieldListData$Cr6 = _HideFieldListData$Cr5.min_net_premium) !== null && _HideFieldListData$Cr6 !== void 0 && _HideFieldListData$Cr6.find(function (d) {
                var _d$product, _ExistingPolicyDtls$p2;

                return (d === null || d === void 0 ? void 0 : (_d$product = d.product) === null || _d$product === void 0 ? void 0 : _d$product.toString()) === (ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : (_ExistingPolicyDtls$p2 = ExistingPolicyDtls.productCode) === null || _ExistingPolicyDtls$p2 === void 0 ? void 0 : _ExistingPolicyDtls$p2.toString());
              })) {
                _context.next = 21;
                break;
              }

              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, "Cross Sell Discount cannot be availed for given Policy Number")),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 21:
              if (!(parseFloat(ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : ExistingPolicyDtls.netPremium) < parseFloat(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr7 = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr7 === void 0 ? void 0 : (_HideFieldListData$Cr8 = _HideFieldListData$Cr7.min_net_premium) === null || _HideFieldListData$Cr8 === void 0 ? void 0 : (_HideFieldListData$Cr9 = _HideFieldListData$Cr8.find(function (d) {
                var _d$product2, _ExistingPolicyDtls$p3;

                return (d === null || d === void 0 ? void 0 : (_d$product2 = d.product) === null || _d$product2 === void 0 ? void 0 : _d$product2.toString()) === (ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : (_ExistingPolicyDtls$p3 = ExistingPolicyDtls.productCode) === null || _ExistingPolicyDtls$p3 === void 0 ? void 0 : _ExistingPolicyDtls$p3.toString());
              })) === null || _HideFieldListData$Cr9 === void 0 ? void 0 : _HideFieldListData$Cr9.min))) {
                _context.next = 24;
                break;
              }

              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, "Cross Sell Discount cannot be availed as cross sell policy is having gross premium less than"), /*#__PURE__*/React.createElement("span", null, "".concat(Parse(HideFieldListData === null || HideFieldListData === void 0 ? void 0 : (_HideFieldListData$Cr10 = HideFieldListData.CrossSellRoleLimits) === null || _HideFieldListData$Cr10 === void 0 ? void 0 : (_HideFieldListData$Cr11 = _HideFieldListData$Cr10.min_net_premium) === null || _HideFieldListData$Cr11 === void 0 ? void 0 : (_HideFieldListData$Cr12 = _HideFieldListData$Cr11.find(function (d) {
                  var _d$product3, _ExistingPolicyDtls$p4;

                  return (d === null || d === void 0 ? void 0 : (_d$product3 = d.product) === null || _d$product3 === void 0 ? void 0 : _d$product3.toString()) === (ExistingPolicyDtls === null || ExistingPolicyDtls === void 0 ? void 0 : (_ExistingPolicyDtls$p4 = ExistingPolicyDtls.productCode) === null || _ExistingPolicyDtls$p4 === void 0 ? void 0 : _ExistingPolicyDtls$p4.toString());
                })) === null || _HideFieldListData$Cr12 === void 0 ? void 0 : _HideFieldListData$Cr12.min, true, true, branding, false), "\n                "))),
                type: 'warning',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 24:
              return _context.abrupt("return", true);

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](0);
              setAlerts([{
                header: 'Cross Sell Discount',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              return _context.abrupt("return", false);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 27]]);
    }));

    return function checkExistingPolicyNo(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
      var errors, error_count, _data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              errors = validate(values);
              error_count = Object.keys(errors).length;

              if (!(error_count === 0)) {
                _context2.next = 18;
                break;
              }

              if (!(values !== null && values !== void 0 && values.existingPolicyNumber)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return checkExistingPolicyNo(values);

            case 6:
              _data = _context2.sent;

              if (_data) {
                _context2.next = 10;
                break;
              }

              setProceedToPlanPage(false);
              return _context2.abrupt("return", false);

            case 10:
              updateHealthQuote(_objectSpread2(_objectSpread2({}, values), {}, {
                currentTab: 'plans',
                isCoverPageLoading: false
              }));

              if (!(healthQuote !== null && healthQuote !== void 0 && healthQuote.quotationNo) && !quoteNumber) ;

              setProceedToPlanPage(true);
              setStartStep(1);
              setAlerts([]);
              return _context2.abrupt("return", true);

            case 18:
              setProceedToPlanPage(false);
              return _context2.abrupt("return", false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var MemberForm = function MemberForm(_ref4) {
    var _screenType$toString, _applicableMemberType2, _values$members3, _values$members3$filt, _screenType$toString2, _applicableMemberType3, _values$members8, _values$members8$filt, _HideFieldListData$Cr13, _HideFieldListData$Cr14;

    var validate = _ref4.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    var isAllowed = function isAllowed(memberType) {
      var isPresent = values.members.filter(function (mem) {
        return memberType.maxAllowed > 1 ? mem.relationship.startsWith(memberType.label) : mem.relationship === memberType.label;
      });
      return isPresent.length < memberType.maxAllowed && memberType.label !== 'Self' && memberType.label !== 'Spouse' ? true : false;
    };

    useEffect(function () {
      if (values && values.members.filter(function (mem) {
        return mem.selected;
      }).length === 1) {
        setFieldValue('cover.type', 'Individual Basis');
      }
    }, [values.members]);

    var onPinCodeLookup = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val, setFieldValue) {
        var queryOutput, _yield$queryOutput2, _data2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (val.toString().length !== 6 || !val.toString().match(/^[0-9]+$/)) {
                  _context3.next = 23;
                  break;
                }

                queryOutput = fetchQuery({
                  query: PIN_CODE_LOOKUP,
                  variables: {
                    filter: {
                      pincode: val
                    }
                  }
                });
                setLoadingPinCode(true);
                _context3.prev = 3;
                setAlerts([]);
                _context3.next = 7;
                return queryOutput;

              case 7:
                _yield$queryOutput2 = _context3.sent;
                _data2 = _yield$queryOutput2.data;
                setLoadingPinCode(false);
                setFieldValue('location.city', _data2.pincodeInfo.city);
                setFieldValue('location.district', _data2.pincodeInfo.district);
                setFieldValue('location.state', _data2.pincodeInfo.state);
                _context3.next = 23;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](3);
                setLoadingPinCode(false);
                setAlerts([{
                  header: 'Pincode Search Failed',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, /*#__PURE__*/React.createElement("span", null, _context3.t0.message)),
                  type: 'error',
                  timeout: null,
                  disableClose: false
                }]);
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
                setFieldValue('location.city', '');
                setFieldValue('location.district', '');
                setFieldValue('location.state', '');

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 15]]);
      }));

      return function onPinCodeLookup(_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();

    var data = [{
      title: 'Choose Business Type',
      grid_data: [{
        colSpan: repeat,
        disabledGlobal: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        type: 'radiogroup',
        name: 'quotationType',
        itemBreak: repeat === repeatForMobile,
        data: businessTypeList ? _toConsumableArray(businessTypeList.map(function (businessType) {
          return {
            label: businessType.value ? businessType.value : '',
            value: businessType.code ? businessType.code : ''
          };
        })) : [],
        onRadioChange: function onRadioChange(val) {
          if (val === 'Roll Over' && productCode === '2883') {
            setAlerts([{
              header: "Roll Over",
              id: Date.now(),
              content: /*#__PURE__*/React.createElement("div", {
                className: "flex flex-row flex-wrap space-y-2 w-full h-full"
              }, /*#__PURE__*/React.createElement("span", null, "Pls confirm whether all below documents are available for upload as it is Rollover Business:-", /*#__PURE__*/React.createElement("br", null), "a. Previous Policy Document", " ", /*#__PURE__*/React.createElement("br", null), "b. Renewal Notice", " ", /*#__PURE__*/React.createElement("br", null), "c. Portability Form", " ", /*#__PURE__*/React.createElement("br", null), "d. Approval Mail", " ", /*#__PURE__*/React.createElement("br", null))),
              type: 'warning',
              timeout: 180000,
              disableClose: false
            }]);
          } else {
            setAlerts([]);
          }
        }
      }]
    }, {
      title: 'Choose Members',
      grid_data: memberList.length > 0 && (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) === 'mobile' ? [{
        type: 'render',
        component: function component(values) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, memberList.map(function (mem, idx) {
            var _values$members$idx, _values$members$idx2, _values$members$idx4, _values$members$idx5, _values$members$idx6, _values$members$idx7, _validate, _validate$members, _validate$members$;

            var dateVal = values === null || values === void 0 ? void 0 : (_values$members$idx = values.members[idx]) === null || _values$members$idx === void 0 ? void 0 : _values$members$idx.dob;
            return /*#__PURE__*/React.createElement(Grid, {
              key: idx,
              flow: 'cols',
              repeat: 3,
              gap: 2,
              className: "py-0.5"
            }, /*#__PURE__*/React.createElement(GridItem, {
              colSpan: 1
            }, /*#__PURE__*/React.createElement(Button, {
              className: "text-black m-0 hover:bg-white focus:text-black focus:bg-white focus:outline-none w-full h-5/6 relative p-1 flex flex-col items-center justify-center rounded-lg text-xs cursor-pointer ".concat(values !== null && values !== void 0 && (_values$members$idx2 = values.members[idx]) !== null && _values$members$idx2 !== void 0 && _values$members$idx2.selected ? 'border-2 border-secondary' : 'border border-secondary bg-opacity-50'),
              flat: true,
              type: "button",
              disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
              onClick: function onClick(_) {
                var _values$members$idx3;

                setFieldValue("members[".concat(idx, "].selected"), !(values !== null && values !== void 0 && (_values$members$idx3 = values.members[idx]) !== null && _values$members$idx3 !== void 0 && _values$members$idx3.selected));
              }
            }, /*#__PURE__*/React.createElement("div", {
              className: "flex flex-col h-full w-full items-center justify-center text-black"
            }, /*#__PURE__*/React.createElement(Text, {
              className: !(initialMemberList !== null && initialMemberList !== void 0 && initialMemberList.find(function (initialMember) {
                var _initialMember$label, _initialMember$label$, _mem$label, _mem$label$toString;

                return (initialMember === null || initialMember === void 0 ? void 0 : (_initialMember$label = initialMember.label) === null || _initialMember$label === void 0 ? void 0 : (_initialMember$label$ = _initialMember$label.toString()) === null || _initialMember$label$ === void 0 ? void 0 : _initialMember$label$.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$label = mem.label) === null || _mem$label === void 0 ? void 0 : (_mem$label$toString = _mem$label.toString()) === null || _mem$label$toString === void 0 ? void 0 : _mem$label$toString.toLowerCase());
              })) && !(values !== null && values !== void 0 && values.quotationNo) ? 'mt-4' : ''
            }, mem.label), /*#__PURE__*/React.createElement(Text, {
              type: "label"
            }, dateVal ? "".concat(moment().diff(moment(dateVal, 'DD/MM/YYYY'), 'years'), " Year(s)") : null), !(initialMemberList !== null && initialMemberList !== void 0 && initialMemberList.find(function (initialMember) {
              var _initialMember$label2, _initialMember$label3, _mem$label2, _mem$label2$toString;

              return (initialMember === null || initialMember === void 0 ? void 0 : (_initialMember$label2 = initialMember.label) === null || _initialMember$label2 === void 0 ? void 0 : (_initialMember$label3 = _initialMember$label2.toString()) === null || _initialMember$label3 === void 0 ? void 0 : _initialMember$label3.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$label2 = mem.label) === null || _mem$label2 === void 0 ? void 0 : (_mem$label2$toString = _mem$label2.toString()) === null || _mem$label2$toString === void 0 ? void 0 : _mem$label2$toString.toLowerCase());
            })) && !(values !== null && values !== void 0 && values.quotationNo) && /*#__PURE__*/React.createElement(Text, {
              severity: 'info',
              type: 'label',
              className: 'rounded hover:bg-secondary hover:text-white',
              onClick: function onClick(e) {
                var _values$members, _values$members2;

                e.stopPropagation();
                setFieldValue('members', [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members = values.members) === null || _values$members === void 0 ? void 0 : _values$members.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members2 = values.members) === null || _values$members2 === void 0 ? void 0 : _values$members2.slice(idx + 1))));
                setMemberList([].concat(_toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(0, idx)), _toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(idx + 1))));
              }
            }, "Remove")), /*#__PURE__*/React.createElement("div", {
              className: values !== null && values !== void 0 && (_values$members$idx4 = values.members[idx]) !== null && _values$members$idx4 !== void 0 && _values$members$idx4.selected ? !(values !== null && values !== void 0 && values.quotationNo) ? 'absolute top-1 right-1 text-secondary' : 'absolute top-1 right-1 text-neutral-dark' : 'hidden'
            }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faCheckCircle
            })))), /*#__PURE__*/React.createElement(GridItem, {
              colSpan: 2
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaSelect, {
              size: "full",
              name: "members[".concat(idx, "].gender"),
              data: genderList.map(function (gender) {
                var _gender$value, _gender$code;

                return {
                  label: gender !== null && gender !== void 0 && gender.value ? gender === null || gender === void 0 ? void 0 : (_gender$value = gender.value) === null || _gender$value === void 0 ? void 0 : _gender$value.toString() : '',
                  value: gender !== null && gender !== void 0 && gender.code ? gender === null || gender === void 0 ? void 0 : (_gender$code = gender.code) === null || _gender$code === void 0 ? void 0 : _gender$code.toString() : ''
                };
              }),
              disabled: !(values !== null && values !== void 0 && (_values$members$idx5 = values.members[idx]) !== null && _values$members$idx5 !== void 0 && _values$members$idx5.selected) || !mem.selectGender || (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
              onDataChange: function onDataChange(val, setFieldValue) {
                if (mem.label === 'Self') {
                  setFieldValue('members[1].gender', val === 'MALE' ? 'FEMALE' : 'MALE' );
                }
              }
            })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
              type: "label"
            }, "Date of Birth", ' ', values !== null && values !== void 0 && (_values$members$idx6 = values.members[idx]) !== null && _values$members$idx6 !== void 0 && _values$members$idx6.selected ? /*#__PURE__*/React.createElement(Text, {
              severity: "error"
            }, "*") : null), /*#__PURE__*/React.createElement(QuantaLookupDateInput, {
              size: "full",
              name: "members[".concat(idx, "].dob"),
              disabled: !(values !== null && values !== void 0 && (_values$members$idx7 = values.members[idx]) !== null && _values$members$idx7 !== void 0 && _values$members$idx7.selected) || (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
              onDataChange: function onDataChange(val, setFieldValue) {
                return setFieldValue("members[".concat(idx, "].age"), moment().diff(moment(val, 'DD/MM/YYYY'), 'years'));
              }
            }))), /*#__PURE__*/React.createElement(GridItem, {
              colSpan: 3,
              className: "-mt-7"
            }, idx === 0 && /*#__PURE__*/React.createElement(Text, {
              type: "label",
              severity: "error"
            }, ((_validate = validate(values)) === null || _validate === void 0 ? void 0 : (_validate$members = _validate.members) === null || _validate$members === void 0 ? void 0 : _validate$members.length) > 0 ? (_validate$members$ = validate(values).members[0]) === null || _validate$members$ === void 0 ? void 0 : _validate$members$.selected : null)));
          }));
        }
      }, !(values !== null && values !== void 0 && values.quotationNo) && (applicableMemberTypes === null || applicableMemberTypes === void 0 ? void 0 : (_applicableMemberType2 = applicableMemberTypes.filter(function (applicable) {
        return isAllowed(applicable);
      })) === null || _applicableMemberType2 === void 0 ? void 0 : _applicableMemberType2.length) > 0 ? {
        type: 'render',
        colSpan: 1,
        component: function component() {
          return /*#__PURE__*/React.createElement("div", {
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Button, {
            flat: false,
            type: "button",
            className: "w-full pl-4 max-h-10",
            iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faPlus
            }),
            onClick: function onClick(e) {
              return setShowModalAddOthers(true);
            }
          }, "Add Others"));
        }
      } : null, (values === null || values === void 0 ? void 0 : (_values$members3 = values.members) === null || _values$members3 === void 0 ? void 0 : (_values$members3$filt = _values$members3.filter(function (mem) {
        return mem.selected;
      })) === null || _values$members3$filt === void 0 ? void 0 : _values$members3$filt.length) === 0 ? {
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement(Text, {
            severity: 'error'
          }, "* Please select atleast 1 member");
        }
      } : null].filter(function (d) {
        return d !== null;
      }) : memberList.length > 0 && (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString2 = screenType.toString()) === null || _screenType$toString2 === void 0 ? void 0 : _screenType$toString2.toLowerCase()) !== 'mobile' ? [].concat(_toConsumableArray(memberList.map(function (mem, idx) {
        var _values$members$idx8, _values$members$idx9, _values$members$idx10, _values$members$idx11;

        return [{
          type: 'checkbox',
          disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
          label: mem.label,
          name: "members[".concat(idx, "].selected"),
          className: 'mt-10',
          onDataChange: function onDataChange(val, setFieldValue) {
            setFieldValue("members[".concat(idx, "].relationship"), mem.label);
          }
        }, {
          type: 'select',
          label: /*#__PURE__*/React.createElement(Text, {
            type: "label"
          }, "Gender", ' ', values !== null && values !== void 0 && (_values$members$idx8 = values.members[idx]) !== null && _values$members$idx8 !== void 0 && _values$members$idx8.selected ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : null),
          name: "members[".concat(idx, "].gender"),
          disabled: !(values !== null && values !== void 0 && (_values$members$idx9 = values.members[idx]) !== null && _values$members$idx9 !== void 0 && _values$members$idx9.selected) || !mem.selectGender || (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
          onDataChange: function onDataChange(val, setFieldValue) {
            if (mem.label === 'Self') {
              setFieldValue('members[1].gender', val === 'MALE' ? 'FEMALE' : 'MALE' );
            }
          },
          data: genderList.map(function (gender) {
            var _gender$value2, _gender$code2;

            return {
              label: gender !== null && gender !== void 0 && gender.value ? gender === null || gender === void 0 ? void 0 : (_gender$value2 = gender.value) === null || _gender$value2 === void 0 ? void 0 : _gender$value2.toString() : '',
              value: gender !== null && gender !== void 0 && gender.code ? gender === null || gender === void 0 ? void 0 : (_gender$code2 = gender.code) === null || _gender$code2 === void 0 ? void 0 : _gender$code2.toString() : ''
            };
          })
        }, {
          type: 'date',
          label: /*#__PURE__*/React.createElement(Text, {
            type: "label"
          }, "Date of Birth", ' ', values !== null && values !== void 0 && (_values$members$idx10 = values.members[idx]) !== null && _values$members$idx10 !== void 0 && _values$members$idx10.selected ? /*#__PURE__*/React.createElement(Text, {
            severity: "error"
          }, "*") : null),
          name: "members[".concat(idx, "].dob"),
          disabled: !(values !== null && values !== void 0 && (_values$members$idx11 = values.members[idx]) !== null && _values$members$idx11 !== void 0 && _values$members$idx11.selected) || (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
          onDataChange: function onDataChange(val, setFieldValue) {
            return setFieldValue("members[".concat(idx, "].age"), moment().diff(moment(val, 'DD/MM/YYYY'), 'years'));
          }
        }, {
          type: 'render',
          component: function component(values) {
            var _values$members$idx12;

            var value = values === null || values === void 0 ? void 0 : (_values$members$idx12 = values.members[idx]) === null || _values$members$idx12 === void 0 ? void 0 : _values$members$idx12.dob;
            return value === undefined || value === '' ? initialMemberList !== null && initialMemberList !== void 0 && initialMemberList.find(function (initialMember) {
              var _initialMember$label4;

              return initialMember === null || initialMember === void 0 ? void 0 : (_initialMember$label4 = initialMember.label) === null || _initialMember$label4 === void 0 ? void 0 : _initialMember$label4.startsWith(mem === null || mem === void 0 ? void 0 : mem.label);
            }) ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
              className: "mb-2 h-6",
              text: ""
            }), /*#__PURE__*/React.createElement("div", {
              className: "flex flex-row gap-2 items-center h-10"
            }, /*#__PURE__*/React.createElement(Text, {
              className: "w-20 text-base"
            }), !(initialMemberList !== null && initialMemberList !== void 0 && initialMemberList.find(function (initialMember) {
              var _initialMember$label5, _initialMember$label6, _mem$label3, _mem$label3$toString;

              return (initialMember === null || initialMember === void 0 ? void 0 : (_initialMember$label5 = initialMember.label) === null || _initialMember$label5 === void 0 ? void 0 : (_initialMember$label6 = _initialMember$label5.toString()) === null || _initialMember$label6 === void 0 ? void 0 : _initialMember$label6.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$label3 = mem.label) === null || _mem$label3 === void 0 ? void 0 : (_mem$label3$toString = _mem$label3.toString()) === null || _mem$label3$toString === void 0 ? void 0 : _mem$label3$toString.toLowerCase());
            })) && !(values !== null && values !== void 0 && values.quotationNo) && /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faTrashAlt,
              className: "cursor-pointer ".concat((values === null || values === void 0 ? void 0 : values.quotationNo) !== '' ? 'text-neutral-dark' : 'text-secondary'),
              size: 'lg',
              onClick: function onClick(_) {
                if ((values === null || values === void 0 ? void 0 : values.quotationNo) === '') {
                  var _values$members4, _values$members5;

                  setFieldValue('members', [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members4 = values.members) === null || _values$members4 === void 0 ? void 0 : _values$members4.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members5 = values.members) === null || _values$members5 === void 0 ? void 0 : _values$members5.slice(idx + 1))));
                  setMemberList([].concat(_toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(0, idx)), _toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(idx + 1))));
                }
              }
            })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
              className: "mb-2",
              text: "Age"
            }), /*#__PURE__*/React.createElement("div", {
              className: "flex flex-row gap-2 items-center h-10"
            }, /*#__PURE__*/React.createElement(Text, {
              className: "w-20 text-base"
            }, moment().diff(moment(value, 'DD/MM/YYYY'), 'years'), ' ', "Years"), !(initialMemberList !== null && initialMemberList !== void 0 && initialMemberList.find(function (initialMember) {
              var _initialMember$label7, _initialMember$label8, _mem$label4, _mem$label4$toString;

              return (initialMember === null || initialMember === void 0 ? void 0 : (_initialMember$label7 = initialMember.label) === null || _initialMember$label7 === void 0 ? void 0 : (_initialMember$label8 = _initialMember$label7.toString()) === null || _initialMember$label8 === void 0 ? void 0 : _initialMember$label8.toLowerCase()) === (mem === null || mem === void 0 ? void 0 : (_mem$label4 = mem.label) === null || _mem$label4 === void 0 ? void 0 : (_mem$label4$toString = _mem$label4.toString()) === null || _mem$label4$toString === void 0 ? void 0 : _mem$label4$toString.toLowerCase());
            })) && !(values !== null && values !== void 0 && values.quotationNo) && /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faTrashAlt,
              className: "cursor-pointer ".concat((values === null || values === void 0 ? void 0 : values.quotationNo) !== '' ? 'text-neutral' : 'text-secondary'),
              size: 'lg',
              onClick: function onClick(_) {
                if ((values === null || values === void 0 ? void 0 : values.quotationNo) === '') {
                  var _values$members6, _values$members7;

                  setFieldValue('members', [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members6 = values.members) === null || _values$members6 === void 0 ? void 0 : _values$members6.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$members7 = values.members) === null || _values$members7 === void 0 ? void 0 : _values$members7.slice(idx + 1))));
                  setMemberList([].concat(_toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(0, idx)), _toConsumableArray(memberList === null || memberList === void 0 ? void 0 : memberList.slice(idx + 1))));
                }
              }
            }))));
          }
        }];
      }).reduce(function (b, a) {
        return [].concat(_toConsumableArray(b), _toConsumableArray(a));
      }).map(function (itm) {
        return _objectSpread2({}, itm);
      })), [!(values !== null && values !== void 0 && values.quotationNo) && (applicableMemberTypes === null || applicableMemberTypes === void 0 ? void 0 : (_applicableMemberType3 = applicableMemberTypes.filter(function (applicable) {
        return isAllowed(applicable);
      })) === null || _applicableMemberType3 === void 0 ? void 0 : _applicableMemberType3.length) > 0 ? {
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement("div", {
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Button, {
            flat: false,
            type: 'button',
            className: "w-40 pl-4 max-h-10",
            iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faPlus
            }),
            onClick: function onClick(e) {
              return setShowModalAddOthers(true);
            }
          }, "Add Others"));
        }
      } : null, (values === null || values === void 0 ? void 0 : (_values$members8 = values.members) === null || _values$members8 === void 0 ? void 0 : (_values$members8$filt = _values$members8.filter(function (mem) {
        return mem.selected;
      })) === null || _values$members8$filt === void 0 ? void 0 : _values$members8$filt.length) === 0 ? {
        type: 'render',
        colSpan: repeat,
        component: function component() {
          return /*#__PURE__*/React.createElement(Text, {
            severity: 'error'
          }, "* Please select atleast 1 member");
        }
      } : null]).filter(function (d) {
        return d;
      }) : []
    }, {
      title: 'Choose Location',
      grid_data: [{
        type: 'input-lookup',
        size: 'large',
        loading: loadingPinCode,
        label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'location.pincode',
        onLookup: onPinCodeLookup,
        disabled: loadingPinCode || (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        onDataChange: function onDataChange(_, setFieldValue) {
          setFieldValue('location.state', '');
          setFieldValue('location.district', '');
          setFieldValue('location.city', '');
        },
        onKeyDown: function onKeyDown(e) {
          var _ref6, _e$key, _e$key$toString;

          if (!e.key.match(/^[0-9]+$/) && !((_ref6 = ['arrowleft', 'arrowright', 'backspace']) !== null && _ref6 !== void 0 && _ref6.includes(e === null || e === void 0 ? void 0 : (_e$key = e.key) === null || _e$key === void 0 ? void 0 : (_e$key$toString = _e$key.toString()) === null || _e$key$toString === void 0 ? void 0 : _e$key$toString.toLowerCase()))) {
            e.preventDefault();
          }
        }
      }, {
        type: 'text',
        label: 'State',
        name: 'location.state',
        disabled: true
      }, {
        type: 'text',
        label: 'District',
        name: 'location.district',
        disabled: true
      }, {
        type: 'text',
        label: 'City/Town/Village',
        name: 'location.city',
        disabled: true
      }, productCode !== '2877' ? {
        type: 'select',
        disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        label: /*#__PURE__*/React.createElement("div", null, "Zone ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'location.zone',
        data: applicableZones.map(function (zone) {
          var _zone$value, _zone$code;

          return {
            label: zone !== null && zone !== void 0 && zone.value ? zone === null || zone === void 0 ? void 0 : (_zone$value = zone.value) === null || _zone$value === void 0 ? void 0 : _zone$value.toString() : '',
            value: zone !== null && zone !== void 0 && zone.code ? zone === null || zone === void 0 ? void 0 : (_zone$code = zone.code) === null || _zone$code === void 0 ? void 0 : _zone$code.toString() : ''
          };
        })
      } : '']
    }, {
      title: 'Choose Cover',
      grid_data: [{
        type: 'select',
        label: /*#__PURE__*/React.createElement("div", null, "Cover Type ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'cover.type',
        disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        data: applicableCoverTypes.filter(function (type) {
          return values.members.filter(function (member) {
            return member.selected;
          }).length === 1 || values.members.filter(function (member) {
            return member.selected;
          }).length === 0 ? type.value !== 'Floater Basis' : true;
        }).reverse(values.cover.type).map(function (coverType) {
          var _coverType$value, _coverType$code;

          return {
            label: coverType !== null && coverType !== void 0 && coverType.value ? coverType === null || coverType === void 0 ? void 0 : (_coverType$value = coverType.value) === null || _coverType$value === void 0 ? void 0 : _coverType$value.toString() : '',
            value: coverType !== null && coverType !== void 0 && coverType.code ? coverType === null || coverType === void 0 ? void 0 : (_coverType$code = coverType.code) === null || _coverType$code === void 0 ? void 0 : _coverType$code.toString() : ''
          };
        }),
        onDataChange: function onDataChange(val, setFieldValue) {
          /**SA : CR_P2_577: set default Value */
          if ((productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && defaultSumInsured) {
            var _defaultSumInsured$fi3, _defaultSumInsured$fi4;

            setFieldValue("cover.sum_insured", defaultSumInsured === null || defaultSumInsured === void 0 ? void 0 : (_defaultSumInsured$fi3 = defaultSumInsured.find(function (d) {
              var _d$coverType2;

              return ((_d$coverType2 = d.coverType) === null || _d$coverType2 === void 0 ? void 0 : _d$coverType2.toLowerCase()) === (val === null || val === void 0 ? void 0 : val.toLowerCase());
            })) === null || _defaultSumInsured$fi3 === void 0 ? void 0 : (_defaultSumInsured$fi4 = _defaultSumInsured$fi3.value) === null || _defaultSumInsured$fi4 === void 0 ? void 0 : _defaultSumInsured$fi4.toString());
          }
          /**EA : CR_P2_577 : set default Value */

        }
      }, {
        type: 'select',
        disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        label: /*#__PURE__*/React.createElement("div", null, "Sum Insured ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        iconPre: /*#__PURE__*/React.createElement(Text, {
          className: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '' ? 'text-neutral-darker' : 'text-info'
        }, branding.currency),
        name: 'cover.sum_insured',
        data: applicableSumInsureds.map(function (sumInsured) {
          return {
            label: "".concat(Parse(sumInsured, false, true, branding, false)),
            value: sumInsured ? sumInsured === null || sumInsured === void 0 ? void 0 : sumInsured.toString() : ''
          };
        }),
        className: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '' ? 'border-neutral-dark' : ''
      }, {
        type: 'select',
        disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        label: /*#__PURE__*/React.createElement("div", null, "Tenure ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'cover.tenure',
        data: applicableTenures.map(function (tenure) {
          var _tenure$value, _tenure$code;

          return {
            label: tenure !== null && tenure !== void 0 && tenure.value ? tenure === null || tenure === void 0 ? void 0 : (_tenure$value = tenure.value) === null || _tenure$value === void 0 ? void 0 : _tenure$value.toString() : '',
            value: tenure !== null && tenure !== void 0 && tenure.code ? tenure === null || tenure === void 0 ? void 0 : (_tenure$code = tenure.code) === null || _tenure$code === void 0 ? void 0 : _tenure$code.toString() : ''
          };
        })
      }]
    }, productCode !== '2877' //added for 2877
    && HideFieldListData !== null && HideFieldListData !== void 0 && (_HideFieldListData$Cr13 = HideFieldListData.CrossSellRoleLimits) !== null && _HideFieldListData$Cr13 !== void 0 && (_HideFieldListData$Cr14 = _HideFieldListData$Cr13.product) !== null && _HideFieldListData$Cr14 !== void 0 && _HideFieldListData$Cr14.find(function (d) {
      return d.toString() === (productCode === null || productCode === void 0 ? void 0 : productCode.toString());
    }) ? {
      title: 'Additional Details for Discounts',
      grid_data: [{
        type: 'text',
        label: /*#__PURE__*/React.createElement(Text, {
          type: "label"
        }, "Does customer already have existing policy with us?"),
        name: 'existingPolicyNumber',
        disabled: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        placeholder: 'Enter existing Policy Number',
        colSpan: repeat === repeatForDesktop ? 2 : repeat,
        size: "".concat(repeat === repeatForDesktop ? 'medium' : 'full'),
        className: "".concat(repeat === repeatForDesktop ? 'w-60' : '')
      }, {
        type: 'radiogroup',
        label: 'Is the customer also an internal employee or staff of us?',
        name: 'isExistingEmployee',
        disabledGlobal: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        data: [{
          label: 'Yes',
          value: 'Yes'
        }, {
          label: 'No',
          value: 'No'
        }],
        colSpan: repeat
      }]
    } : //added for 2877
    {
      // title: 'Additional Details for Discounts',
      grid_data: [// {
      //   type: 'text',
      //   label: (
      //     <Text type="label">
      //       Does customer already have existing policy with us?
      //     </Text>
      //   ),
      //   name: 'existingPolicyNumber',
      //   disabled: values?.quotationNo !== '',
      //   placeholder: 'Enter existing Policy Number',
      //   colSpan: repeat === repeatForDesktop ? 2 : repeat,
      //   size: `${repeat === repeatForDesktop ? 'medium' : 'full'
      //     }`,
      //   className: `${repeat === repeatForDesktop ? 'w-60' : ''}`,
      //   visible:false,
      // },
      {
        type: 'radiogroup',
        label: 'Is the customer also an internal employee or staff of us?',
        name: 'isExistingEmployee',
        disabledGlobal: (values === null || values === void 0 ? void 0 : values.quotationNo) !== '',
        data: [{
          label: 'Yes',
          value: 'Yes'
        }, {
          label: 'No',
          value: 'No'
        }],
        colSpan: repeat
      }]
    }];
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info'
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
      data: data
    }, other_props))), /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(ModalAddOthers, {
      setShowModalAddOthers: setShowModalAddOthers,
      showModalAddOthers: showModalAddOthers,
      applicableMemberTypes: applicableMemberTypes,
      genderList: genderList,
      memberList: memberList,
      setMemberList: setMemberList,
      values: values,
      setFieldValue: setFieldValue,
      productCode: productCode,
      productName: productName,
      lobCode: lobCode,
      quoteNumber: quoteNumber
    })));
  };

  var initialValues = {
    show_plans: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.show_plans,
    quotationNo: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationNo,
    quotationType: healthQuote !== null && healthQuote !== void 0 && healthQuote.quotationType ? healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationType : businessTypeList && (businessTypeList === null || businessTypeList === void 0 ? void 0 : businessTypeList.length) > 0 ? (_businessTypeList$ = businessTypeList[0]) === null || _businessTypeList$ === void 0 ? void 0 : _businessTypeList$.code : '',
    quotationStatus: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationStatus,
    quoteCreationDate: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quoteCreationDate,
    proposalNumber: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.proposalNumber,
    members: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.members,
    maternityMembers: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.maternityMembers,
    maternitySelectedCover: healthQuote !== null && healthQuote !== void 0 && healthQuote.maternitySelectedCover ? healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.maternitySelectedCover : false,
    location: {
      pincode: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location = healthQuote.location) === null || _healthQuote$location === void 0 ? void 0 : _healthQuote$location.pincode,
      state: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location2 = healthQuote.location) === null || _healthQuote$location2 === void 0 ? void 0 : _healthQuote$location2.state,
      district: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location3 = healthQuote.location) === null || _healthQuote$location3 === void 0 ? void 0 : _healthQuote$location3.district,
      city: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location4 = healthQuote.location) === null || _healthQuote$location4 === void 0 ? void 0 : _healthQuote$location4.city,
      zone: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$location5 = healthQuote.location) !== null && _healthQuote$location5 !== void 0 && _healthQuote$location5.zone ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location6 = healthQuote.location) === null || _healthQuote$location6 === void 0 ? void 0 : _healthQuote$location6.zone : applicableZones && (applicableZones === null || applicableZones === void 0 ? void 0 : applicableZones.length) > 0 ? (_applicableZones$ = applicableZones[0]) === null || _applicableZones$ === void 0 ? void 0 : _applicableZones$.code : ''
    },
    isExistingEmployee: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.isExistingEmployee,
    existingPolicyNumber: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.existingPolicyNumber,
    cover: {
      // type: healthQuote?.cover?.type
      //   ? `${healthQuote?.cover?.type}`
      //   : applicableCoverTypes && applicableCoverTypes?.length > 0
      //   ? applicableCoverTypes[0]?.code
      //   : '',
      // sum_insured: healthQuote?.cover?.sum_insured,
      type: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$cover = healthQuote.cover) !== null && _healthQuote$cover !== void 0 && _healthQuote$cover.type ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover2 = healthQuote.cover) === null || _healthQuote$cover2 === void 0 ? void 0 : _healthQuote$cover2.type : 'Individual Basis',
      sum_insured: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$cover3 = healthQuote.cover) !== null && _healthQuote$cover3 !== void 0 && _healthQuote$cover3.sum_insured ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover4 = healthQuote.cover) === null || _healthQuote$cover4 === void 0 ? void 0 : _healthQuote$cover4.sum_insured : (productCode === null || productCode === void 0 ? void 0 : productCode.toString()) === '2883' && defaultSumInsured
      /**SAEA : CR_P2_577 : set default Value */
      ? defaultSumInsured === null || defaultSumInsured === void 0 ? void 0 : (_defaultSumInsured$fi5 = defaultSumInsured.find(function (d) {
        return d.coverType === 'Individual Basis';
      })) === null || _defaultSumInsured$fi5 === void 0 ? void 0 : (_defaultSumInsured$fi6 = _defaultSumInsured$fi5.value) === null || _defaultSumInsured$fi6 === void 0 ? void 0 : _defaultSumInsured$fi6.toString() : '500000',
      tenure: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$cover5 = healthQuote.cover) !== null && _healthQuote$cover5 !== void 0 && _healthQuote$cover5.tenure ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover6 = healthQuote.cover) === null || _healthQuote$cover6 === void 0 ? void 0 : _healthQuote$cover6.tenure : applicableTenures && (applicableTenures === null || applicableTenures === void 0 ? void 0 : applicableTenures.length) > 0 ? (_applicableTenures$ = applicableTenures[0]) === null || _applicableTenures$ === void 0 ? void 0 : _applicableTenures$.code : ''
    },
    customer: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.customer,
    customerMeta: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.customerMeta
  };
  return /*#__PURE__*/React.createElement("div", null, initialValues && /*#__PURE__*/React.createElement(QuantaFormik, {
    enableReinitialize: true,
    innerRef: props.forwardedRef,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(MemberForm, {
    validate: validate
  })));
}

function QuoteWizard(_ref) {
  var productName = _ref.productName,
      productCode = _ref.productCode,
      quoteNumber = _ref.quoteNumber,
      lobCode = _ref.lobCode,
      moveToPlans = _ref.moveToPlans,
      setMoveToPlans = _ref.setMoveToPlans,
      saveProceedDisplay = _ref.saveProceedDisplay;

  var _useState = useState(quoteNumber ? 1 : 0),
      _useState2 = _slicedToArray(_useState, 2),
      startStep = _useState2[0],
      setStartStep = _useState2[1];

  var fetchQuery = useFetchQuery();

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      productDetails = _useState4[0],
      setProductDetails = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      genderList = _useState6[0],
      setGenderList = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var errorMessage = "There was an issue fetching the Form. Please try again after some time...";
  useEffect(function () {
    var isMounted = true;

    if (isMounted) {
      var _fetchQuery, _fetchQuery$then;

      setError(null);
      setLoading(true);
      (_fetchQuery = fetchQuery({
        query: QUERY_STATE
      })) === null || _fetchQuery === void 0 ? void 0 : (_fetchQuery$then = _fetchQuery.then(function (response) {
        if (isMounted) {
          var _fetchQuery2, _fetchQuery2$then, _healthQuote$intermed;

          var _response$data = response === null || response === void 0 ? void 0 : response.data,
              healthQuote = _response$data.healthQuote,
              selectedIntermediary = _response$data.selectedIntermediary;

          (_fetchQuery2 = fetchQuery({
            query: GET_PRODUCT_DETAILS,
            variables: {
              input: {
                productCode: productCode,
                startDate: moment().format('DD/MM/YYYY').toString(),
                imdCode: (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed = healthQuote.intermediaryDetails) === null || _healthQuote$intermed === void 0 ? void 0 : _healthQuote$intermed.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode)
              }
            }
          })) === null || _fetchQuery2 === void 0 ? void 0 : (_fetchQuery2$then = _fetchQuery2.then(function (response) {
            var _response$data2, _response$data3;

            setLoading(false);
            setProductDetails(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.productDetails);
            setGenderList(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.genderList);
          })) === null || _fetchQuery2$then === void 0 ? void 0 : _fetchQuery2$then.catch(function (error) {
            setLoading(false);
            setError(error === null || error === void 0 ? void 0 : error.message);
          });
        }
      })) === null || _fetchQuery$then === void 0 ? void 0 : _fetchQuery$then.catch(function (error) {
        if (isMounted) {
          setLoading(false);
          setError(error === null || error === void 0 ? void 0 : error.message);
        }
      });
    }

    return function () {
      isMounted = false;
    };
  }, []);
  useEffect(function () {
    if (moveToPlans) {
      setStartStep(1);
      setMoveToPlans(false);
    }
  }, [moveToPlans]);

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      proceedToPlanPage = _useState12[0],
      setProceedToPlanPage = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      alerts = _useState14[0],
      setAlerts = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      disableProceed = _useState16[0],
      setDisableProcced = _useState16[1];

  var memberFormRef = useRef();

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error) {
    return /*#__PURE__*/React.createElement(Error$1, {
      error: errorMessage
    });
  }

  var steps = [{
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUsers
    }),
    label: 'Members',
    proceedLabel: function proceedLabel() {
      return 'Show Available Plans';
    },
    disabledLabel: disableProceed,
    submitForm: function () {
      var _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!memberFormRef.current) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return memberFormRef.current.submitForm();

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 5:
                return _context.abrupt("return", false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function submitForm() {
        return _submitForm.apply(this, arguments);
      }

      return submitForm;
    }(),
    stepCompleted: function stepCompleted() {
      return proceedToPlanPage;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      var _memberFormRef$curren, _memberFormRef$curren2, _memberFormRef$curren3, _memberFormRef$curren9, _memberFormRef$curren10, _memberFormRef$curren11;

      if (memberFormRef !== null && memberFormRef !== void 0 && (_memberFormRef$curren = memberFormRef.current) !== null && _memberFormRef$curren !== void 0 && (_memberFormRef$curren2 = _memberFormRef$curren.errors) !== null && _memberFormRef$curren2 !== void 0 && (_memberFormRef$curren3 = _memberFormRef$curren2.cover) !== null && _memberFormRef$curren3 !== void 0 && _memberFormRef$curren3.type) {
        var _memberFormRef$curren4, _memberFormRef$curren5, _memberFormRef$curren6, _memberFormRef$curren7, _memberFormRef$curren8;

        setAlerts([{
          header: 'Warning',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, /*#__PURE__*/React.createElement("span", null, "".concat(memberFormRef === null || memberFormRef === void 0 ? void 0 : (_memberFormRef$curren4 = memberFormRef.current) === null || _memberFormRef$curren4 === void 0 ? void 0 : (_memberFormRef$curren5 = _memberFormRef$curren4.errors) === null || _memberFormRef$curren5 === void 0 ? void 0 : (_memberFormRef$curren6 = _memberFormRef$curren5.cover) === null || _memberFormRef$curren6 === void 0 ? void 0 : (_memberFormRef$curren7 = _memberFormRef$curren6.type) === null || _memberFormRef$curren7 === void 0 ? void 0 : (_memberFormRef$curren8 = _memberFormRef$curren7.split('*')[1]) === null || _memberFormRef$curren8 === void 0 ? void 0 : _memberFormRef$curren8.trim(), " for the selected cover type"))),
          type: 'warning',
          timeout: null,
          disableClose: false
        }]);
      } else if (memberFormRef !== null && memberFormRef !== void 0 && (_memberFormRef$curren9 = memberFormRef.current) !== null && _memberFormRef$curren9 !== void 0 && (_memberFormRef$curren10 = _memberFormRef$curren9.errors) !== null && _memberFormRef$curren10 !== void 0 && (_memberFormRef$curren11 = _memberFormRef$curren10.cover) !== null && _memberFormRef$curren11 !== void 0 && _memberFormRef$curren11.suminsured) {
        var _memberFormRef$curren12, _memberFormRef$curren13, _memberFormRef$curren14;

        /*EA : CR_P2_577 : SI validation For HP  */
        setAlerts([{
          header: 'Warning',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, /*#__PURE__*/React.createElement("span", null, "".concat(memberFormRef === null || memberFormRef === void 0 ? void 0 : (_memberFormRef$curren12 = memberFormRef.current) === null || _memberFormRef$curren12 === void 0 ? void 0 : (_memberFormRef$curren13 = _memberFormRef$curren12.errors) === null || _memberFormRef$curren13 === void 0 ? void 0 : (_memberFormRef$curren14 = _memberFormRef$curren13.cover) === null || _memberFormRef$curren14 === void 0 ? void 0 : _memberFormRef$curren14.suminsured))),
          type: 'warning',
          timeout: null,
          disableClose: false
        }]);
      } else {
        setAlerts([{
          header: 'Warning',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, /*#__PURE__*/React.createElement("span", null, "Please fill in all the mandatory fields to proceed")),
          type: 'warning',
          timeout: null,
          disableClose: false
        }]);
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    component: function component(_ref2) {
      var expanded = _ref2.expanded;
      return expanded ? /*#__PURE__*/React.createElement(Members, {
        quoteNumber: quoteNumber,
        setProceedToPlanPage: setProceedToPlanPage,
        setAlerts: setAlerts,
        productDetails: productDetails,
        genderList: genderList,
        forwardedRef: memberFormRef,
        productCode: productCode,
        productName: productName,
        lobCode: lobCode,
        setStartStep: setStartStep,
        setDisableProcced: setDisableProcced
      }) : null;
    }
  }, {
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faFileAlt
    }),
    label: 'Plans',
    proceedLabel: function proceedLabel() {
      return undefined;
    },
    stepNotCompleteAlert: function stepNotCompleteAlert() {
      return undefined;
    },
    component: function component(_ref3) {
      var expanded = _ref3.expanded,
          goToStep = _ref3.goToStep;
      return expanded ? /*#__PURE__*/React.createElement(Plans, {
        productName: productName,
        productCode: productCode,
        quoteNumber: quoteNumber,
        lobCode: lobCode,
        goToStep: goToStep,
        genderList: genderList,
        setStartStep: setStartStep,
        productDetails: productDetails,
        saveProceedDisplay: saveProceedDisplay
      }) : null;
    }
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "min-h-full"
  }, loading || !productDetails || !genderList ? /*#__PURE__*/React.createElement("div", {
    className: "h-screen"
  }, /*#__PURE__*/React.createElement(Loading, null)) : error ? /*#__PURE__*/React.createElement(Error$1, {
    error: errorMessage
  }) : /*#__PURE__*/React.createElement(Wizard, {
    steps: steps,
    startStep: startStep,
    tabStyle: true,
    switchTabs: false,
    buttonSize: 'medium'
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })));
}

function ModalSendEmail(_ref) {
  var _plans$filter;

  var setShowEmail = _ref.setShowEmail,
      showEmail = _ref.showEmail,
      initialEmail = _ref.initialEmail,
      getPayLoad = _ref.getPayLoad,
      plans = _ref.plans,
      SEND_EMAIL_QUERY = _ref.SEND_EMAIL_QUERY;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      displayMessage = _useState4[0],
      setDisplayMessage = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      sentSuccess = _useState6[0],
      setSentSuccess = _useState6[1];

  var _useMutation = useMutation(SEND_EMAIL_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setSentSuccess(true);
      setDisplayMessage((_data$ = data["".concat(Object.keys(data)[0])]) === null || _data$ === void 0 ? void 0 : _data$.message);
    },
    onError: function onError(_) {
      setSentSuccess(false);
      setDisplayMessage('Email send failed...Please try again after some time.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSendQuoteEmailAlert = _useMutation2[0],
      loading = _useMutation2[1].loading;

  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showEmail);
    }, 150);
    return function cleanup() {
      clearTimeout(timer);
      setDisplayMessage(null);
      setSentSuccess(true);
    };
  }, [showEmail, setModalDisplay]);

  var onSubmit = function onSubmit(values, _ref2) {
    var _values$plans, _values$plans$filter;

    var setFieldValue = _ref2.setFieldValue;

    if ((values === null || values === void 0 ? void 0 : (_values$plans = values.plans) === null || _values$plans === void 0 ? void 0 : (_values$plans$filter = _values$plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
    })) === null || _values$plans$filter === void 0 ? void 0 : _values$plans$filter.length) === 0) {
      setSentSuccess(false);
      setDisplayMessage('Atleast one plan must be selected');
    } else {
      var _validate;

      setDisplayMessage(null);
      var variables = null;

      if (values !== null && values !== void 0 && values.ccEmail && !((_validate = validate(values)) !== null && _validate !== void 0 && _validate.ccEmail)) {
        var _values$plans2;

        setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : values.ccEmail]));
        setFieldValue("ccEmail", '');
        variables = getPayLoad(values.email, (_values$plans2 = values.plans) === null || _values$plans2 === void 0 ? void 0 : _values$plans2.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
        }), [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : values.ccEmail]));
      } else {
        var _values$plans3;

        variables = getPayLoad(values.email, (_values$plans3 = values.plans) === null || _values$plans3 === void 0 ? void 0 : _values$plans3.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
        }), values === null || values === void 0 ? void 0 : values.ccEmailIDs);
      }

      if (SEND_EMAIL_QUERY) {
        doSendQuoteEmailAlert({
          variables: variables
        });
      }
    }
  };

  var initialValues = {
    email: initialEmail ? initialEmail : '',
    ccEmailIDs: [],
    ccEmail: '',
    plans: _toConsumableArray(plans === null || plans === void 0 ? void 0 : (_plans$filter = plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _plans$filter === void 0 ? void 0 : _plans$filter.map(function (plan) {
      return _objectSpread2(_objectSpread2({}, plan), {}, {
        isPlanChecked: true
      });
    }))
  };

  var validate = function validate(values) {
    var _values$ccEmail, _values$ccEmail$trim, _values$email, _values$email$trim, _values$ccEmailIDs;

    var errors = {};
    var email_check = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

    if (!values.email) {
      errors.email = '* Required';
    } else if (!email_check.test(values.email)) {
      errors.email = '* Please enter valid email address.';
    }

    if (values !== null && values !== void 0 && values.ccEmail && !email_check.test(values === null || values === void 0 ? void 0 : values.ccEmail)) {
      errors.ccEmail = '* Please enter valid email address.';
    } else if (values !== null && values !== void 0 && values.ccEmail && ((values === null || values === void 0 ? void 0 : (_values$ccEmail = values.ccEmail) === null || _values$ccEmail === void 0 ? void 0 : (_values$ccEmail$trim = _values$ccEmail.trim()) === null || _values$ccEmail$trim === void 0 ? void 0 : _values$ccEmail$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$email = values.email) === null || _values$email === void 0 ? void 0 : (_values$email$trim = _values$email.trim()) === null || _values$email$trim === void 0 ? void 0 : _values$email$trim.toLowerCase()) || values !== null && values !== void 0 && (_values$ccEmailIDs = values.ccEmailIDs) !== null && _values$ccEmailIDs !== void 0 && _values$ccEmailIDs.find(function (ccEmailId) {
      var _ccEmailId$trim, _values$ccEmail2, _values$ccEmail2$trim;

      return (ccEmailId === null || ccEmailId === void 0 ? void 0 : (_ccEmailId$trim = ccEmailId.trim()) === null || _ccEmailId$trim === void 0 ? void 0 : _ccEmailId$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$ccEmail2 = values.ccEmail) === null || _values$ccEmail2 === void 0 ? void 0 : (_values$ccEmail2$trim = _values$ccEmail2.trim()) === null || _values$ccEmail2$trim === void 0 ? void 0 : _values$ccEmail2$trim.toLowerCase());
    }))) {
      errors.ccEmail = '* This email ID is already added';
    }

    return errors;
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setShowEmail(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  var SendEmailForm = function SendEmailForm(_ref3) {
    var _plans$filter2, _values$ccEmailIDs3, _values$ccEmailIDs4;

    _ref3.initialValues;
        var validate = _ref3.validate;
        _ref3.onSubmit;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(Label, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Select plans for which email has to be sent", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: 'error'
      }, "*"))
    }, /*#__PURE__*/React.createElement(Grid, {
      repeat: 3
    }, plans === null || plans === void 0 ? void 0 : (_plans$filter2 = plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _plans$filter2 === void 0 ? void 0 : _plans$filter2.map(function (plan, idx) {
      return /*#__PURE__*/React.createElement(GridItem, {
        key: idx,
        colSpan: 1
      }, /*#__PURE__*/React.createElement(QuantaCheckbox, {
        name: "plans[".concat(idx, "].isPlanChecked"),
        label: "".concat(plan === null || plan === void 0 ? void 0 : plan.name),
        disabled: loading
      }));
    }))), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "email",
      size: "full",
      type: "email",
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Email ID ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your email",
      disabled: loading
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "ccEmail",
      type: 'email',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, " CC/Reference Email IDs "),
      size: 'full',
      placeholder: 'Enter CC/Reference Email IDs',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref4, _evt$key, _evt$key$toString, _evt$key$toString$tri;

        if ((_ref4 = ['tab', 'enter', ',', ';']) !== null && _ref4 !== void 0 && _ref4.includes(evt === null || evt === void 0 ? void 0 : (_evt$key = evt.key) === null || _evt$key === void 0 ? void 0 : (_evt$key$toString = _evt$key.toString()) === null || _evt$key$toString === void 0 ? void 0 : (_evt$key$toString$tri = _evt$key$toString.trim()) === null || _evt$key$toString$tri === void 0 ? void 0 : _evt$key$toString$tri.toLowerCase())) {
          var _validate2;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.ccEmail && !((_validate2 = validate(values)) !== null && _validate2 !== void 0 && _validate2.ccEmail)) {
            var _values$ccEmail3;

            setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : (_values$ccEmail3 = values.ccEmail) === null || _values$ccEmail3 === void 0 ? void 0 : _values$ccEmail3.trim()]));
            setFieldValue("ccEmail", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        evt.preventDefault();
        var paste = evt.clipboardData.getData('text');
        var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

        if (emails) {
          var toBeAdded = emails.filter(function (email) {
            var _values$ccEmailIDs2;

            return !(values !== null && values !== void 0 && (_values$ccEmailIDs2 = values.ccEmailIDs) !== null && _values$ccEmailIDs2 !== void 0 && _values$ccEmailIDs2.includes(email)) && email !== (values === null || values === void 0 ? void 0 : values.email);
          });
          setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$ccEmailIDs3 = values.ccEmailIDs) === null || _values$ccEmailIDs3 === void 0 ? void 0 : _values$ccEmailIDs3.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$ccEmailIDs4 = values.ccEmailIDs) === null || _values$ccEmailIDs4 === void 0 ? void 0 : _values$ccEmailIDs4.map(function (ccEmailId, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$ccEmailIDs5, _values$ccEmailIDs6;

          return setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$ccEmailIDs5 = values.ccEmailIDs) === null || _values$ccEmailIDs5 === void 0 ? void 0 : _values$ccEmailIDs5.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$ccEmailIDs6 = values.ccEmailIDs) === null || _values$ccEmailIDs6 === void 0 ? void 0 : _values$ccEmailIDs6.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, ccEmailId);
    })), displayMessage && !loading ? /*#__PURE__*/React.createElement(Text, {
      severity: sentSuccess ? 'success' : 'error'
    }, displayMessage) : null, /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      className: "mt-4",
      disabled: loading,
      iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true,
        className: "ml-2"
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEnvelope,
        className: "ml-2"
      })
    }, loading ? "Sending..." : "Send Email"));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "medium",
    title: "Verify/Enter your email",
    severity: "action",
    onClose: function onClose() {
      onModalClose();
    },
    modalCloseDisabled: loading
  }, /*#__PURE__*/React.createElement(QuantaFormik, {
    enableReinitialise: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SendEmailForm, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  })));
}

var _templateObject;
var MOBILE_NUMBER_STARTING_WITH = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query mobileNumberStartingWith {\n    mobileNumberStartingWith {\n      code\n      value\n    }\n  }\n"])));

function ModalSendSms(_ref) {
  var _plans$filter;

  var setShowSms = _ref.setShowSms,
      showSms = _ref.showSms,
      initialMobile = _ref.initialMobile,
      getPayLoad = _ref.getPayLoad,
      plans = _ref.plans,
      SEND_SMS_QUERY = _ref.SEND_SMS_QUERY;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      displayMessage = _useState4[0],
      setDisplayMessage = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      sentSuccess = _useState6[0],
      setSentSuccess = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileNumberStartingWith = _useState8[0],
      setMobileNumberStartingWith = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loadingMobileNumberStartingWith = _useState10[0],
      setLoadingMobileNumberStartingWith = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      errorMobileNumberStartingWith = _useState12[0],
      setErrorMobileNumberStartingWith = _useState12[1];

  var fetchQuery = useFetchQuery();

  var _useMutation = useMutation(SEND_SMS_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setSentSuccess(true);
      setDisplayMessage((_data$ = data["".concat(Object.keys(data)[0])]) === null || _data$ === void 0 ? void 0 : _data$.message);
    },
    onError: function onError(_) {
      setSentSuccess(false);
      setDisplayMessage('Message send failed...Please try again after some time.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSendQuoteSMSAlert = _useMutation2[0],
      loading = _useMutation2[1].loading;

  useEffect(function () {
    var isMounted = true;

    if (showSms && isMounted && !mobileNumberStartingWith) {
      var _fetchQuery, _fetchQuery$then;

      setLoadingMobileNumberStartingWith(true);
      setErrorMobileNumberStartingWith(null);
      (_fetchQuery = fetchQuery({
        query: MOBILE_NUMBER_STARTING_WITH,
        fetchPolicy: 'cache-first'
      })) === null || _fetchQuery === void 0 ? void 0 : (_fetchQuery$then = _fetchQuery.then(function (response) {
        if (isMounted) {
          var _response$data;

          setLoadingMobileNumberStartingWith(false);
          setMobileNumberStartingWith(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.mobileNumberStartingWith);
        }
      })) === null || _fetchQuery$then === void 0 ? void 0 : _fetchQuery$then.catch(function (error) {
        if (isMounted) {
          setLoadingMobileNumberStartingWith(false);
          setErrorMobileNumberStartingWith(error === null || error === void 0 ? void 0 : error.message);
        }
      });
    }

    return function () {
      isMounted = false;
    };
  }, [showSms, mobileNumberStartingWith]);
  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showSms);
    }, 150);
    return function () {
      clearTimeout(timer);
      setDisplayMessage(null);
      setSentSuccess(true);
    };
  }, [showSms, setModalDisplay]);

  var onSubmit = function onSubmit(values, _ref2) {
    var _values$plans, _values$plans$filter;

    var setFieldValue = _ref2.setFieldValue;

    if ((values === null || values === void 0 ? void 0 : (_values$plans = values.plans) === null || _values$plans === void 0 ? void 0 : (_values$plans$filter = _values$plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
    })) === null || _values$plans$filter === void 0 ? void 0 : _values$plans$filter.length) === 0) {
      setSentSuccess(false);
      setDisplayMessage('Atleast one plan must be selected');
    } else {
      var _validate;

      setDisplayMessage(null);
      var variables = null;

      if (values !== null && values !== void 0 && values.alternateMobile && !((_validate = validate(values)) !== null && _validate !== void 0 && _validate.alternateMobile)) {
        var _values$mode, _values$plans2, _values$mode2, _values$mode3, _values$mode4, _values$mode5, _values$mode6, _values$mode7, _values$mode8, _values$mode9;

        setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : values.alternateMobile]));
        setFieldValue("alternateMobile", '');
        variables = getPayLoad(values !== null && values !== void 0 && (_values$mode = values.mode) !== null && _values$mode !== void 0 && _values$mode.sms ? values.mobile : '', (_values$plans2 = values.plans) === null || _values$plans2 === void 0 ? void 0 : _values$plans2.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
        }), values !== null && values !== void 0 && (_values$mode2 = values.mode) !== null && _values$mode2 !== void 0 && _values$mode2.sms ? [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : values.alternateMobile]) : [], values !== null && values !== void 0 && values.isWhatsAppSameAsMobile && values !== null && values !== void 0 && (_values$mode3 = values.mode) !== null && _values$mode3 !== void 0 && _values$mode3.sms && values !== null && values !== void 0 && (_values$mode4 = values.mode) !== null && _values$mode4 !== void 0 && _values$mode4.whatsapp ? values === null || values === void 0 ? void 0 : values.mobile : values !== null && values !== void 0 && (_values$mode5 = values.mode) !== null && _values$mode5 !== void 0 && _values$mode5.whatsapp ? values === null || values === void 0 ? void 0 : values.whatsappNo : '', values !== null && values !== void 0 && (_values$mode6 = values.mode) !== null && _values$mode6 !== void 0 && _values$mode6.sms && values !== null && values !== void 0 && (_values$mode7 = values.mode) !== null && _values$mode7 !== void 0 && _values$mode7.whatsapp ? ['sms', 'whatsapp'] : !(values !== null && values !== void 0 && (_values$mode8 = values.mode) !== null && _values$mode8 !== void 0 && _values$mode8.sms) && values !== null && values !== void 0 && (_values$mode9 = values.mode) !== null && _values$mode9 !== void 0 && _values$mode9.whatsapp ? ['whatsapp'] : ['sms']);
      } else {
        var _values$mode10, _values$plans3, _values$mode11, _values$mode12, _values$mode13, _values$mode14, _values$mode15, _values$mode16, _values$mode17, _values$mode18;

        variables = getPayLoad(values !== null && values !== void 0 && (_values$mode10 = values.mode) !== null && _values$mode10 !== void 0 && _values$mode10.sms ? values.mobile : '', (_values$plans3 = values.plans) === null || _values$plans3 === void 0 ? void 0 : _values$plans3.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
        }), values !== null && values !== void 0 && (_values$mode11 = values.mode) !== null && _values$mode11 !== void 0 && _values$mode11.sms ? [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : values.alternateMobile]) : [], values !== null && values !== void 0 && values.isWhatsAppSameAsMobile && values !== null && values !== void 0 && (_values$mode12 = values.mode) !== null && _values$mode12 !== void 0 && _values$mode12.sms && values !== null && values !== void 0 && (_values$mode13 = values.mode) !== null && _values$mode13 !== void 0 && _values$mode13.whatsapp ? values === null || values === void 0 ? void 0 : values.mobile : values !== null && values !== void 0 && (_values$mode14 = values.mode) !== null && _values$mode14 !== void 0 && _values$mode14.whatsapp ? values === null || values === void 0 ? void 0 : values.whatsappNo : '', values !== null && values !== void 0 && (_values$mode15 = values.mode) !== null && _values$mode15 !== void 0 && _values$mode15.sms && values !== null && values !== void 0 && (_values$mode16 = values.mode) !== null && _values$mode16 !== void 0 && _values$mode16.whatsapp ? ['sms', 'whatsapp'] : !(values !== null && values !== void 0 && (_values$mode17 = values.mode) !== null && _values$mode17 !== void 0 && _values$mode17.sms) && values !== null && values !== void 0 && (_values$mode18 = values.mode) !== null && _values$mode18 !== void 0 && _values$mode18.whatsapp ? ['whatsapp'] : ['sms']);
      }

      doSendQuoteSMSAlert({
        variables: variables
      });
    }
  };

  var initialValues = {
    mobile: initialMobile ? initialMobile : '',
    alternateMobile: '',
    alternateMobileNos: [],
    plans: _toConsumableArray(plans === null || plans === void 0 ? void 0 : (_plans$filter = plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _plans$filter === void 0 ? void 0 : _plans$filter.map(function (plan) {
      return _objectSpread2(_objectSpread2({}, plan), {}, {
        isPlanChecked: true
      });
    })),
    whatsappNo: initialMobile ? initialMobile : '',
    isWhatsAppSameAsMobile: true,
    mode: {
      sms: true,
      whatsapp: false
    }
  };

  var validate = function validate(values) {
    var _values$alternateMobi, _values$alternateMobi2, _values$alternateMobi3, _values$alternateMobi4, _values$mobile, _values$mobile$trim, _values$alternateMobi5, _values$mode19;

    var errors = {};

    if (!values.mobile) {
      errors.mobile = 'Required';
    } else if (values.mobile.toString().length !== 10 || !values.mobile.toString().match(/^[0-9]+$/)) {
      errors.mobile = '* Mobile number must be of 10 digits';
    }

    if (values !== null && values !== void 0 && values.alternateMobile && (values.alternateMobile.toString().length !== 10 || !(values !== null && values !== void 0 && (_values$alternateMobi = values.alternateMobile) !== null && _values$alternateMobi !== void 0 && (_values$alternateMobi2 = _values$alternateMobi.toString()) !== null && _values$alternateMobi2 !== void 0 && _values$alternateMobi2.match(/^[0-9]+$/)))) {
      errors.alternateMobile = '* Mobile number must be of 10 digits';
    } else if (values !== null && values !== void 0 && values.alternateMobile && ((values === null || values === void 0 ? void 0 : (_values$alternateMobi3 = values.alternateMobile) === null || _values$alternateMobi3 === void 0 ? void 0 : (_values$alternateMobi4 = _values$alternateMobi3.trim()) === null || _values$alternateMobi4 === void 0 ? void 0 : _values$alternateMobi4.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$mobile = values.mobile) === null || _values$mobile === void 0 ? void 0 : (_values$mobile$trim = _values$mobile.trim()) === null || _values$mobile$trim === void 0 ? void 0 : _values$mobile$trim.toLowerCase()) || values !== null && values !== void 0 && (_values$alternateMobi5 = values.alternateMobileNos) !== null && _values$alternateMobi5 !== void 0 && _values$alternateMobi5.find(function (alternateMob) {
      var _alternateMob$trim, _values$alternateMobi6, _values$alternateMobi7;

      return (alternateMob === null || alternateMob === void 0 ? void 0 : (_alternateMob$trim = alternateMob.trim()) === null || _alternateMob$trim === void 0 ? void 0 : _alternateMob$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$alternateMobi6 = values.alternateMobile) === null || _values$alternateMobi6 === void 0 ? void 0 : (_values$alternateMobi7 = _values$alternateMobi6.trim()) === null || _values$alternateMobi7 === void 0 ? void 0 : _values$alternateMobi7.toLowerCase());
    }))) {
      errors.alternateMobile = '* This mobile no is already added';
    }

    if (values !== null && values !== void 0 && (_values$mode19 = values.mode) !== null && _values$mode19 !== void 0 && _values$mode19.whatsapp) {
      var _values$mode20, _values$mode21, _values$mobile2, _values$whatsappNo;

      if (!(values !== null && values !== void 0 && values.whatsappNo)) {
        errors.whatsappNo = '* Required';
      } else if (!(values !== null && values !== void 0 && values.isWhatsAppSameAsMobile) && values !== null && values !== void 0 && (_values$mode20 = values.mode) !== null && _values$mode20 !== void 0 && _values$mode20.sms && values !== null && values !== void 0 && (_values$mode21 = values.mode) !== null && _values$mode21 !== void 0 && _values$mode21.whatsapp && (values === null || values === void 0 ? void 0 : (_values$mobile2 = values.mobile) === null || _values$mobile2 === void 0 ? void 0 : _values$mobile2.toString()) === (values === null || values === void 0 ? void 0 : (_values$whatsappNo = values.whatsappNo) === null || _values$whatsappNo === void 0 ? void 0 : _values$whatsappNo.toString())) {
        errors.whatsappNo = '* WhatsApp No cannot be same as mobile no';
      } else if (parseInt(values === null || values === void 0 ? void 0 : values.whatsappNo[0]) < parseInt(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value)) {
        errors.whatsappNo = "* WhatsApp No must start with digit ".concat(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value, " to 9");
      } else if (values.whatsappNo.toString().length !== 10 || !values.whatsappNo.toString().match(/^[0-9]+$/)) {
        errors.whatsappNo = '* WhatsApp No must be of 10 digits';
      }
    }

    return errors;
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setShowSms(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  var SendSMSForm = function SendSMSForm(_ref3) {
    var _plans$filter2, _values$mode22, _values$mode23, _values$mode24, _values$mode25, _values$alternateMobi10, _values$alternateMobi11, _values$mode26, _values$mode27, _values$alternateMobi16, _values$alternateMobi17, _values$mode28, _values$mode29, _values$mode30, _values$mode31, _values$mode32, _values$mode33, _values$mode34, _values$mode35, _values$mode36, _values$mode37, _values$mode38, _values$mode39;

    _ref3.initialValues;
        var validate = _ref3.validate;
        _ref3.onSubmit;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(Label, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Select plans for which SMS has to be sent", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: 'error'
      }, "*"))
    }, /*#__PURE__*/React.createElement(Grid, {
      repeat: 3
    }, plans === null || plans === void 0 ? void 0 : (_plans$filter2 = plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _plans$filter2 === void 0 ? void 0 : _plans$filter2.map(function (plan, idx) {
      return /*#__PURE__*/React.createElement(GridItem, {
        key: idx,
        colSpan: 1
      }, /*#__PURE__*/React.createElement(QuantaCheckbox, {
        name: "plans[".concat(idx, "].isPlanChecked"),
        label: "".concat(plan === null || plan === void 0 ? void 0 : plan.name),
        disabled: loading
      }));
    }))), /*#__PURE__*/React.createElement(Label, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Select the mode of sending quote details", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: 'error'
      }, "*"))
    }, /*#__PURE__*/React.createElement(Grid, {
      repeat: 3
    }, /*#__PURE__*/React.createElement(GridItem, {
      colSpan: 1
    }, /*#__PURE__*/React.createElement(QuantaCheckbox, {
      name: 'mode.sms',
      label: "SMS",
      disabled: loading
    })))), values !== null && values !== void 0 && (_values$mode22 = values.mode) !== null && _values$mode22 !== void 0 && _values$mode22.whatsapp && !(values !== null && values !== void 0 && (_values$mode23 = values.mode) !== null && _values$mode23 !== void 0 && _values$mode23.sms) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "whatsappNo",
      disabled: loading,
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "WhatsApp No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your WhatsApp Number"
    })) : !(values !== null && values !== void 0 && (_values$mode24 = values.mode) !== null && _values$mode24 !== void 0 && _values$mode24.whatsapp) && values !== null && values !== void 0 && (_values$mode25 = values.mode) !== null && _values$mode25 !== void 0 && _values$mode25.sms ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "mobile",
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Mobile No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your mobile Number",
      disabled: loading
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "alternateMobile",
      type: 'text',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Alternative Mobile Nos"),
      size: 'full',
      placeholder: 'Enter alternative numbers for SMS',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref4, _evt$key, _evt$key$toString, _evt$key$toString$tri;

        if ((_ref4 = ['tab', 'enter', ',', ';']) !== null && _ref4 !== void 0 && _ref4.includes(evt === null || evt === void 0 ? void 0 : (_evt$key = evt.key) === null || _evt$key === void 0 ? void 0 : (_evt$key$toString = _evt$key.toString()) === null || _evt$key$toString === void 0 ? void 0 : (_evt$key$toString$tri = _evt$key$toString.trim()) === null || _evt$key$toString$tri === void 0 ? void 0 : _evt$key$toString$tri.toLowerCase())) {
          var _validate2;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.alternateMobile && !((_validate2 = validate(values)) !== null && _validate2 !== void 0 && _validate2.alternateMobile)) {
            var _values$alternateMobi8;

            setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : (_values$alternateMobi8 = values.alternateMobile) === null || _values$alternateMobi8 === void 0 ? void 0 : _values$alternateMobi8.trim()]));
            setFieldValue("alternateMobile", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        var _evt$clipboardData$ge, _evt$clipboardData$ge2;

        evt.preventDefault();
        var paste = (_evt$clipboardData$ge = evt.clipboardData.getData('text')) === null || _evt$clipboardData$ge === void 0 ? void 0 : (_evt$clipboardData$ge2 = _evt$clipboardData$ge.toString()) === null || _evt$clipboardData$ge2 === void 0 ? void 0 : _evt$clipboardData$ge2.trim();
        var phones = paste.match(/[0-9]{10}/g);

        if (phones) {
          var toBeAdded = phones.filter(function (phone) {
            var _values$alternateMobi9;

            return !(values !== null && values !== void 0 && (_values$alternateMobi9 = values.alternateMobileNos) !== null && _values$alternateMobi9 !== void 0 && _values$alternateMobi9.includes(phone)) && phone !== (values === null || values === void 0 ? void 0 : values.mobile);
          });
          setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$alternateMobi10 = values.alternateMobileNos) === null || _values$alternateMobi10 === void 0 ? void 0 : _values$alternateMobi10.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$alternateMobi11 = values.alternateMobileNos) === null || _values$alternateMobi11 === void 0 ? void 0 : _values$alternateMobi11.map(function (alternateMobile, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$alternateMobi12, _values$alternateMobi13;

          return setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi12 = values.alternateMobileNos) === null || _values$alternateMobi12 === void 0 ? void 0 : _values$alternateMobi12.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi13 = values.alternateMobileNos) === null || _values$alternateMobi13 === void 0 ? void 0 : _values$alternateMobi13.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, alternateMobile);
    }))) : values !== null && values !== void 0 && (_values$mode26 = values.mode) !== null && _values$mode26 !== void 0 && _values$mode26.whatsapp && values !== null && values !== void 0 && (_values$mode27 = values.mode) !== null && _values$mode27 !== void 0 && _values$mode27.sms ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "mobile",
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Mobile No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your mobile Number",
      disabled: loading
    }), /*#__PURE__*/React.createElement(QuantaCheckbox, {
      name: 'isWhatsAppSameAsMobile',
      label: "WhatsApp no. same as mobile no.",
      disabled: loading,
      onDataChange: function onDataChange(val) {
        if (!val) {
          setFieldValue('whatsappNo', '');
        } else {
          setFieldValue('whatsappNo', values === null || values === void 0 ? void 0 : values.mobile);
        }
      }
    }), !(values !== null && values !== void 0 && values.isWhatsAppSameAsMobile) && /*#__PURE__*/React.createElement(QuantaInput, {
      name: "whatsappNo",
      disabled: loading,
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "WhatsApp No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your WhatsApp Number"
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "alternateMobile",
      type: 'text',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Alternative Mobile Nos"),
      size: 'full',
      placeholder: 'Enter alternative numbers for SMS',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref5, _evt$key2, _evt$key2$toString, _evt$key2$toString$tr;

        if ((_ref5 = ['tab', 'enter', ',', ';']) !== null && _ref5 !== void 0 && _ref5.includes(evt === null || evt === void 0 ? void 0 : (_evt$key2 = evt.key) === null || _evt$key2 === void 0 ? void 0 : (_evt$key2$toString = _evt$key2.toString()) === null || _evt$key2$toString === void 0 ? void 0 : (_evt$key2$toString$tr = _evt$key2$toString.trim()) === null || _evt$key2$toString$tr === void 0 ? void 0 : _evt$key2$toString$tr.toLowerCase())) {
          var _validate3;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.alternateMobile && !((_validate3 = validate(values)) !== null && _validate3 !== void 0 && _validate3.alternateMobile)) {
            var _values$alternateMobi14;

            setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : (_values$alternateMobi14 = values.alternateMobile) === null || _values$alternateMobi14 === void 0 ? void 0 : _values$alternateMobi14.trim()]));
            setFieldValue("alternateMobile", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        var _evt$clipboardData$ge3, _evt$clipboardData$ge4;

        evt.preventDefault();
        var paste = (_evt$clipboardData$ge3 = evt.clipboardData.getData('text')) === null || _evt$clipboardData$ge3 === void 0 ? void 0 : (_evt$clipboardData$ge4 = _evt$clipboardData$ge3.toString()) === null || _evt$clipboardData$ge4 === void 0 ? void 0 : _evt$clipboardData$ge4.trim();
        var phones = paste.match(/[0-9]{10}/g);

        if (phones) {
          var toBeAdded = phones.filter(function (phone) {
            var _values$alternateMobi15;

            return !(values !== null && values !== void 0 && (_values$alternateMobi15 = values.alternateMobileNos) !== null && _values$alternateMobi15 !== void 0 && _values$alternateMobi15.includes(phone)) && phone !== (values === null || values === void 0 ? void 0 : values.mobile);
          });
          setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$alternateMobi16 = values.alternateMobileNos) === null || _values$alternateMobi16 === void 0 ? void 0 : _values$alternateMobi16.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$alternateMobi17 = values.alternateMobileNos) === null || _values$alternateMobi17 === void 0 ? void 0 : _values$alternateMobi17.map(function (alternateMobile, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$alternateMobi18, _values$alternateMobi19;

          return setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi18 = values.alternateMobileNos) === null || _values$alternateMobi18 === void 0 ? void 0 : _values$alternateMobi18.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi19 = values.alternateMobileNos) === null || _values$alternateMobi19 === void 0 ? void 0 : _values$alternateMobi19.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, alternateMobile);
    }))) : null, displayMessage && !loading ? /*#__PURE__*/React.createElement(Text, {
      severity: sentSuccess ? 'success' : 'error'
    }, displayMessage) : /*#__PURE__*/React.createElement("div", null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      className: "mt-4",
      disabled: loading || !(values !== null && values !== void 0 && (_values$mode28 = values.mode) !== null && _values$mode28 !== void 0 && _values$mode28.sms) && !(values !== null && values !== void 0 && (_values$mode29 = values.mode) !== null && _values$mode29 !== void 0 && _values$mode29.whatsapp),
      iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true,
        className: "ml-2"
      }) : values !== null && values !== void 0 && (_values$mode30 = values.mode) !== null && _values$mode30 !== void 0 && _values$mode30.sms && values !== null && values !== void 0 && (_values$mode31 = values.mode) !== null && _values$mode31 !== void 0 && _values$mode31.whatsapp || values !== null && values !== void 0 && (_values$mode32 = values.mode) !== null && _values$mode32 !== void 0 && _values$mode32.sms && !(values !== null && values !== void 0 && (_values$mode33 = values.mode) !== null && _values$mode33 !== void 0 && _values$mode33.whatsapp) || !(values !== null && values !== void 0 && (_values$mode34 = values.mode) !== null && _values$mode34 !== void 0 && _values$mode34.sms) && !(values !== null && values !== void 0 && (_values$mode35 = values.mode) !== null && _values$mode35 !== void 0 && _values$mode35.whatsapp) ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSms,
        className: "ml-2"
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faWhatsapp,
        className: "ml-2"
      })
    }, loading ? "Sending..." : values !== null && values !== void 0 && (_values$mode36 = values.mode) !== null && _values$mode36 !== void 0 && _values$mode36.sms && values !== null && values !== void 0 && (_values$mode37 = values.mode) !== null && _values$mode37 !== void 0 && _values$mode37.whatsapp ? "Send SMS & WhatsApp" : values !== null && values !== void 0 && (_values$mode38 = values.mode) !== null && _values$mode38 !== void 0 && _values$mode38.sms ? "Send SMS" : values !== null && values !== void 0 && (_values$mode39 = values.mode) !== null && _values$mode39 !== void 0 && _values$mode39.whatsapp ? "Send WhatsApp" : "Send SMS"));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "medium",
    title: "Verify/Enter your Mobile Number",
    severity: "action",
    onClose: function onClose() {
      onModalClose();
    },
    modalCloseDisabled: loading
  }, loadingMobileNumberStartingWith && /*#__PURE__*/React.createElement(Loading, null), errorMobileNumberStartingWith && /*#__PURE__*/React.createElement(Error$1, {
    error: errorMobileNumberStartingWith
  }), mobileNumberStartingWith && !loadingMobileNumberStartingWith && !errorMobileNumberStartingWith && /*#__PURE__*/React.createElement(QuantaFormik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SendSMSForm, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  })));
}

function GetFieldUserName(_ref) {
  var code = _ref.code;

  var _useQuery = useQuery(LOOKUP_FIELDUSER, {
    variables: {
      filter: {
        fieldUserID: code
      }
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, {
    textSize: "normal",
    className: "flex flex-row justify-start space-x-2 text-opacity-50 text-primary w-full"
  });
  if (error) return /*#__PURE__*/React.createElement(Error$1, {
    className: "flex flex-row justify-start space-x-2 text-base text-opacity-50 text-red-600 w-full"
  });
  var associatedEntityLookup = data.associatedEntityLookup;
  return /*#__PURE__*/React.createElement(Text, null, associatedEntityLookup.fieldUserName);
}

var saveQuoteVariables = function saveQuoteVariables(lobCode, productCode, custData, quotationType, members, cover, healthPlans, location, existingPolicyNumber, isExistingEmployee, selectedIntermediary, intermediaryDetails, maternitySelectedCover, maternityMembers) {
  var _members$filter, _healthPlans$plans, _healthPlans$plans$fi;

  return {
    input: {
      quotationType: quotationType,
      intermediary: {
        intermediaryCode: (intermediaryDetails === null || intermediaryDetails === void 0 ? void 0 : intermediaryDetails.code) || selectedIntermediary.intermediaryCode,
        intermediaryName: (intermediaryDetails === null || intermediaryDetails === void 0 ? void 0 : intermediaryDetails.name) || selectedIntermediary.intermediaryName,
        locationCode: (intermediaryDetails === null || intermediaryDetails === void 0 ? void 0 : intermediaryDetails.location) || selectedIntermediary.branchOfficeCode,
        fieldUserCode: (intermediaryDetails === null || intermediaryDetails === void 0 ? void 0 : intermediaryDetails.fieldUserCode) || selectedIntermediary.fieldUserCode
      },
      quoteCreationDate: moment().format('YYYY-MM-DD').toString(),
      customer: custData,
      lob: lobCode,
      product: productCode,
      location: {
        pinCode: location === null || location === void 0 ? void 0 : location.pincode,
        state: location === null || location === void 0 ? void 0 : location.state,
        district: location === null || location === void 0 ? void 0 : location.district,
        city: location === null || location === void 0 ? void 0 : location.city,
        zone: location === null || location === void 0 ? void 0 : location.zone
      },
      members: members === null || members === void 0 ? void 0 : (_members$filter = members.filter(function (mem) {
        return mem.selected;
      })) === null || _members$filter === void 0 ? void 0 : _members$filter.map(function (member) {
        var _member$age;

        return {
          relationship: member === null || member === void 0 ? void 0 : member.relationship,
          gender: member === null || member === void 0 ? void 0 : member.gender,
          dob: member === null || member === void 0 ? void 0 : member.dob,
          age: member === null || member === void 0 ? void 0 : (_member$age = member.age) === null || _member$age === void 0 ? void 0 : _member$age.toString(),
          maternitySelected: member !== null && member !== void 0 && member.maternitySelected ? member === null || member === void 0 ? void 0 : member.maternitySelected : false
        };
      }),
      maternityMembers: maternityMembers === null || maternityMembers === void 0 ? void 0 : maternityMembers.map(function (plan) {
        var _plan$members;

        return {
          planName: plan === null || plan === void 0 ? void 0 : plan.planName,
          members: (_plan$members = plan.members) === null || _plan$members === void 0 ? void 0 : _plan$members.map(function (mem) {
            var _mem$age;

            return {
              relationship: mem.relationship,
              gender: mem.gender,
              dob: mem.dob,
              age: (_mem$age = mem.age) === null || _mem$age === void 0 ? void 0 : _mem$age.toString(),
              maternitySelected: mem.maternitySelected
            };
          })
        };
      }),
      cover: {
        type: cover === null || cover === void 0 ? void 0 : cover.type,
        sumInsured: parseInt(cover === null || cover === void 0 ? void 0 : cover.sum_insured),
        tenure: cover === null || cover === void 0 ? void 0 : cover.tenure
      },
      plans: healthPlans === null || healthPlans === void 0 ? void 0 : (_healthPlans$plans = healthPlans.plans) === null || _healthPlans$plans === void 0 ? void 0 : (_healthPlans$plans$fi = _healthPlans$plans.filter(function (plan) {
        return plan === null || plan === void 0 ? void 0 : plan.isSelected;
      })) === null || _healthPlans$plans$fi === void 0 ? void 0 : _healthPlans$plans$fi.map(function (plan) {
        var _plan$covers, _plan$packs, _plan$premium, _plan$premium2, _plan$premium3, _plan$premium4, _plan$premium5, _plan$premium6, _plan$premium7, _plan$premium7$breaku, _plan$premium8, _plan$premium8$loadin, _plan$premium9, _plan$premium9$discou;

        return {
          name: plan === null || plan === void 0 ? void 0 : plan.name,
          code: plan === null || plan === void 0 ? void 0 : plan.code,
          covers: plan === null || plan === void 0 ? void 0 : (_plan$covers = plan.covers) === null || _plan$covers === void 0 ? void 0 : _plan$covers.map(function (cover) {
            return {
              name: cover === null || cover === void 0 ? void 0 : cover.name,
              index: cover === null || cover === void 0 ? void 0 : cover.index
            };
          }),
          packs: plan === null || plan === void 0 ? void 0 : (_plan$packs = plan.packs) === null || _plan$packs === void 0 ? void 0 : _plan$packs.map(function (pack) {
            var _pack$addOnCovers;

            return {
              name: pack === null || pack === void 0 ? void 0 : pack.name,
              index: pack === null || pack === void 0 ? void 0 : pack.index,
              addOnCovers: pack === null || pack === void 0 ? void 0 : (_pack$addOnCovers = pack.addOnCovers) === null || _pack$addOnCovers === void 0 ? void 0 : _pack$addOnCovers.map(function (addOn) {
                return {
                  name: addOn === null || addOn === void 0 ? void 0 : addOn.name,
                  index: addOn === null || addOn === void 0 ? void 0 : addOn.index,
                  selected: addOn === null || addOn === void 0 ? void 0 : addOn.selected
                };
              })
            };
          }),
          premium: {
            basePremium: plan === null || plan === void 0 ? void 0 : (_plan$premium = plan.premium) === null || _plan$premium === void 0 ? void 0 : _plan$premium.basePremium,
            loadingDiscount: plan === null || plan === void 0 ? void 0 : (_plan$premium2 = plan.premium) === null || _plan$premium2 === void 0 ? void 0 : _plan$premium2.loadingDiscount,
            netPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium3 = plan.premium) === null || _plan$premium3 === void 0 ? void 0 : _plan$premium3.netPremium,
            gst: plan === null || plan === void 0 ? void 0 : (_plan$premium4 = plan.premium) === null || _plan$premium4 === void 0 ? void 0 : _plan$premium4.gst,
            stampDuty: plan === null || plan === void 0 ? void 0 : (_plan$premium5 = plan.premium) === null || _plan$premium5 === void 0 ? void 0 : _plan$premium5.stampDuty,
            totalPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium6 = plan.premium) === null || _plan$premium6 === void 0 ? void 0 : _plan$premium6.totalPremium,
            breakup: plan === null || plan === void 0 ? void 0 : (_plan$premium7 = plan.premium) === null || _plan$premium7 === void 0 ? void 0 : (_plan$premium7$breaku = _plan$premium7.breakup) === null || _plan$premium7$breaku === void 0 ? void 0 : _plan$premium7$breaku.map(function (brkup) {
              return {
                relationship: brkup === null || brkup === void 0 ? void 0 : brkup.relationship,
                gender: brkup === null || brkup === void 0 ? void 0 : brkup.gender,
                age: brkup === null || brkup === void 0 ? void 0 : brkup.age,
                premium: brkup === null || brkup === void 0 ? void 0 : brkup.premium
              };
            }),
            loading: plan === null || plan === void 0 ? void 0 : (_plan$premium8 = plan.premium) === null || _plan$premium8 === void 0 ? void 0 : (_plan$premium8$loadin = _plan$premium8.loading) === null || _plan$premium8$loadin === void 0 ? void 0 : _plan$premium8$loadin.map(function (loading) {
              return {
                name: loading === null || loading === void 0 ? void 0 : loading.name,
                amount: loading === null || loading === void 0 ? void 0 : loading.amount
              };
            }),
            discount: plan === null || plan === void 0 ? void 0 : (_plan$premium9 = plan.premium) === null || _plan$premium9 === void 0 ? void 0 : (_plan$premium9$discou = _plan$premium9.discount) === null || _plan$premium9$discou === void 0 ? void 0 : _plan$premium9$discou.map(function (discount) {
              return {
                name: discount === null || discount === void 0 ? void 0 : discount.name,
                amount: discount === null || discount === void 0 ? void 0 : discount.amount
              };
            })
          }
        };
      }),
      existingPolicyNumber: existingPolicyNumber,
      maternitySelectedCover: maternitySelectedCover == true ? true : false,
      isExistingEmployee: (isExistingEmployee === null || isExistingEmployee === void 0 ? void 0 : isExistingEmployee.toLowerCase()) === 'yes' ? true : false
    }
  };
};

var reformData = function reformData(val, returnType, isString) {
  return val && val.toString().trim() !== '' ? isString === undefined || isString === true ? "".concat(val) : val : returnType;
};

var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
  return domainArr.find(function (d) {
    var _d$, _d$$toString, _searchText$toString;

    return ((_d$ = d["".concat(searchType)]) === null || _d$ === void 0 ? void 0 : (_d$$toString = _d$.toString()) === null || _d$$toString === void 0 ? void 0 : _d$$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString = searchText.toString()) === null || _searchText$toString === void 0 ? void 0 : _searchText$toString.toLowerCase());
  }) ? domainArr.find(function (d) {
    var _d$2, _d$2$toString, _searchText$toString2;

    return ((_d$2 = d["".concat(searchType)]) === null || _d$2 === void 0 ? void 0 : (_d$2$toString = _d$2.toString()) === null || _d$2$toString === void 0 ? void 0 : _d$2$toString.toLowerCase()) === (searchText === null || searchText === void 0 ? void 0 : (_searchText$toString2 = searchText.toString()) === null || _searchText$toString2 === void 0 ? void 0 : _searchText$toString2.toLowerCase());
  })["".concat(returnType)] : '';
};

function NewCustomerForm(_ref) {
  var validate = _ref.validate,
      setLocalNewCustomerValues = _ref.setLocalNewCustomerValues,
      setDropdownDetails = _ref.setDropdownDetails,
      onModalClose = _ref.onModalClose,
      lobCode = _ref.lobCode,
      productCode = _ref.productCode,
      setCustomerNameQuoteSaved = _ref.setCustomerNameQuoteSaved,
      doSaveQuote = _ref.doSaveQuote,
      selectedIntermediary = _ref.selectedIntermediary,
      setEnableReinitialize = _ref.setEnableReinitialize;

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var fetchQuery = useFetchQuery();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loadingHealthQuotePlans = _useState2[0],
      setLoadingHealthQuotePlans = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorHealthQuotePlans = _useState4[0],
      setErrorHealthQuotePlans = _useState4[1];

  var _useQuery = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: function onCompleted(data) {
      return setDropdownDetails(data);
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      dropDownDetails = _useQuery.data;

  var _useQuery2 = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loading_cust_type_domain = _useQuery2.loading,
      error_cust_type_domain = _useQuery2.error,
      data_cust_type_domain = _useQuery2.data;

  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 4
  });
  useResponsiveParams({
    for_mobile: true,
    for_desktop: false
  });

  if (loading || loading_cust_type_domain) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-full"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error || error_cust_type_domain) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-full"
    }, /*#__PURE__*/React.createElement(Error$1, {
      error: error || error_cust_type_domain
    }));
  }

  var newCustomerData = [{
    title: '',
    grid_data: [{
      type: 'select-tabs',
      name: 'customerType',
      colSpan: repeat,
      size: 'large',
      data: [{
        icon: function icon() {
          return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUserTag
          });
        },
        label: 'Individual',
        value: data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') : '',
        onFieldChange: function onFieldChange(values, _) {
          setEnableReinitialize(false);

          if (values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code')) {
            Object.keys(values.orgDetails).forEach(function (k) {
              setFieldValue("orgDetails.".concat(k), '');
            });
            setLocalNewCustomerValues({
              customerType: getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code')
            });
          }
        }
      }, {
        icon: function icon() {
          return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faBuilding
          });
        },
        label: 'Organisation',
        value: data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code') : '',
        onFieldChange: function onFieldChange(values, _) {
          setEnableReinitialize(false);

          if (values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code')) {
            Object.keys(values.indvDetails).forEach(function (k) {
              setFieldValue("indvDetails.".concat(k), '');
            });
            setLocalNewCustomerValues({
              customerType: getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code')
            });
          }
        }
      }]
    }].concat(_toConsumableArray(values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? [{
      type: 'select',
      name: 'indvDetails.title',
      label: /*#__PURE__*/React.createElement("div", null, "Title ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      searchable: true,
      data: dropDownDetails !== null && dropDownDetails !== void 0 && dropDownDetails.salutationList ? _toConsumableArray(dropDownDetails.salutationList.map(function (s) {
        return {
          label: s.value ? s.value : '',
          value: s.code ? s.code : ''
        };
      })) : []
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "First Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'indvDetails.firstName',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target, _evt$target$value, _evt$target$value$toS, _evt$target2, _evt$target2$value, _evt$target2$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target = evt.target) !== null && _evt$target !== void 0 && (_evt$target$value = _evt$target.value) !== null && _evt$target$value !== void 0 && (_evt$target$value$toS = _evt$target$value.toString()) !== null && _evt$target$value$toS !== void 0 && _evt$target$value$toS.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target2 = evt.target) === null || _evt$target2 === void 0 ? void 0 : (_evt$target2$value = _evt$target2.value) === null || _evt$target2$value === void 0 ? void 0 : (_evt$target2$value$to = _evt$target2$value.toString()) === null || _evt$target2$value$to === void 0 ? void 0 : _evt$target2$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Middle Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'indvDetails.middleName',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target3, _evt$target3$value, _evt$target3$value$to, _evt$target4, _evt$target4$value, _evt$target4$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target3 = evt.target) !== null && _evt$target3 !== void 0 && (_evt$target3$value = _evt$target3.value) !== null && _evt$target3$value !== void 0 && (_evt$target3$value$to = _evt$target3$value.toString()) !== null && _evt$target3$value$to !== void 0 && _evt$target3$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target4 = evt.target) === null || _evt$target4 === void 0 ? void 0 : (_evt$target4$value = _evt$target4.value) === null || _evt$target4$value === void 0 ? void 0 : (_evt$target4$value$to = _evt$target4$value.toString()) === null || _evt$target4$value$to === void 0 ? void 0 : _evt$target4$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Last Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'indvDetails.lastName',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target5, _evt$target5$value, _evt$target5$value$to, _evt$target6, _evt$target6$value, _evt$target6$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target5 = evt.target) !== null && _evt$target5 !== void 0 && (_evt$target5$value = _evt$target5.value) !== null && _evt$target5$value !== void 0 && (_evt$target5$value$to = _evt$target5$value.toString()) !== null && _evt$target5$value$to !== void 0 && _evt$target5$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target6 = evt.target) === null || _evt$target6 === void 0 ? void 0 : (_evt$target6$value = _evt$target6.value) === null || _evt$target6$value === void 0 ? void 0 : (_evt$target6$value$to = _evt$target6$value.toString()) === null || _evt$target6$value$to === void 0 ? void 0 : _evt$target6$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'indvDetails.email'
    }, {
      type: 'text',
      maxLength: 10,
      label: /*#__PURE__*/React.createElement("div", null, "Mobile Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'indvDetails.mobileNumber'
    } // {
    //   type: 'date',
    //   maxdate: moment()
    //     .subtract(18, 'years')
    //     .subtract(1, 'days')
    //     .format('DD/MM/YYYY'),
    //   label: (
    //     <div>
    //       Date Of Birth <Text severity="error">*</Text>
    //     </div>
    //   ),
    //   name: 'indvDetails.dob',
    // },
    ] : [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'orgDetails.organisationName',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target7, _evt$target7$value, _evt$target7$value$to, _evt$target8, _evt$target8$value, _evt$target8$value$to;

        if (evt !== null && evt !== void 0 && (_evt$target7 = evt.target) !== null && _evt$target7 !== void 0 && (_evt$target7$value = _evt$target7.value) !== null && _evt$target7$value !== void 0 && (_evt$target7$value$to = _evt$target7$value.toString()) !== null && _evt$target7$value$to !== void 0 && _evt$target7$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target8 = evt.target) === null || _evt$target8 === void 0 ? void 0 : (_evt$target8$value = _evt$target8.value) === null || _evt$target8$value === void 0 ? void 0 : (_evt$target8$value$to = _evt$target8$value.toString()) === null || _evt$target8$value$to === void 0 ? void 0 : _evt$target8$value$to.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'select',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'orgDetails.organisationType',
      data: dropDownDetails !== null && dropDownDetails !== void 0 && dropDownDetails.organisationList ? _toConsumableArray(dropDownDetails.organisationList.map(function (orgType) {
        return {
          label: orgType.value ? orgType.value : '',
          value: orgType.code ? orgType.code : ''
        };
      })) : []
    }, {
      type: 'text',
      maxLength: 40,
      label: /*#__PURE__*/React.createElement("div", null, "Contact Person ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'orgDetails.contactPerson',
      onKeyDown: function onKeyDown(evt) {
        var _evt$target9, _evt$target9$value, _evt$target9$value$to, _evt$target10, _evt$target10$value, _evt$target10$value$t;

        if (evt !== null && evt !== void 0 && (_evt$target9 = evt.target) !== null && _evt$target9 !== void 0 && (_evt$target9$value = _evt$target9.value) !== null && _evt$target9$value !== void 0 && (_evt$target9$value$to = _evt$target9$value.toString()) !== null && _evt$target9$value$to !== void 0 && _evt$target9$value$to.endsWith(' ') && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ' || (evt === null || evt === void 0 ? void 0 : (_evt$target10 = evt.target) === null || _evt$target10 === void 0 ? void 0 : (_evt$target10$value = _evt$target10.value) === null || _evt$target10$value === void 0 ? void 0 : (_evt$target10$value$t = _evt$target10$value.toString()) === null || _evt$target10$value$t === void 0 ? void 0 : _evt$target10$value$t.length) === 0 && (evt === null || evt === void 0 ? void 0 : evt.key) === ' ') {
          evt.preventDefault();
        }
      }
    }, {
      type: 'text',
      maxLength: 10,
      label: /*#__PURE__*/React.createElement("div", null, "Mobile Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'orgDetails.mobileNumber'
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'orgDetails.email'
    }]))
  }];
  var other_props = {
    flow: 'cols',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info'
  };
  return /*#__PURE__*/React.createElement(QuantaForm, {
    className: "space-y-4 h-full w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:justify-between h-full pb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full"
  }, /*#__PURE__*/React.createElement(InputGridGroup, _objectSpread2({
    data: newCustomerData
  }, other_props))), /*#__PURE__*/React.createElement("div", {
    className: "h-full flex flex-row justify-end items-end"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    flat: false,
    type: "button",
    size: "medium",
    className: "w-32",
    disabled: loadingHealthQuotePlans ? loadingHealthQuotePlans : values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? Object.keys(validate(values).indvDetails).length !== 0 : Object.keys(validate(values).orgDetails).length !== 0,
    onClick: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
        var _values$indvDetails, _values$indvDetails2, _values$indvDetails3, _values$indvDetails4, _values$indvDetails5, _values$indvDetails6, _values$indvDetails7, _values$indvDetails8, _values$indvDetails9, _values$indvDetails10, _values$indvDetails11, _healthQuote$location, _healthQuote$location2, _healthQuote$location3, _healthQuote$location4, _values$orgDetails, _values$orgDetails2, _values$orgDetails3, _values$orgDetails4, _values$orgDetails5, _healthQuote$location5, _healthQuote$location6, _healthQuote$location7, _healthQuote$location8, _values$indvDetails12, _values$indvDetails13, _values$indvDetails14, _values$indvDetails15, _values$orgDetails6, fetchQueryState, _yield$fetchQueryStat, state, healthQuote, healthPlans, quotationType, members, location, cover, existingPolicyNumber, isExistingEmployee, intermediaryDetails, maternitySelectedCover, maternityMembers, customerData, variables;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                fetchQueryState = fetchQuery({
                  query: QUERY_STATE
                });
                setLoadingHealthQuotePlans(true);
                _context.next = 5;
                return fetchQueryState;

              case 5:
                _yield$fetchQueryStat = _context.sent;
                state = _yield$fetchQueryStat.data;
                healthQuote = state.healthQuote, healthPlans = state.healthPlans;
                quotationType = healthQuote.quotationType, members = healthQuote.members, location = healthQuote.location, cover = healthQuote.cover, existingPolicyNumber = healthQuote.existingPolicyNumber, isExistingEmployee = healthQuote.isExistingEmployee, intermediaryDetails = healthQuote.intermediaryDetails, maternitySelectedCover = healthQuote.maternitySelectedCover, maternityMembers = healthQuote.maternityMembers;
                setLoadingHealthQuotePlans(false);
                customerData = values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? {
                  id: null,
                  customerType: values.customerType,
                  title: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails = values.indvDetails) === null || _values$indvDetails === void 0 ? void 0 : _values$indvDetails.title, ''),
                  firstName: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails2 = values.indvDetails) === null || _values$indvDetails2 === void 0 ? void 0 : _values$indvDetails2.firstName, ''),
                  middleName: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails3 = values.indvDetails) === null || _values$indvDetails3 === void 0 ? void 0 : _values$indvDetails3.middleName, ''),
                  lastName: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails4 = values.indvDetails) === null || _values$indvDetails4 === void 0 ? void 0 : _values$indvDetails4.lastName, ''),
                  fullName: reformData([values === null || values === void 0 ? void 0 : (_values$indvDetails5 = values.indvDetails) === null || _values$indvDetails5 === void 0 ? void 0 : _values$indvDetails5.title.trim(), values === null || values === void 0 ? void 0 : (_values$indvDetails6 = values.indvDetails) === null || _values$indvDetails6 === void 0 ? void 0 : _values$indvDetails6.firstName.trim(), values === null || values === void 0 ? void 0 : (_values$indvDetails7 = values.indvDetails) === null || _values$indvDetails7 === void 0 ? void 0 : _values$indvDetails7.middleName.trim(), values === null || values === void 0 ? void 0 : (_values$indvDetails8 = values.indvDetails) === null || _values$indvDetails8 === void 0 ? void 0 : _values$indvDetails8.lastName.trim()].filter(function (n) {
                    return n;
                  }).join(' '), ''),
                  emailID: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails9 = values.indvDetails) === null || _values$indvDetails9 === void 0 ? void 0 : _values$indvDetails9.email, ''),
                  mobileNo: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails10 = values.indvDetails) === null || _values$indvDetails10 === void 0 ? void 0 : _values$indvDetails10.mobileNumber, ''),
                  proposerDOB: reformData(values === null || values === void 0 ? void 0 : (_values$indvDetails11 = values.indvDetails) === null || _values$indvDetails11 === void 0 ? void 0 : _values$indvDetails11.dob, ''),
                  permPincode: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location = healthQuote.location) === null || _healthQuote$location === void 0 ? void 0 : _healthQuote$location.pincode, ''),
                  permCityTownVillage: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location2 = healthQuote.location) === null || _healthQuote$location2 === void 0 ? void 0 : _healthQuote$location2.city, ''),
                  permState: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location3 = healthQuote.location) === null || _healthQuote$location3 === void 0 ? void 0 : _healthQuote$location3.state, ''),
                  permDistrict: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location4 = healthQuote.location) === null || _healthQuote$location4 === void 0 ? void 0 : _healthQuote$location4.district, ''),
                  permCommAddressYN: false
                } : {
                  id: null,
                  customerType: values.customerType,
                  orgName: reformData(values === null || values === void 0 ? void 0 : (_values$orgDetails = values.orgDetails) === null || _values$orgDetails === void 0 ? void 0 : _values$orgDetails.organisationName, ''),
                  orgType: reformData(values === null || values === void 0 ? void 0 : (_values$orgDetails2 = values.orgDetails) === null || _values$orgDetails2 === void 0 ? void 0 : _values$orgDetails2.organisationType, ''),
                  contactName: reformData(values === null || values === void 0 ? void 0 : (_values$orgDetails3 = values.orgDetails) === null || _values$orgDetails3 === void 0 ? void 0 : _values$orgDetails3.contactPerson, ''),
                  mobileNo: reformData(values === null || values === void 0 ? void 0 : (_values$orgDetails4 = values.orgDetails) === null || _values$orgDetails4 === void 0 ? void 0 : _values$orgDetails4.mobileNumber, ''),
                  emailID: reformData(values === null || values === void 0 ? void 0 : (_values$orgDetails5 = values.orgDetails) === null || _values$orgDetails5 === void 0 ? void 0 : _values$orgDetails5.email, ''),
                  permPincode: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location5 = healthQuote.location) === null || _healthQuote$location5 === void 0 ? void 0 : _healthQuote$location5.pincode, ''),
                  permCityTownVillage: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location6 = healthQuote.location) === null || _healthQuote$location6 === void 0 ? void 0 : _healthQuote$location6.city, ''),
                  permState: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location7 = healthQuote.location) === null || _healthQuote$location7 === void 0 ? void 0 : _healthQuote$location7.state, ''),
                  permDistrict: reformData(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location8 = healthQuote.location) === null || _healthQuote$location8 === void 0 ? void 0 : _healthQuote$location8.district, ''),
                  permCommAddressYN: false
                };
                variables = saveQuoteVariables(lobCode, productCode, customerData, quotationType, members, cover, healthPlans, location, existingPolicyNumber, isExistingEmployee, selectedIntermediary, intermediaryDetails, maternitySelectedCover, maternityMembers);
                setCustomerNameQuoteSaved(values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? "".concat(values === null || values === void 0 ? void 0 : (_values$indvDetails12 = values.indvDetails) === null || _values$indvDetails12 === void 0 ? void 0 : _values$indvDetails12.title, " ").concat(values === null || values === void 0 ? void 0 : (_values$indvDetails13 = values.indvDetails) === null || _values$indvDetails13 === void 0 ? void 0 : _values$indvDetails13.firstName).concat(values !== null && values !== void 0 && (_values$indvDetails14 = values.indvDetails) !== null && _values$indvDetails14 !== void 0 && _values$indvDetails14.middleName ? " ".concat(values.indvDetails.middleName, " ") : ' ').concat(values === null || values === void 0 ? void 0 : (_values$indvDetails15 = values.indvDetails) === null || _values$indvDetails15 === void 0 ? void 0 : _values$indvDetails15.lastName) : values === null || values === void 0 ? void 0 : (_values$orgDetails6 = values.orgDetails) === null || _values$orgDetails6 === void 0 ? void 0 : _values$orgDetails6.organisationName);
                doSaveQuote({
                  variables: variables
                });
                updateCustomerInformation({
                  customer: customerData,
                  customerMeta: {
                    crn: '',
                    isNewCustomer: true,
                    ifscCode: '',
                    bankName: '',
                    branchName: '',
                    bankAcno: '',
                    accountHolderName: '',
                    micrCode: ''
                  }
                });
                updateHealthQuote({
                  isQuoteSaving: true
                });
                onModalClose();
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                setLoadingHealthQuotePlans(false);
                setErrorHealthQuotePlans(_context.t0.message);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    iconPre: loadingHealthQuotePlans ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true,
      className: "ml-4 text-secondary"
    }) : errorHealthQuotePlans ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faExclamationTriangle,
      className: "ml-4"
    }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSave,
      className: "ml-4"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "pl-1 text-base"
  }, "Save"))))));
}

function ModalSaveQuote(_ref3) {
  var _localExistingCustome, _localExistingCustome2, _localExistingCustome5, _getDomainData5;

  var saveQuoteDisplay = _ref3.saveQuoteDisplay,
      setSaveQuoteDisplay = _ref3.setSaveQuoteDisplay,
      setCustomerNameQuoteSaved = _ref3.setCustomerNameQuoteSaved,
      doSaveQuote = _ref3.doSaveQuote,
      productCode = _ref3.productCode,
      lobCode = _ref3.lobCode,
      selectedIntermediary = _ref3.selectedIntermediary;

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      CRSL = _useState6[0],
      setCRSL = _useState6[1];

  var _useQuery3 = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loading_cust_type_domain = _useQuery3.loading,
      error_cust_type_domain = _useQuery3.error,
      data_cust_type_domain = _useQuery3.data;

  var _useQuery4 = useQuery(MOBILE_NUMBER_STARTING_WITH$1, {
    fetchPolicy: 'cache-first'
  }),
      loading_mobile_number_starting_with = _useQuery4.loading,
      error_mobile_number_starting_with = _useQuery4.error,
      data_mobile_number_starting_with = _useQuery4.data;

  var _useQuery5 = useQuery(QUERY_STATE, {
    fetchPolicy: 'cache-first'
  });
      _useQuery5.loading;
      _useQuery5.error;
      var state1 = _useQuery5.data;

  var _useQuery6 = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loading_character_limit = _useQuery6.loading,
      error_character_limit = _useQuery6.error,
      data_character_limit = _useQuery6.data;

  var screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop'
  });

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      modalDisplay = _useState8[0],
      setModalDisplay = _useState8[1];

  var _useState9 = useState({
    searchType: 'Mobile Number'
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      localExistingCustomerValues = _useState10[0],
      setLocalExistingCustomerValues = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      enableReinitialize = _useState12[0],
      setEnableReinitialize = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      localNewCustomerValues = _useState14[0],
      setLocalNewCustomerValues = _useState14[1];

  var fetchQuery = useFetchQuery();

  var _useContext = useContext(ConfigContext);
      _useContext.branding;

  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(saveQuoteDisplay);
    }, 150);
    return function () {
      return clearTimeout(timer);
    };
  }, [saveQuoteDisplay, setModalDisplay]);

  var _useState15 = useState({
    type: '',
    message: ''
  }),
      _useState16 = _slicedToArray(_useState15, 2),
      customerSearchMetaMessage = _useState16[0],
      setCustomerSearchMetaMessage = _useState16[1];

  var _useState17 = useState(true),
      _useState18 = _slicedToArray(_useState17, 2),
      isIdleDisplay = _useState18[0],
      setIdleDisplay = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      existingCustomers = _useState20[0],
      setExistingCustomers = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      loadingExistingCustomers = _useState22[0],
      setLoadingExistingCustomers = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      customerDropdownDetails = _useState24[0],
      setDropdownDetails = _useState24[1];

  var _useState25 = useState({
    existingCustomers: ''
  }),
      _useState26 = _slicedToArray(_useState25, 2),
      errors = _useState26[0],
      setErrors = _useState26[1];

  var getSearchTextPlaceholder = function getSearchTextPlaceholder(searchType, customerType) {
    switch (searchType) {
      case 'Customer Number':
        return 'Enter customer ID to search.';
      // case 'Customer Name':
      //   return customerType ===
      //     getDomainData(
      //       data_cust_type_domain?.customerTypeList,
      //       'Individual',
      //       'value',
      //       'code',
      //     ) || !customerType
      //     ? 'Enter customer name to search.'
      //     : 'Enter organisation name to search.';

      case 'Mobile Number':
        return "Enter customer's mobile number to search.";

      case 'PAN No':
        return searchType === 'Individual' ? 'Enter PAN Number to search...' : 'Enter PAN Number to search...';

      case 'CKYC Id':
        return "Enter customer's CKYC ID to search...";

      default:
        return customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') || !customerType ? "Enter customer's CKYC No. to search" : "Enter customer's CKYC No. to search";
    }
  };

  var getSearchObject = function getSearchObject(customerType, searchType, searchString) {
    return {
      customer_type: customerType,
      customer_number: searchType === 'Customer Number' ? searchString : undefined,
      // customer_name:
      //   searchType === 'Customer Name' ? searchString : undefined,
      mobile: searchType === 'Mobile Number' ? searchString : undefined,
      ckyc_id: searchType === 'CKYC Id' ? searchString : undefined,
      pan_no: searchType === 'PAN No' ? searchString : undefined
    };
  };

  var validateNewCustomer = function validateNewCustomer(values) {
    var errors = {};

    if (values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code')) {
      var _data_mobile_number_s, _data_character_limit, _data_character_limit2, _data_character_limit3, _getDomainData, _values$indvDetails16, _values$indvDetails$g, _getDomainData2, _values$indvDetails17, _getDomainData3, _getDomainData4;

      errors.indvDetails = {};
      var mobileNumberValue = data_mobile_number_starting_with === null || data_mobile_number_starting_with === void 0 ? void 0 : (_data_mobile_number_s = data_mobile_number_starting_with.mobileNumberStartingWith) === null || _data_mobile_number_s === void 0 ? void 0 : _data_mobile_number_s.value;
      var firstNameValue = data_character_limit === null || data_character_limit === void 0 ? void 0 : (_data_character_limit = data_character_limit.characterLimitList) === null || _data_character_limit === void 0 ? void 0 : _data_character_limit.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'first name';
      });
      var middleNameValue = data_character_limit === null || data_character_limit === void 0 ? void 0 : (_data_character_limit2 = data_character_limit.characterLimitList) === null || _data_character_limit2 === void 0 ? void 0 : _data_character_limit2.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'middle name';
      });
      var lastNameValue = data_character_limit === null || data_character_limit === void 0 ? void 0 : (_data_character_limit3 = data_character_limit.characterLimitList) === null || _data_character_limit3 === void 0 ? void 0 : _data_character_limit3.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'last name';
      });

      if (!values.indvDetails.title) {
        errors.indvDetails.title = '* Required';
      }

      if (values.indvDetails.title && customerDropdownDetails && customerDropdownDetails.salutationList && values.indvDetails.title !== getDomainData(customerDropdownDetails.salutationList, values.indvDetails.title, 'value', 'code')) {
        errors.indvDetails.title = '* Enter a valid title';
      } else if (customerDropdownDetails && customerDropdownDetails.salutationList && (_getDomainData = getDomainData(customerDropdownDetails === null || customerDropdownDetails === void 0 ? void 0 : customerDropdownDetails.salutationList, values === null || values === void 0 ? void 0 : (_values$indvDetails16 = values.indvDetails) === null || _values$indvDetails16 === void 0 ? void 0 : _values$indvDetails16.title, 'code', 'gender')) !== null && _getDomainData !== void 0 && _getDomainData.toLowerCase() && ((_values$indvDetails$g = values.indvDetails.gender) === null || _values$indvDetails$g === void 0 ? void 0 : _values$indvDetails$g.toLowerCase()) !== ((_getDomainData2 = getDomainData(customerDropdownDetails === null || customerDropdownDetails === void 0 ? void 0 : customerDropdownDetails.salutationList, values === null || values === void 0 ? void 0 : (_values$indvDetails17 = values.indvDetails) === null || _values$indvDetails17 === void 0 ? void 0 : _values$indvDetails17.title, 'code', 'gender')) === null || _getDomainData2 === void 0 ? void 0 : _getDomainData2.toLowerCase()) && (((_getDomainData3 = getDomainData(customerDropdownDetails === null || customerDropdownDetails === void 0 ? void 0 : customerDropdownDetails.genderList, values.indvDetails.gender, 'code', 'value')) === null || _getDomainData3 === void 0 ? void 0 : _getDomainData3.toLowerCase()) === 'male' || ((_getDomainData4 = getDomainData(customerDropdownDetails === null || customerDropdownDetails === void 0 ? void 0 : customerDropdownDetails.genderList, values.indvDetails.gender, 'code', 'value')) === null || _getDomainData4 === void 0 ? void 0 : _getDomainData4.toLowerCase()) === 'female')) {
        errors.proposerDetails.title = '* Title mismatch with gender';
      }

      if (!values.indvDetails.firstName) {
        errors.indvDetails.firstName = '* Required';
      }

      if (values.indvDetails.firstName && !values.indvDetails.firstName.match(/^[a-zA-Z ]*$/)) {
        errors.indvDetails.firstName = '* First Name can contain alphabets only';
      }

      if (values.indvDetails.firstName && values.indvDetails.firstName.length > (firstNameValue === null || firstNameValue === void 0 ? void 0 : firstNameValue.value)) {
        errors.indvDetails.firstName = "* First Name cannot be greater than ".concat(firstNameValue === null || firstNameValue === void 0 ? void 0 : firstNameValue.value, " characters");
      }

      if (values.indvDetails.middleName && !values.indvDetails.middleName.match(/^[a-zA-Z ]*$/)) {
        errors.indvDetails.middleName = '* Middle name can contain alphabets only';
      }

      if (values.indvDetails.middleName && values.indvDetails.middleName.length > (middleNameValue === null || middleNameValue === void 0 ? void 0 : middleNameValue.value)) {
        errors.indvDetails.middleName = "* Middle Name cannot be greater than ".concat(middleNameValue === null || middleNameValue === void 0 ? void 0 : middleNameValue.value, " characters");
      }

      if (values.indvDetails.middleName && !values.indvDetails.middleName.match(/\d/) && !values.indvDetails.middleName.match(/^[a-zA-Z\s]+$/)) {
        errors.indvDetails.middleName = '* No special characters allowed';
      }

      if (!values.indvDetails.lastName) {
        errors.indvDetails.lastName = '* Required';
      }

      if (values.indvDetails.lastName && !values.indvDetails.lastName.match(/^[a-zA-Z. ]*$/)) {
        errors.indvDetails.lastName = '* Last name can contain alphabets only';
      }

      if (values.indvDetails.lastName && values.indvDetails.lastName.length > (lastNameValue === null || lastNameValue === void 0 ? void 0 : lastNameValue.value)) {
        errors.indvDetails.lastName = "* Last Name cannot be greater than ".concat(lastNameValue === null || lastNameValue === void 0 ? void 0 : lastNameValue.value, " characters");
      }

      if (!values.indvDetails.mobileNumber) {
        errors.indvDetails.mobileNumber = '* Required';
      }

      if (values.indvDetails.mobileNumber && values.indvDetails.mobileNumber.toString().slice(0, 1) < mobileNumberValue) {
        errors.indvDetails.mobileNumber = "* Mobile number must start with digit between ".concat(mobileNumberValue, " - 9");
      }

      if (values.indvDetails.mobileNumber && (values.indvDetails.mobileNumber.length !== 10 || !values.indvDetails.mobileNumber.match(/^[0-9]+$/))) {
        errors.indvDetails.mobileNumber = '* Mobile number must be of 10 digits';
      }

      if (!values.indvDetails.email) {
        errors.indvDetails.email = '* Required';
      }

      if (values.indvDetails.email) {
        var email_check = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!email_check.test(values.indvDetails.email)) {
          errors.indvDetails.email = '* Please enter valid email address';
        }
      } // if (!values.indvDetails.dob) {
      //   errors.indvDetails.dob = '* Required';
      // }
      // if (values.indvDetails.dob) {
      //   if (moment(values.indvDetails.dob, 'DD/MM/YYYY').isAfter()) {
      //     errors.indvDetails.dob =
      //       '* Date of Birth cannot be a future date';
      //   }
      // }

    } else {
      var _data_mobile_number_s2, _data_character_limit4;

      errors.orgDetails = {};
      var mobileNumberValue = data_mobile_number_starting_with === null || data_mobile_number_starting_with === void 0 ? void 0 : (_data_mobile_number_s2 = data_mobile_number_starting_with.mobileNumberStartingWith) === null || _data_mobile_number_s2 === void 0 ? void 0 : _data_mobile_number_s2.value;
      var orgNameValue = data_character_limit === null || data_character_limit === void 0 ? void 0 : (_data_character_limit4 = data_character_limit.characterLimitList) === null || _data_character_limit4 === void 0 ? void 0 : _data_character_limit4.find(function (characterLimit) {
        return characterLimit.code.toLowerCase() === 'org name';
      });

      if (!values.orgDetails.organisationName) {
        errors.orgDetails.organisationName = '* Required';
      }

      if (values.orgDetails.organisationName && !values.orgDetails.organisationName.match(/^[a-zA-Z ]*$/)) {
        errors.orgDetails.organisationName = '* Organisation name can contain alphabets only';
      }

      if (values.orgDetails.organisationName && values.orgDetails.organisationName.length > (orgNameValue === null || orgNameValue === void 0 ? void 0 : orgNameValue.value)) {
        errors.orgDetails.organisationName = "* Organisation Name cannot be greater than ".concat(orgNameValue === null || orgNameValue === void 0 ? void 0 : orgNameValue.value, " characters");
      }

      if (!values.orgDetails.organisationType) {
        errors.orgDetails.organisationType = '* Required';
      }
      /**SU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/
      // if (!values.orgDetails.contactPerson) {
      //   errors.orgDetails.contactPerson = '* Required';
      // }

      /**EU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/


      if (values.orgDetails.contactPerson && !values.orgDetails.contactPerson.match(/^[a-zA-Z ]*$/)) {
        errors.orgDetails.contactPerson = '* Contact Person name can contain alphabets only';
      }

      if (!values.orgDetails.mobileNumber) {
        errors.orgDetails.mobileNumber = '* Required';
      }

      if (values.orgDetails.mobileNumber && values.orgDetails.mobileNumber.toString().slice(0, 1) < mobileNumberValue) {
        errors.orgDetails.mobileNumber = "* Mobile number must start with digit between ".concat(mobileNumberValue, " - 9");
      }

      if (values.orgDetails.mobileNumber && (values.orgDetails.mobileNumber.length !== 10 || !values.orgDetails.mobileNumber.match(/^[0-9]+$/))) {
        errors.orgDetails.mobileNumber = '* Mobile number must be of 10 digits';
      }

      if (!values.orgDetails.email) {
        errors.orgDetails.email = '* Required';
      }

      if (values.orgDetails.email) {
        var _email_check = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!_email_check.test(values.orgDetails.email)) {
          errors.orgDetails.email = '* Please enter valid email address';
        }
      }
    }

    return errors;
  };

  var initialValuesNewCustomer = {
    customerType: localNewCustomerValues !== null && localNewCustomerValues !== void 0 && localNewCustomerValues.customerType ? localNewCustomerValues === null || localNewCustomerValues === void 0 ? void 0 : localNewCustomerValues.customerType : data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') : '',
    indvDetails: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      dob: ''
    },
    orgDetails: {
      organisationName: '',
      organisationType: '',
      contactPerson: '',
      mobileNumber: '',
      email: ''
    }
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setSaveQuoteDisplay(false);
    setExistingCustomers([]);
    setLocalExistingCustomerValues({
      searchType: 'Mobile Number'
    });
    setEnableReinitialize(true);
    document.body.classList.remove('overflow-y-hidden');
  };

  var onNoResultsFound = function onNoResultsFound() {
    return errors.existingCustomers;
  };

  var inputColSpans = useResponsiveParams({
    for_mobile: {
      searchString: 5,
      searchType: 3,
      button: 2
    },
    for_desktop: {
      searchString: 3,
      searchType: 1,
      button: 1
    }
  });
  var tableRepeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3
  });
  var modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'large',
    for_iPad: 'full'
  });
  var searchInput = {
    enableReinitialize: enableReinitialize,
    flow: 'cols',
    repeat: 5,
    data: [{
      type: 'select-tabs',
      name: 'customerType',
      colSpan: 5,
      size: 'large',
      data: [{
        icon: function icon() {
          return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUserTag
          });
        },
        label: 'Individual',
        value: data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') : '',
        onFieldChange: function onFieldChange(values, setFieldValue) {
          setEnableReinitialize(false);

          if (values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code')) {
            setFieldValue('customerType', getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code'));
            setFieldValue('searchString', '');
            setFieldValue('searchType', 'Mobile Number');
            setLocalExistingCustomerValues(_objectSpread2(_objectSpread2({}, localExistingCustomerValues), {}, {
              customerType: getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code'),
              searchType: 'Mobile Number'
            }));
            setExistingCustomers([]);
            setIdleDisplay(true);
          }
        }
      }, {
        icon: function icon() {
          return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faBuilding
          });
        },
        label: 'Organisation',
        value: data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code') : '',
        onFieldChange: function onFieldChange(values, setFieldValue) {
          setEnableReinitialize(false);

          if (values.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code')) {
            setFieldValue('customerType', getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code'));
            setFieldValue('searchString', '');
            setFieldValue('searchType', '');
            setLocalExistingCustomerValues(_objectSpread2(_objectSpread2({}, localExistingCustomerValues), {}, {
              customerType: getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code'),
              searchType: ''
            }));
            setExistingCustomers([]);
            setIdleDisplay(true);
          }
        }
      }]
    }, {
      type: (localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : (_localExistingCustome = localExistingCustomerValues.searchType) === null || _localExistingCustome === void 0 ? void 0 : _localExistingCustome.toString().toLowerCase()) === 'mobile number' ? 'number' : 'text',
      name: 'searchString',
      step: (localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : (_localExistingCustome2 = localExistingCustomerValues.searchType) === null || _localExistingCustome2 === void 0 ? void 0 : _localExistingCustome2.toString().toLowerCase()) === 'mobile number' ? '1' : null,
      min: 1000000000,
      max: 9999999999,
      size: 'full',
      onKeyDown: function onKeyDown(evt) {
        var _localExistingCustome3, _localExistingCustome4;

        if (evt.key === 'e' && (localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : (_localExistingCustome3 = localExistingCustomerValues.searchType) === null || _localExistingCustome3 === void 0 ? void 0 : _localExistingCustome3.toString().toLowerCase()) === 'mobile number' || (localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : (_localExistingCustome4 = localExistingCustomerValues.searchType) === null || _localExistingCustome4 === void 0 ? void 0 : _localExistingCustome4.toString().toLowerCase()) === 'customer name' && (!evt.key.match(/^[a-zA-Z ]+$/) || evt.target.value.length === 0 && evt.key === ' ' || evt.target.value.length > 0 && evt.target.value[evt.target.value.length - 1] === ' ' && evt.key === ' ')) {
          evt.preventDefault();
        }
      },
      placeholder: getSearchTextPlaceholder(localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.searchType, localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.customerType),
      onDataChange: function onDataChange(val, _) {
        setLocalExistingCustomerValues(_objectSpread2(_objectSpread2({}, localExistingCustomerValues), {}, {
          searchString: val
        }));
        setEnableReinitialize(false);
      },
      colSpan: inputColSpans.searchString
    }, {
      type: 'select',
      name: 'searchType',
      size: 'full',
      className: 'flex flex-row justify-center items-center py-0',
      colSpan: inputColSpans.searchType,
      value: localExistingCustomerValues.searchType,
      onDataChange: function onDataChange(val, _) {
        setLocalExistingCustomerValues(_objectSpread2(_objectSpread2({}, localExistingCustomerValues), {}, {
          searchType: val
        }));
        setEnableReinitialize(false);
      },
      data: !localExistingCustomerValues.customerType || ((_localExistingCustome5 = localExistingCustomerValues.customerType) === null || _localExistingCustome5 === void 0 ? void 0 : _localExistingCustome5.toLowerCase()) === ((_getDomainData5 = getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code')) === null || _getDomainData5 === void 0 ? void 0 : _getDomainData5.toLowerCase()) ? [// { label: 'Customer Name', value: 'Customer Name' },
      {
        label: 'Customer ID',
        value: 'Customer Number'
      }, {
        label: 'Mobile Number',
        value: 'Mobile Number'
      }, {
        label: 'CKYC ID',
        value: 'CKYC Id'
      }, {
        label: 'PAN Number',
        value: 'PAN No'
      }] : [// {
      //   label: 'Organisation Name',
      //   value: 'Customer Name',
      // },
      {
        label: 'Customer ID',
        value: 'Customer Number'
      }, {
        label: 'CKYC ID',
        value: 'CKYC Id'
      }, {
        label: 'PAN Number',
        value: 'PAN No'
      }]
    }, {
      type: 'submit',
      colSpan: inputColSpans.button,
      iconPost: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSearch
      }),
      children: 'Search',
      size: 'full'
    }],
    initialValues: {
      customerType: localExistingCustomerValues !== null && localExistingCustomerValues !== void 0 && localExistingCustomerValues.customerType ? localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.customerType : data_cust_type_domain !== null && data_cust_type_domain !== void 0 && data_cust_type_domain.customerTypeList ? getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') : '',
      searchString: localExistingCustomerValues !== null && localExistingCustomerValues !== void 0 && localExistingCustomerValues.searchString ? localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.searchString : '',
      searchType: localExistingCustomerValues.searchType
    },
    validate: function validate(values) {
      var _data_mobile_number_s3, _data_mobile_number_s4, _data_character_limit5, _values$searchType, _values$searchType$to, _values$searchString;

      var errors = {};
      var mobileNumberCode = data_mobile_number_starting_with === null || data_mobile_number_starting_with === void 0 ? void 0 : (_data_mobile_number_s3 = data_mobile_number_starting_with.mobileNumberStartingWith) === null || _data_mobile_number_s3 === void 0 ? void 0 : _data_mobile_number_s3.code;
      var mobileNumberValue = data_mobile_number_starting_with === null || data_mobile_number_starting_with === void 0 ? void 0 : (_data_mobile_number_s4 = data_mobile_number_starting_with.mobileNumberStartingWith) === null || _data_mobile_number_s4 === void 0 ? void 0 : _data_mobile_number_s4.value;
      var orgNameValue = data_character_limit === null || data_character_limit === void 0 ? void 0 : (_data_character_limit5 = data_character_limit.characterLimitList) === null || _data_character_limit5 === void 0 ? void 0 : _data_character_limit5.find(function (characterLimit) {
        var _characterLimit$code;

        return (characterLimit === null || characterLimit === void 0 ? void 0 : (_characterLimit$code = characterLimit.code) === null || _characterLimit$code === void 0 ? void 0 : _characterLimit$code.toLowerCase()) === 'org name';
      });

      if (!values.customerType || values.customerType === '') {
        errors.customerType = '* Required';
      } else if (!values.searchString || values.searchString === '') {
        errors.searchString = '* Required';
      } else if (values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') && typeof values.searchString === 'string' && (values.searchString.toLowerCase().startsWith('mrs') && values.searchString.length < 6 || values.searchString.toLowerCase().startsWith('mr') && values.searchString.length < 5 || values.searchString.toLowerCase().startsWith('dr') && values.searchString.length < 5 || values.searchString.toLowerCase().startsWith('miss') && values.searchString.length < 7)) {
        errors.searchString = '* Customer cannot be searched only by title';
      } else if (values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') && values.searchString.length < 4 && values.searchType.toLowerCase() !== 'mobile number') {
        errors.searchString = '* Minimum 4 characters are required for individual customer search';
      } else if (data_cust_type_domain && data_cust_type_domain.customerTypeList && values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code') && values.searchString.length < 3) {
        errors.searchString = '* Minimum 3 characters are required for organisation/corporate customer search';
      } else if (data_cust_type_domain && data_cust_type_domain.customerTypeList && values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code') && values.searchType.toLowerCase().endsWith('name') && values.searchString.length > (orgNameValue === null || orgNameValue === void 0 ? void 0 : orgNameValue.value)) {
        errors.searchString = "* Organisation Name cannot be greater than ".concat(orgNameValue.value, " characters");
      } else if (data_cust_type_domain.customerTypeList && values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Organisation', 'value', 'code') && values.searchType.toLowerCase().endsWith('name') && !values.searchString.match(/^[a-zA-Z ]+$/)) {
        errors.searchString = '* Organisation name contains only alphabets';
      } else if (values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') && values.searchType.toLowerCase().endsWith('name') && values.searchString.match(/\d/)) {
        errors.searchString = '* Customer name cannot be alphanumeric';
      } else if (values.customerType === getDomainData(data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') && values.searchType.toLowerCase().endsWith('name') && !values.searchString.match(/^[a-zA-Z ]+$/)) {
        errors.searchString = '* Customer name contains only alphabets';
      } else if (values.searchType.toLowerCase() === mobileNumberCode.toLowerCase() && values.searchString.toString().slice(0, 1) < mobileNumberValue) {
        errors.searchString = "* Mobile number must start with digit between ".concat(mobileNumberValue, " - 9");
      } else if (values.searchType.toLowerCase() === 'mobile number' && (values.searchString.toString().length !== 10 || !values.searchString.toString().match(/^[0-9]+$/))) {
        errors.searchString = '* Mobile number must be of 10 digits';
      } else if (!values.searchType || values.searchType === '') {
        errors.searchType = '* Required';
      } else if ((values === null || values === void 0 ? void 0 : (_values$searchType = values.searchType) === null || _values$searchType === void 0 ? void 0 : (_values$searchType$to = _values$searchType.toString()) === null || _values$searchType$to === void 0 ? void 0 : _values$searchType$to.toLowerCase()) === 'customer number' && !(values !== null && values !== void 0 && (_values$searchString = values.searchString) !== null && _values$searchString !== void 0 && _values$searchString.match(/^[a-zA-Z0-9]+$/))) {
        errors.searchString = '* Customer ID cannot contain special characters';
      }

      return errors;
    },
    onSearch: function () {
      var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
        var searchType, customerType, searchString, queryOutput, _yield$queryOutput, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                searchType = values.searchType, customerType = values.customerType, searchString = values.searchString;
                setIdleDisplay(false);
                _context2.prev = 2;
                setCRSL('');
                setExistingCustomers([]);
                setLoadingExistingCustomers(true);
                queryOutput = fetchQuery({
                  query: SEARCH_CUSTOMERS,
                  variables: {
                    filter: getSearchObject(customerType, searchType, searchString)
                  }
                });
                _context2.next = 9;
                return queryOutput;

              case 9:
                _yield$queryOutput = _context2.sent;
                data = _yield$queryOutput.data;
                setLoadingExistingCustomers(false);
                setExistingCustomers(data.customers);
                setCustomerSearchMetaMessage({
                  type: data._customer_meta.metaMessage.type,
                  message: data._customer_meta.metaMessage.message
                });
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](2);
                setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                  existingCustomers: _context2.t0.message
                }));
                setLoadingExistingCustomers(false);
                setExistingCustomers([]);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 16]]);
      }));

      function onSearch(_x2) {
        return _onSearch.apply(this, arguments);
      }

      return onSearch;
    }()
  };
  var searchResults = {
    data: existingCustomers,
    onIdle: function onIdle() {
      if (loadingExistingCustomers) {
        return /*#__PURE__*/React.createElement(Loading, null);
      } else if (isIdleDisplay) {
        return /*#__PURE__*/React.createElement(IconIdle, null);
      }

      return undefined;
    },
    dependencies: [localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.customerType, localExistingCustomerValues === null || localExistingCustomerValues === void 0 ? void 0 : localExistingCustomerValues.searchString],
    columns: [{
      Header: 'Customer ID',
      accessor: 'cust_number'
    }, {
      Header: !localExistingCustomerValues.customerType || localExistingCustomerValues.customerType === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? 'Customer Name' : 'Organisation Name',
      Cell: function Cell(_ref4) {
        var row = _ref4.row;
        return /*#__PURE__*/React.createElement("span", null, row.original.cust_type.value === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? row.original.indv_detail.full_name : row.original.org_detail.org_name);
      }
    }, {
      Header: 'Location',
      Cell: function Cell(_ref5) {
        var row = _ref5.row;
        return /*#__PURE__*/React.createElement("div", {
          className: "text-base"
        }, row.original.permanent_address.location);
      }
    }, {
      Header: 'Contact',
      Cell: function Cell(_ref6) {
        var row = _ref6.row;
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col -mb-1 -mt-1 item-baseline justify-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-base"
        }, row.original.contact.mobile), /*#__PURE__*/React.createElement("div", {
          className: "text-base"
        }, row.original.contact.email)));
      }
    }].filter(function (d) {
      return d.Header !== undefined;
    }),
    grid: {
      repeat: 1,
      gap: 2,
      gapX: 2,
      gapY: 2,
      gridClassName: 'w-full',
      gridItemsArr: (existingCustomers === null || existingCustomers === void 0 ? void 0 : existingCustomers.length) > 0 ? // &&
      // existingCustomers[0].cust_type.value ===
      //   getDomainData(
      //     data_cust_type_domain?.customerTypeList,
      //     'Individual',
      //     'value',
      //     'code',
      //   )
      existingCustomers === null || existingCustomers === void 0 ? void 0 : existingCustomers.map(function (customerData) {
        var _customerData$cust_ty, _customerData$cust_ty2, _customerData$cust_ty3;

        return {
          id: "".concat(customerData === null || customerData === void 0 ? void 0 : customerData.cust_number),
          content: /*#__PURE__*/React.createElement(Paper, {
            className: "border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light"
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col h-full w-full justify-between'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex items-center justify-between'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold flex space-x-4 items-start'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col justify-start items-center'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: "border-2 px-2 py-1 rounded-lg bg-white"
          }, (customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty = customerData.cust_type) === null || _customerData$cust_ty === void 0 ? void 0 : (_customerData$cust_ty2 = _customerData$cust_ty.value) === null || _customerData$cust_ty2 === void 0 ? void 0 : (_customerData$cust_ty3 = _customerData$cust_ty2.toString()) === null || _customerData$cust_ty3 === void 0 ? void 0 : _customerData$cust_ty3.toLowerCase()) === 'organisation' ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUniversity,
            size: '2x'
          }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUser,
            size: '2x'
          }))), /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'font-semibold'
          }, "".concat(customerData.cust_type.value === 'Individual' ? customerData.indv_detail.full_name : customerData.org_detail.org_name)), /*#__PURE__*/React.createElement(Text, {
            severity: 'neutral-darker',
            type: 'label'
          }, customerData.cust_number)))), /*#__PURE__*/React.createElement(Grid, {
            repeat: 3,
            className: 'w-full'
          }, customerData.permanent_address.location ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: screenType === 'desktop' ? 'flex space-x-2 w-full justify-start ml-16 mt-2' : 'flex space-x-2 w-full justify-start ml-2 mt-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMapMarkerAlt
          })), /*#__PURE__*/React.createElement(Text, null, customerData.permanent_address.location)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null)), customerData.contact.mobile ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: screenType === 'desktop' ? 'flex justify-center space-x-2 w-full mt-2' : 'flex space-x-2 w-full mt-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMobileAlt
          })), /*#__PURE__*/React.createElement(Text, null, customerData.contact.mobile)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null)), customerData.contact.email ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: screenType === 'desktop' ? 'flex space-x-2 w-full mt-2 ml-7' : 'flex space-x-2 w-full mt-2'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faEnvelope
          })), /*#__PURE__*/React.createElement(Text, null, customerData.contact.email)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null))))),
          onClick: function () {
            var _onClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
              var _state$healthPlans$pl, _state$healthPlans$pl2, _state$healthPlans$pl3, _customerData$cust_nu, fetchQueryState, _yield$fetchQueryStat2, state, _customerData$cust_ty4, _customerData$indv_de, _customerData$org_det, _customerData$cust_ty5, _customerData$cust_ty6, _customerData$indv_de2, _customerData$indv_de3, _customerData$indv_de4, _customerData$indv_de5, _customerData$indv_de6, _customerData$indv_de7, _customerData$contact, _customerData$contact2, _customerData$indv_de8, _customerData$cust_ty7, _customerData$org_det2, _customerData$org_det3, _customerData$org_det4, _customerData$org_det5, _customerData$contact3, _customerData$contact4, healthQuote, healthPlans, quotationType, members, location, cover, existingPolicyNumber, isExistingEmployee, intermediaryDetails, maternitySelectedCover, maternityMembers, customerDataModified, variables;

              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      fetchQueryState = fetchQuery({
                        query: QUERY_STATE
                      });
                      setLoadingExistingCustomers(true);
                      _context3.next = 5;
                      return fetchQueryState;

                    case 5:
                      _yield$fetchQueryStat2 = _context3.sent;
                      state = _yield$fetchQueryStat2.data;

                      if (state.healthQuote.existingPolicyNumber !== '' && ((_state$healthPlans$pl = state.healthPlans.plans[0]) === null || _state$healthPlans$pl === void 0 ? void 0 : (_state$healthPlans$pl2 = _state$healthPlans$pl.premium) === null || _state$healthPlans$pl2 === void 0 ? void 0 : (_state$healthPlans$pl3 = _state$healthPlans$pl2.CustID) === null || _state$healthPlans$pl3 === void 0 ? void 0 : _state$healthPlans$pl3.toString()) !== (customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_nu = customerData.cust_number) === null || _customerData$cust_nu === void 0 ? void 0 : _customerData$cust_nu.toString())) {
                        setCRSL(1);
                        setLoadingExistingCustomers(false);
                      } else {
                        setCRSL('');
                        setLoadingExistingCustomers(false);
                        healthQuote = state.healthQuote, healthPlans = state.healthPlans;
                        quotationType = healthQuote.quotationType, members = healthQuote.members, location = healthQuote.location, cover = healthQuote.cover, existingPolicyNumber = healthQuote.existingPolicyNumber, isExistingEmployee = healthQuote.isExistingEmployee, intermediaryDetails = healthQuote.intermediaryDetails, maternitySelectedCover = healthQuote.maternitySelectedCover, maternityMembers = healthQuote.maternityMembers;
                        setCustomerNameQuoteSaved((customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty4 = customerData.cust_type) === null || _customerData$cust_ty4 === void 0 ? void 0 : _customerData$cust_ty4.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de = customerData.indv_detail) === null || _customerData$indv_de === void 0 ? void 0 : _customerData$indv_de.full_name : customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det = customerData.org_detail) === null || _customerData$org_det === void 0 ? void 0 : _customerData$org_det.org_name);
                        customerDataModified = (customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty5 = customerData.cust_type) === null || _customerData$cust_ty5 === void 0 ? void 0 : _customerData$cust_ty5.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? {
                          id: customerData === null || customerData === void 0 ? void 0 : customerData.cust_number,
                          customerType: customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty6 = customerData.cust_type) === null || _customerData$cust_ty6 === void 0 ? void 0 : _customerData$cust_ty6.code,
                          title: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de2 = customerData.indv_detail) === null || _customerData$indv_de2 === void 0 ? void 0 : (_customerData$indv_de3 = _customerData$indv_de2.title) === null || _customerData$indv_de3 === void 0 ? void 0 : _customerData$indv_de3.code, ''),
                          firstName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de4 = customerData.indv_detail) === null || _customerData$indv_de4 === void 0 ? void 0 : _customerData$indv_de4.first_name, ''),
                          middleName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de5 = customerData.indv_detail) === null || _customerData$indv_de5 === void 0 ? void 0 : _customerData$indv_de5.middle_name, ''),
                          fullName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de6 = customerData.indv_detail) === null || _customerData$indv_de6 === void 0 ? void 0 : _customerData$indv_de6.full_name, ''),
                          lastName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de7 = customerData.indv_detail) === null || _customerData$indv_de7 === void 0 ? void 0 : _customerData$indv_de7.surname, ''),
                          emailID: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact = customerData.contact) === null || _customerData$contact === void 0 ? void 0 : _customerData$contact.email, ''),
                          mobileNo: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact2 = customerData.contact) === null || _customerData$contact2 === void 0 ? void 0 : _customerData$contact2.mobile, ''),
                          proposerDOB: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de8 = customerData.indv_detail) === null || _customerData$indv_de8 === void 0 ? void 0 : _customerData$indv_de8.date_of_birth, '')
                        } : {
                          id: customerData === null || customerData === void 0 ? void 0 : customerData.cust_number,
                          customerType: customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty7 = customerData.cust_type) === null || _customerData$cust_ty7 === void 0 ? void 0 : _customerData$cust_ty7.code,
                          orgName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det2 = customerData.org_detail) === null || _customerData$org_det2 === void 0 ? void 0 : _customerData$org_det2.org_name, ''),
                          orgType: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det3 = customerData.org_detail) === null || _customerData$org_det3 === void 0 ? void 0 : (_customerData$org_det4 = _customerData$org_det3.org_type) === null || _customerData$org_det4 === void 0 ? void 0 : _customerData$org_det4.code, ''),
                          contactName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det5 = customerData.org_detail) === null || _customerData$org_det5 === void 0 ? void 0 : _customerData$org_det5.contact_name, ''),
                          mobileNo: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact3 = customerData.contact) === null || _customerData$contact3 === void 0 ? void 0 : _customerData$contact3.mobile, ''),
                          emailID: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact4 = customerData.contact) === null || _customerData$contact4 === void 0 ? void 0 : _customerData$contact4.email, '')
                        };
                        variables = saveQuoteVariables(lobCode, productCode, customerDataModified, quotationType, members, cover, healthPlans, location, existingPolicyNumber, isExistingEmployee, selectedIntermediary, intermediaryDetails, maternitySelectedCover, maternityMembers);
                        doSaveQuote({
                          variables: variables
                        });
                        updateCustomerInformation({
                          customer: customerDataModified,
                          customerMeta: {
                            crn: '',
                            isNewCustomer: false,
                            ifscCode: '',
                            bankName: '',
                            branchName: '',
                            bankAcno: '',
                            accountHolderName: '',
                            micrCode: ''
                          }
                        });
                        updateHealthQuote({
                          isQuoteSaving: true
                        });
                        onModalClose();
                      }

                      _context3.next = 14;
                      break;

                    case 10:
                      _context3.prev = 10;
                      _context3.t0 = _context3["catch"](0);
                      setErrors({
                        existingCustomers: _context3.t0.message
                      });
                      setLoadingExistingCustomers(false);

                    case 14:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[0, 10]]);
            }));

            function onClick() {
              return _onClick.apply(this, arguments);
            }

            return onClick;
          }(),
          colSpan: 1
        };
      }) : []
    },
    card: {
      gap: 2,
      gapX: 2,
      gapY: 2,
      cardClassName: 'w-full',
      cardItemsArr: existingCustomers.length > 0 ? // &&
      // existingCustomers[0].cust_type.value ===
      //   getDomainData(
      //     data_cust_type_domain?.customerTypeList,
      //     'Individual',
      //     'value',
      //     'code',
      //   )
      existingCustomers === null || existingCustomers === void 0 ? void 0 : existingCustomers.map(function (customerData) {
        return {
          id: "".concat(customerData === null || customerData === void 0 ? void 0 : customerData.cust_number),
          content: /*#__PURE__*/React.createElement(Paper, {
            className: " border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light"
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col h-full w-full justify-start'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex items-center justify-between'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold flex space-x-2 items-start'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'font-semibold'
          }, "".concat(customerData.cust_type.value === 'Individual' ? customerData.indv_detail.full_name : customerData.org_detail.org_name)), /*#__PURE__*/React.createElement(Text, {
            severity: 'neutral-darker',
            type: 'label'
          }, customerData.cust_number)))), /*#__PURE__*/React.createElement(Grid, {
            repeat: 2,
            gap: 1,
            className: 'w-full h-full mt-2'
          }, customerData.permanent_address.location ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full justify-start items-center'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMapMarkerAlt
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, customerData.permanent_address.location)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null)), customerData.contact.mobile ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: screenType === 'mobile' ? 'flex space-x-2 w-full justify-end' : 'flex space-x-2 w-full justify-start'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMobileAlt
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, customerData.contact.mobile)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null)), customerData.contact.email ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full items-center'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faEnvelope
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, customerData.contact.email)) : /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1
          }, /*#__PURE__*/React.createElement(React.Fragment, null))))),
          onClick: function () {
            var _onClick2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
              var _state$healthPlans$pl4, _state$healthPlans$pl5, _state$healthPlans$pl6, _customerData$cust_nu2, fetchQueryState, _yield$fetchQueryStat3, state, _customerData$cust_ty8, _customerData$indv_de9, _customerData$org_det6, _customerData$cust_ty9, _customerData$cust_ty10, _customerData$indv_de10, _customerData$indv_de11, _customerData$indv_de12, _customerData$indv_de13, _customerData$indv_de14, _customerData$indv_de15, _customerData$contact5, _customerData$contact6, _customerData$indv_de16, _customerData$cust_ty11, _customerData$org_det7, _customerData$org_det8, _customerData$org_det9, _customerData$org_det10, _customerData$contact7, _customerData$contact8, healthQuote, healthPlans, quotationType, members, location, cover, existingPolicyNumber, isExistingEmployee, intermediaryDetails, maternitySelectedCover, maternityMembers, customerDataModified, variables;

              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      fetchQueryState = fetchQuery({
                        query: QUERY_STATE
                      });
                      setLoadingExistingCustomers(true);
                      _context4.next = 5;
                      return fetchQueryState;

                    case 5:
                      _yield$fetchQueryStat3 = _context4.sent;
                      state = _yield$fetchQueryStat3.data;

                      if (state.healthQuote.existingPolicyNumber !== '' && ((_state$healthPlans$pl4 = state.healthPlans.plans[0]) === null || _state$healthPlans$pl4 === void 0 ? void 0 : (_state$healthPlans$pl5 = _state$healthPlans$pl4.premium) === null || _state$healthPlans$pl5 === void 0 ? void 0 : (_state$healthPlans$pl6 = _state$healthPlans$pl5.CustID) === null || _state$healthPlans$pl6 === void 0 ? void 0 : _state$healthPlans$pl6.toString()) !== (customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_nu2 = customerData.cust_number) === null || _customerData$cust_nu2 === void 0 ? void 0 : _customerData$cust_nu2.toString())) {
                        setCRSL(1);
                        setLoadingExistingCustomers(false);
                      } else {
                        setCRSL('');
                        setLoadingExistingCustomers(false);
                        healthQuote = state.healthQuote, healthPlans = state.healthPlans;
                        quotationType = healthQuote.quotationType, members = healthQuote.members, location = healthQuote.location, cover = healthQuote.cover, existingPolicyNumber = healthQuote.existingPolicyNumber, isExistingEmployee = healthQuote.isExistingEmployee, intermediaryDetails = healthQuote.intermediaryDetails, maternitySelectedCover = healthQuote.maternitySelectedCover, maternityMembers = healthQuote.maternityMembers;
                        setCustomerNameQuoteSaved((customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty8 = customerData.cust_type) === null || _customerData$cust_ty8 === void 0 ? void 0 : _customerData$cust_ty8.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de9 = customerData.indv_detail) === null || _customerData$indv_de9 === void 0 ? void 0 : _customerData$indv_de9.full_name : customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det6 = customerData.org_detail) === null || _customerData$org_det6 === void 0 ? void 0 : _customerData$org_det6.org_name);
                        customerDataModified = (customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty9 = customerData.cust_type) === null || _customerData$cust_ty9 === void 0 ? void 0 : _customerData$cust_ty9.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? {
                          id: customerData === null || customerData === void 0 ? void 0 : customerData.cust_number,
                          customerType: customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty10 = customerData.cust_type) === null || _customerData$cust_ty10 === void 0 ? void 0 : _customerData$cust_ty10.code,
                          title: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de10 = customerData.indv_detail) === null || _customerData$indv_de10 === void 0 ? void 0 : (_customerData$indv_de11 = _customerData$indv_de10.title) === null || _customerData$indv_de11 === void 0 ? void 0 : _customerData$indv_de11.code, ''),
                          firstName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de12 = customerData.indv_detail) === null || _customerData$indv_de12 === void 0 ? void 0 : _customerData$indv_de12.first_name, ''),
                          middleName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de13 = customerData.indv_detail) === null || _customerData$indv_de13 === void 0 ? void 0 : _customerData$indv_de13.middle_name, ''),
                          fullName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de14 = customerData.indv_detail) === null || _customerData$indv_de14 === void 0 ? void 0 : _customerData$indv_de14.full_name, ''),
                          lastName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de15 = customerData.indv_detail) === null || _customerData$indv_de15 === void 0 ? void 0 : _customerData$indv_de15.surname, ''),
                          emailID: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact5 = customerData.contact) === null || _customerData$contact5 === void 0 ? void 0 : _customerData$contact5.email, ''),
                          mobileNo: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact6 = customerData.contact) === null || _customerData$contact6 === void 0 ? void 0 : _customerData$contact6.mobile, ''),
                          proposerDOB: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$indv_de16 = customerData.indv_detail) === null || _customerData$indv_de16 === void 0 ? void 0 : _customerData$indv_de16.date_of_birth, '')
                        } : {
                          id: customerData === null || customerData === void 0 ? void 0 : customerData.cust_number,
                          customerType: customerData === null || customerData === void 0 ? void 0 : (_customerData$cust_ty11 = customerData.cust_type) === null || _customerData$cust_ty11 === void 0 ? void 0 : _customerData$cust_ty11.code,
                          orgName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det7 = customerData.org_detail) === null || _customerData$org_det7 === void 0 ? void 0 : _customerData$org_det7.org_name, ''),
                          orgType: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det8 = customerData.org_detail) === null || _customerData$org_det8 === void 0 ? void 0 : (_customerData$org_det9 = _customerData$org_det8.org_type) === null || _customerData$org_det9 === void 0 ? void 0 : _customerData$org_det9.code, ''),
                          contactName: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$org_det10 = customerData.org_detail) === null || _customerData$org_det10 === void 0 ? void 0 : _customerData$org_det10.contact_name, ''),
                          mobileNo: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact7 = customerData.contact) === null || _customerData$contact7 === void 0 ? void 0 : _customerData$contact7.mobile, ''),
                          emailID: reformData(customerData === null || customerData === void 0 ? void 0 : (_customerData$contact8 = customerData.contact) === null || _customerData$contact8 === void 0 ? void 0 : _customerData$contact8.email, '')
                        };
                        variables = saveQuoteVariables(lobCode, productCode, customerDataModified, quotationType, members, cover, healthPlans, location, existingPolicyNumber, isExistingEmployee, selectedIntermediary, intermediaryDetails, maternitySelectedCover, maternityMembers);
                        doSaveQuote({
                          variables: variables
                        });
                        updateCustomerInformation({
                          customer: customerDataModified,
                          customerMeta: {
                            crn: '',
                            isNewCustomer: false,
                            ifscCode: '',
                            bankName: '',
                            branchName: '',
                            bankAcno: '',
                            accountHolderName: '',
                            micrCode: ''
                          }
                        });
                        updateHealthQuote({
                          isQuoteSaving: true
                        });
                        onModalClose();
                      }

                      _context4.next = 14;
                      break;

                    case 10:
                      _context4.prev = 10;
                      _context4.t0 = _context4["catch"](0);
                      setErrors({
                        existingCustomers: _context4.t0.message
                      });
                      setLoadingExistingCustomers(false);

                    case 14:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, null, [[0, 10]]);
            }));

            function onClick() {
              return _onClick2.apply(this, arguments);
            }

            return onClick;
          }(),
          colSpan: 1
        };
      }) : []
    },
    // list: existingCustomers.map((customerData) => {
    //   return {
    //     title: `${
    //       customerData.cust_type.value ===
    //       getDomainData(
    //         data_cust_type_domain?.customerTypeList,
    //         'Individual',
    //         'value',
    //         'code',
    //       )
    //         ? customerData.indv_detail.full_name
    //         : customerData.org_detail.org_name
    //     } (${customerData.cust_number})`,
    //     subtitle: `${customerData.permanent_address.location}`,
    //     onClick: async () => {
    //       try {
    //         let fetchQueryState = fetchQuery({
    //           query: QUERY_STATE,
    //         });
    //         setLoadingExistingCustomers(true);
    //         let { data: state } = await fetchQueryState;
    //         setLoadingExistingCustomers(false);
    //         let { healthQuote, healthPlans } = state;
    //         let {
    //           quotationType,
    //           members,
    //           location,
    //           cover,
    //           existingPolicyNumber,
    //           isExistingEmployee,
    //           intermediaryDetails,
    //         } = healthQuote;
    //         setCustomerNameQuoteSaved(
    //           customerData?.cust_type?.value ===
    //             getDomainData(
    //               data_cust_type_domain?.customerTypeList,
    //               'Individual',
    //               'value',
    //               'code',
    //             )
    //             ? customerData?.indv_detail?.full_name
    //             : customerData?.org_detail?.org_name,
    //         );
    //         customerData =
    //           customerData?.cust_type?.value ===
    //           getDomainData(
    //             data_cust_type_domain?.customerTypeList,
    //             'Individual',
    //             'value',
    //             'code',
    //           )
    //             ? {
    //                 id: customerData?.cust_number,
    //                 customerType: customerData?.cust_type?.code,
    //                 title: reformData(
    //                   customerData?.indv_detail?.title?.code,
    //                   '',
    //                 ),
    //                 firstName: reformData(
    //                   customerData?.indv_detail?.first_name,
    //                   '',
    //                 ),
    //                 middleName: reformData(
    //                   customerData?.indv_detail?.middle_name,
    //                   '',
    //                 ),
    //                 fullName: reformData(
    //                   customerData?.indv_detail?.full_name,
    //                   '',
    //                 ),
    //                 lastName: reformData(
    //                   customerData?.indv_detail?.surname,
    //                   '',
    //                 ),
    //                 emailID: reformData(
    //                   customerData?.contact?.email,
    //                   '',
    //                 ),
    //                 mobileNo: reformData(
    //                   customerData?.contact?.mobile,
    //                   '',
    //                 ),
    //                 proposerDOB: reformData(
    //                   customerData?.indv_detail?.date_of_birth,
    //                   '',
    //                 ),
    //               }
    //             : {
    //                 id: customerData?.cust_number,
    //                 customerType: customerData?.cust_type?.code,
    //                 orgName: reformData(
    //                   customerData?.org_detail?.org_name,
    //                   '',
    //                 ),
    //                 orgType: reformData(
    //                   customerData?.org_detail?.org_type?.code,
    //                   '',
    //                 ),
    //                 contactName: reformData(
    //                   customerData?.org_detail?.contact_name,
    //                   '',
    //                 ),
    //                 mobileNo: reformData(
    //                   customerData?.contact?.mobile,
    //                   '',
    //                 ),
    //                 emailID: reformData(
    //                   customerData?.contact?.email,
    //                   '',
    //                 ),
    //               };
    //         const variables = saveQuoteVariables(
    //           lobCode,
    //           productCode,
    //           customerData,
    //           quotationType,
    //           members,
    //           cover,
    //           healthPlans,
    //           location,
    //           existingPolicyNumber,
    //           isExistingEmployee,
    //           selectedIntermediary,
    //           intermediaryDetails,
    //         );
    //         doSaveQuote({ variables });
    //         updateCustomerInformation({
    //           customer: customerData,
    //           customerMeta: {
    //             crn: '',
    //             isNewCustomer: false,
    //             ifscCode: '',
    //             bankName: '',
    //             branchName: '',
    //             bankAcno: '',
    //             accountHolderName: '',
    //             micrCode: '',
    //           },
    //         });
    //         updateHealthQuote({
    //           isQuoteSaving: true,
    //         });
    //         onModalClose();
    //       } catch (error) {
    //         setErrors({
    //           existingCustomers: error.message,
    //         });
    //         setLoadingExistingCustomers(false);
    //       }
    //     },
    //   };
    // }),
    onRowClick: function () {
      var _onRowClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(customerData) {
        var _state$healthPlans$pl7, _state$healthPlans$pl8, _state$healthPlans$pl9, _customerData, _customerData$cust_nu3, fetchQueryState, _yield$fetchQueryStat4, state, _customerData2, _customerData2$cust_t, _customerData3, _customerData3$indv_d, _customerData4, _customerData4$org_de, _customerData5, _customerData5$cust_t, _customerData6, _customerData7, _customerData7$cust_t, _customerData8, _customerData8$indv_d, _customerData8$indv_d2, _customerData9, _customerData9$indv_d, _customerData10, _customerData10$indv_, _customerData11, _customerData11$indv_, _customerData12, _customerData12$indv_, _customerData13, _customerData13$conta, _customerData14, _customerData14$conta, _customerData15, _customerData15$indv_, _customerData16, _customerData17, _customerData17$cust_, _customerData18, _customerData18$org_d, _customerData19, _customerData19$org_d, _customerData19$org_d2, _customerData20, _customerData20$org_d, _customerData21, _customerData21$conta, _customerData22, _customerData22$conta, healthQuote, healthPlans, quotationType, members, location, cover, existingPolicyNumber, isExistingEmployee, intermediaryDetails, maternitySelectedCover, maternityMembers, variables;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                fetchQueryState = fetchQuery({
                  query: QUERY_STATE
                });
                setLoadingExistingCustomers(true);
                _context5.next = 5;
                return fetchQueryState;

              case 5:
                _yield$fetchQueryStat4 = _context5.sent;
                state = _yield$fetchQueryStat4.data;

                if (state.healthQuote.existingPolicyNumber !== '' && ((_state$healthPlans$pl7 = state.healthPlans.plans[0]) === null || _state$healthPlans$pl7 === void 0 ? void 0 : (_state$healthPlans$pl8 = _state$healthPlans$pl7.premium) === null || _state$healthPlans$pl8 === void 0 ? void 0 : (_state$healthPlans$pl9 = _state$healthPlans$pl8.CustID) === null || _state$healthPlans$pl9 === void 0 ? void 0 : _state$healthPlans$pl9.toString()) !== ((_customerData = customerData) === null || _customerData === void 0 ? void 0 : (_customerData$cust_nu3 = _customerData.cust_number) === null || _customerData$cust_nu3 === void 0 ? void 0 : _customerData$cust_nu3.toString())) {
                  setCRSL(1);
                  setLoadingExistingCustomers(false);
                } else {
                  setCRSL('');
                  setLoadingExistingCustomers(false);
                  healthQuote = state.healthQuote, healthPlans = state.healthPlans;
                  quotationType = healthQuote.quotationType, members = healthQuote.members, location = healthQuote.location, cover = healthQuote.cover, existingPolicyNumber = healthQuote.existingPolicyNumber, isExistingEmployee = healthQuote.isExistingEmployee, intermediaryDetails = healthQuote.intermediaryDetails, maternitySelectedCover = healthQuote.maternitySelectedCover, maternityMembers = healthQuote.maternityMembers;
                  setCustomerNameQuoteSaved(((_customerData2 = customerData) === null || _customerData2 === void 0 ? void 0 : (_customerData2$cust_t = _customerData2.cust_type) === null || _customerData2$cust_t === void 0 ? void 0 : _customerData2$cust_t.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? (_customerData3 = customerData) === null || _customerData3 === void 0 ? void 0 : (_customerData3$indv_d = _customerData3.indv_detail) === null || _customerData3$indv_d === void 0 ? void 0 : _customerData3$indv_d.full_name : (_customerData4 = customerData) === null || _customerData4 === void 0 ? void 0 : (_customerData4$org_de = _customerData4.org_detail) === null || _customerData4$org_de === void 0 ? void 0 : _customerData4$org_de.org_name);
                  customerData = ((_customerData5 = customerData) === null || _customerData5 === void 0 ? void 0 : (_customerData5$cust_t = _customerData5.cust_type) === null || _customerData5$cust_t === void 0 ? void 0 : _customerData5$cust_t.value) === getDomainData(data_cust_type_domain === null || data_cust_type_domain === void 0 ? void 0 : data_cust_type_domain.customerTypeList, 'Individual', 'value', 'code') ? {
                    id: (_customerData6 = customerData) === null || _customerData6 === void 0 ? void 0 : _customerData6.cust_number,
                    customerType: (_customerData7 = customerData) === null || _customerData7 === void 0 ? void 0 : (_customerData7$cust_t = _customerData7.cust_type) === null || _customerData7$cust_t === void 0 ? void 0 : _customerData7$cust_t.code,
                    title: reformData((_customerData8 = customerData) === null || _customerData8 === void 0 ? void 0 : (_customerData8$indv_d = _customerData8.indv_detail) === null || _customerData8$indv_d === void 0 ? void 0 : (_customerData8$indv_d2 = _customerData8$indv_d.title) === null || _customerData8$indv_d2 === void 0 ? void 0 : _customerData8$indv_d2.code, ''),
                    firstName: reformData((_customerData9 = customerData) === null || _customerData9 === void 0 ? void 0 : (_customerData9$indv_d = _customerData9.indv_detail) === null || _customerData9$indv_d === void 0 ? void 0 : _customerData9$indv_d.first_name, ''),
                    middleName: reformData((_customerData10 = customerData) === null || _customerData10 === void 0 ? void 0 : (_customerData10$indv_ = _customerData10.indv_detail) === null || _customerData10$indv_ === void 0 ? void 0 : _customerData10$indv_.middle_name, ''),
                    fullName: reformData((_customerData11 = customerData) === null || _customerData11 === void 0 ? void 0 : (_customerData11$indv_ = _customerData11.indv_detail) === null || _customerData11$indv_ === void 0 ? void 0 : _customerData11$indv_.full_name, ''),
                    lastName: reformData((_customerData12 = customerData) === null || _customerData12 === void 0 ? void 0 : (_customerData12$indv_ = _customerData12.indv_detail) === null || _customerData12$indv_ === void 0 ? void 0 : _customerData12$indv_.surname, ''),
                    emailID: reformData((_customerData13 = customerData) === null || _customerData13 === void 0 ? void 0 : (_customerData13$conta = _customerData13.contact) === null || _customerData13$conta === void 0 ? void 0 : _customerData13$conta.email, ''),
                    mobileNo: reformData((_customerData14 = customerData) === null || _customerData14 === void 0 ? void 0 : (_customerData14$conta = _customerData14.contact) === null || _customerData14$conta === void 0 ? void 0 : _customerData14$conta.mobile, ''),
                    proposerDOB: reformData((_customerData15 = customerData) === null || _customerData15 === void 0 ? void 0 : (_customerData15$indv_ = _customerData15.indv_detail) === null || _customerData15$indv_ === void 0 ? void 0 : _customerData15$indv_.date_of_birth, '')
                  } : {
                    id: (_customerData16 = customerData) === null || _customerData16 === void 0 ? void 0 : _customerData16.cust_number,
                    customerType: (_customerData17 = customerData) === null || _customerData17 === void 0 ? void 0 : (_customerData17$cust_ = _customerData17.cust_type) === null || _customerData17$cust_ === void 0 ? void 0 : _customerData17$cust_.code,
                    orgName: reformData((_customerData18 = customerData) === null || _customerData18 === void 0 ? void 0 : (_customerData18$org_d = _customerData18.org_detail) === null || _customerData18$org_d === void 0 ? void 0 : _customerData18$org_d.org_name, ''),
                    orgType: reformData((_customerData19 = customerData) === null || _customerData19 === void 0 ? void 0 : (_customerData19$org_d = _customerData19.org_detail) === null || _customerData19$org_d === void 0 ? void 0 : (_customerData19$org_d2 = _customerData19$org_d.org_type) === null || _customerData19$org_d2 === void 0 ? void 0 : _customerData19$org_d2.code, ''),
                    contactName: reformData((_customerData20 = customerData) === null || _customerData20 === void 0 ? void 0 : (_customerData20$org_d = _customerData20.org_detail) === null || _customerData20$org_d === void 0 ? void 0 : _customerData20$org_d.contact_name, ''),
                    mobileNo: reformData((_customerData21 = customerData) === null || _customerData21 === void 0 ? void 0 : (_customerData21$conta = _customerData21.contact) === null || _customerData21$conta === void 0 ? void 0 : _customerData21$conta.mobile, ''),
                    emailID: reformData((_customerData22 = customerData) === null || _customerData22 === void 0 ? void 0 : (_customerData22$conta = _customerData22.contact) === null || _customerData22$conta === void 0 ? void 0 : _customerData22$conta.email, '')
                  };
                  variables = saveQuoteVariables(lobCode, productCode, customerData, quotationType, members, cover, healthPlans, location, existingPolicyNumber, isExistingEmployee, selectedIntermediary, intermediaryDetails, maternitySelectedCover, maternityMembers);
                  doSaveQuote({
                    variables: variables
                  });
                  updateCustomerInformation({
                    customer: customerData,
                    customerMeta: {
                      crn: '',
                      isNewCustomer: false,
                      ifscCode: '',
                      bankName: '',
                      branchName: '',
                      bankAcno: '',
                      accountHolderName: '',
                      micrCode: ''
                    }
                  });
                  updateHealthQuote({
                    isQuoteSaving: true
                  });
                  onModalClose();
                }

                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                setErrors({
                  existingCustomers: _context5.t0.message
                });
                setLoadingExistingCustomers(false);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 10]]);
      }));

      function onRowClick(_x3) {
        return _onRowClick.apply(this, arguments);
      }

      return onRowClick;
    }(),
    sortBy: {
      id: 'cust_number',
      desc: false
    }
  };
  var paginationInput = {
    offset: 0,
    PAGE_SIZE: 4
  };

  var onMessage = function onMessage() {
    return customerSearchMetaMessage && customerSearchMetaMessage.type && customerSearchMetaMessage.message && CRSL.toString() === '' ? /*#__PURE__*/React.createElement(Text, {
      severity: customerSearchMetaMessage.type,
      className: "space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: customerSearchMetaMessage.type === 'info' ? faExclamationCircle : customerSearchMetaMessage.type === 'warning' ? faExclamationTriangle : faTimesCircle,
      className: "mr-1 text-".concat(customerSearchMetaMessage.type)
    })), /*#__PURE__*/React.createElement("div", null, customerSearchMetaMessage.message))) : /*#__PURE__*/React.createElement(Text, {
      severity: "error",
      className: "space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faExclamationCircle,
      className: "mr-1 text-error"
    })), /*#__PURE__*/React.createElement("div", null, "existing customer policy previous customer ID is not matching with selected customer ID")));
  };

  var renderTabData = [{
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserCheck
    }),
    label: 'Existing Customer',
    onTabClick: function onTabClick() {
      setEnableReinitialize(false);
    },
    tab_data: /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col justify-between h-full"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchResultsAdvanced, {
      searchInput: searchInput,
      searchResults: searchResults,
      paginationInput: paginationInput,
      onMessage: onMessage,
      onNoResultsFound: onNoResultsFound,
      isModalDisplay: true,
      firstRowClickRequired: false,
      switchViewEnabled: true
    })))
  }, state1.healthQuote.existingPolicyNumber === '' ? {
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserPlus
    }),
    label: 'New Customer',
    onTabClick: function onTabClick() {
      setEnableReinitialize(false);
    },
    tab_data: /*#__PURE__*/React.createElement(QuantaFormik, {
      initialValues: initialValuesNewCustomer,
      validate: validateNewCustomer,
      enableReinitialize: true
    }, /*#__PURE__*/React.createElement(NewCustomerForm, {
      validate: validateNewCustomer,
      setLocalNewCustomerValues: setLocalNewCustomerValues,
      onModalClose: onModalClose,
      setDropdownDetails: setDropdownDetails,
      lobCode: lobCode,
      productCode: productCode,
      setCustomerNameQuoteSaved: setCustomerNameQuoteSaved,
      doSaveQuote: doSaveQuote,
      selectedIntermediary: selectedIntermediary,
      setEnableReinitialize: setEnableReinitialize
    }))
  } : []];
  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: modalSize,
    title: 'Save Quote',
    className: "min-h-screen flex flex-col justify-start",
    onClose: onModalClose,
    severity: 'action'
  }, (loading_cust_type_domain || loading_character_limit || loading_mobile_number_starting_with) && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full"
  }, /*#__PURE__*/React.createElement(Loading, null)), (error_cust_type_domain || error_character_limit || error_mobile_number_starting_with) && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full"
  }, /*#__PURE__*/React.createElement(Error$1, {
    error: error_cust_type_domain || error_character_limit || error_mobile_number_starting_with
  })), !loading_cust_type_domain && !error_cust_type_domain && !loading_mobile_number_starting_with && !loading_character_limit && !error_mobile_number_starting_with && !error_character_limit && /*#__PURE__*/React.createElement(MixedTabbedDataGroup, {
    data: renderTabData,
    textType: "normal",
    titleSeverity: "info",
    repeat: tableRepeat,
    nullData: function nullData() {
      return /*#__PURE__*/React.createElement(Text, {
        severity: "neutral"
      }, "Not Captured");
    }
  }));
}

function QuoteSummary(_ref) {
  var _healthQuote$intermed3, _healthQuote$intermed4, _healthQuote$intermed5, _healthQuote$intermed6, _healthQuote$intermed7, _healthQuote$intermed8, _healthQuote$intermed9, _healthQuote$intermed10, _healthQuote$intermed11, _healthQuote$intermed12, _healthQuote$intermed13, _healthQuote$intermed14, _healthQuote$intermed15, _healthQuote$customer54, _healthQuote$customer55, _healthQuote$customer56, _healthQuote$customer57, _healthQuote$customer58, _healthQuote$customer59, _healthQuote$customer60, _healthQuote$customer61;

  var productCode = _ref.productCode,
      lobCode = _ref.lobCode,
      productName = _ref.productName,
      quoteNumber = _ref.quoteNumber,
      setsaveProceedDisplay = _ref.setsaveProceedDisplay;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showEmail = _useState4[0],
      setShowEmail = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showSms = _useState6[0],
      setShowSms = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showDownload = _useState8[0],
      setShowDownload = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      saveQuoteDisplay = _useState10[0],
      setSaveQuoteDisplay = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      loadingDownload = _useState12[0];
      _useState12[1];

  useMutationQuery();

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      customerNameQuoteSaved = _useState14[0],
      setCustomerNameQuoteSaved = _useState14[1];

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  var _useQuery2 = useQuery(CUSTOMER_DROPDOWN_DETAILS),
      loadingBusinessType = _useQuery2.loading,
      errorBusinessType = _useQuery2.error,
      businessTypeData = _useQuery2.data;

  var _useQuery3 = useQuery(INTERMEDIARY_LIST),
      intermediaryListLoading = _useQuery3.loading,
      intermediaryListError = _useQuery3.error,
      intermediaryListData = _useQuery3.data;

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    }) ? domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    })["".concat(returnType)] : '';
  };

  var getGraphQLErrorMessage = function getGraphQLErrorMessage(error) {
    return error.graphQLErrors.length > 0 ? error.graphQLErrors.map(function (gerr) {
      return gerr && gerr.message ? gerr.message : 'Internal Error Occurred';
    })[0] : error.message ? error.message : 'Internal Error Occurred';
  };

  var _useMutation = useMutation(SAVE_QUOTE, {
    onCompleted: function onCompleted(data) {
      if (productCode.toString() === '2883' && healthQuote.existingPolicyNumber.toString() !== '' && healthQuote.customerMeta.isNewCustomer.toString() === 'true') {
        {
          setAlerts([].concat(_toConsumableArray(alerts), [{
            header: 'Error',
            id: Date.now(),
            content: /*#__PURE__*/React.createElement("div", {
              className: "flex flex-row flex-wrap space-y-2 w-full h-full"
            }, "Existing policy discount is not applicable for New Customer in this product"),
            type: 'error',
            timeout: null,
            disableClose: false
          }]));
        }
      } else {
        updateQuotationDetails(data.saveQuote.quoteNumber, data.saveQuote.status, data.saveQuote.quoteCreationDate);
        setsaveProceedDisplay(false);
        updateHealthQuote({
          isQuoteSaving: false
        });
        setAlerts([{
          header: 'Quote Save Success',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-col w-full h-full"
          }, /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faCheck,
            className: "text-success"
          }), ' ', "Quote Saved successfully for", ' ', /*#__PURE__*/React.createElement("span", {
            className: "font-bold"
          }, customerNameQuoteSaved)), /*#__PURE__*/React.createElement(Text, {
            type: "normal"
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faCheck,
            className: "text-success"
          }), ' ', "Quotation Number: ", data.saveQuote.quoteNumber)),
          type: 'success',
          timeout: 5000,
          disableClose: false
        }]);
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    //
    onError: function onError(error) {
      setAlerts([].concat(_toConsumableArray(alerts), [{
        header: 'Error',
        id: Date.now(),
        content: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
        }, getGraphQLErrorMessage(error)),
        type: 'error',
        timeout: null,
        disableClose: false
      }]));
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSaveQuote = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      saveLoading = _useMutation2$.loading,
      saveError = _useMutation2$.error;

  if (loading || loadingBusinessType || intermediaryListLoading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error || errorBusinessType || intermediaryListError) return /*#__PURE__*/React.createElement(Error$1, null);
  var healthQuote = state.healthQuote,
      healthPlans = state.healthPlans,
      selectedIntermediary = state.selectedIntermediary;
  var businessTypeList = businessTypeData.businessTypeList;
  var myIntermediaries = intermediaryListData.myIntermediaries;

  var getBase64Var = function getBase64Var(healthQuote, plans, myIntermediaries) {
    var _healthQuote$intermed, _myIntermediaries$fin, _healthQuote$intermed2, _myIntermediaries$fin2, _healthQuote$customer, _healthQuote$customer2, _healthQuote$customer3, _healthQuote$customer4, _healthQuote$customer5, _healthQuote$customer6, _healthQuote$customer7, _healthQuote$customer8, _healthQuote$customer9, _healthQuote$customer10, _healthQuote$customer11, _healthQuote$customer12, _healthQuote$customer13, _healthQuote$customer14, _healthQuote$customer15, _healthQuote$customer16, _healthQuote$customer17, _healthQuote$customer18, _healthQuote$customer19, _healthQuote$customer20, _healthQuote$customer21, _healthQuote$customer22, _healthQuote$customer23, _healthQuote$customer24, _healthQuote$customer25, _healthQuote$customer26, _healthQuote$customer27, _healthQuote$customer28, _healthQuote$customer29, _healthQuote$customer30, _healthQuote$customer31, _healthQuote$customer32, _healthQuote$customer33, _healthQuote$customer34, _healthQuote$customer35, _healthQuote$customer36, _healthQuote$customer37, _healthQuote$customer38, _healthQuote$customer39, _healthQuote$customer40, _healthQuote$customer41, _healthQuote$customer42, _healthQuote$customer43, _healthQuote$customer44, _healthQuote$customer45, _healthQuote$customer46, _healthQuote$customer47, _healthQuote$customer48, _healthQuote$customer49, _healthQuote$customer50, _healthQuote$customer51, _healthQuote$customer52, _healthQuote$customer53, _healthQuote$location, _healthQuote$location2, _healthQuote$location3, _healthQuote$location4, _healthQuote$location5, _healthQuote$location6, _healthQuote$location7, _healthQuote$location8, _healthQuote$cover, _healthQuote$cover2, _healthQuote$cover3, _plans$filter;

    return {
      input: {
        quotationType: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationType,
        quoteCreationDate: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quoteCreationDate,
        intermediary: {
          intermediaryCode: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed !== void 0 && _healthQuote$intermed.code || myIntermediaries ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin = myIntermediaries.find(function (intermediary) {
            return intermediary === null || intermediary === void 0 ? void 0 : intermediary.isSelected;
          })) === null || _myIntermediaries$fin === void 0 ? void 0 : _myIntermediaries$fin.intermediaryCode : "",
          intermediaryName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed2 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed2 !== void 0 && _healthQuote$intermed2.name || myIntermediaries ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin2 = myIntermediaries.find(function (intermediary) {
            return intermediary === null || intermediary === void 0 ? void 0 : intermediary.isSelected;
          })) === null || _myIntermediaries$fin2 === void 0 ? void 0 : _myIntermediaries$fin2.intermediaryName : "",
          locationCode: '',
          fieldUserCode: ''
        },
        customer: {
          id: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer = healthQuote.customer) !== null && _healthQuote$customer !== void 0 && _healthQuote$customer.id ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer2 = healthQuote.customer) === null || _healthQuote$customer2 === void 0 ? void 0 : _healthQuote$customer2.id : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer3 = healthQuote.customer) === null || _healthQuote$customer3 === void 0 ? void 0 : _healthQuote$customer3.cust_number,
          customerType: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer4 = healthQuote.customer) !== null && _healthQuote$customer4 !== void 0 && _healthQuote$customer4.customerType ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer5 = healthQuote.customer) === null || _healthQuote$customer5 === void 0 ? void 0 : _healthQuote$customer5.customerType : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer6 = healthQuote.customer) === null || _healthQuote$customer6 === void 0 ? void 0 : (_healthQuote$customer7 = _healthQuote$customer6.cust_type) === null || _healthQuote$customer7 === void 0 ? void 0 : _healthQuote$customer7.code,
          // custCkyc: '123444',
          // panNo: 'BSAPG7676S',
          title: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer8 = healthQuote.customer) !== null && _healthQuote$customer8 !== void 0 && _healthQuote$customer8.title ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer9 = healthQuote.customer) === null || _healthQuote$customer9 === void 0 ? void 0 : _healthQuote$customer9.title : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer10 = healthQuote.customer) === null || _healthQuote$customer10 === void 0 ? void 0 : (_healthQuote$customer11 = _healthQuote$customer10.indv_detail) === null || _healthQuote$customer11 === void 0 ? void 0 : (_healthQuote$customer12 = _healthQuote$customer11.title) === null || _healthQuote$customer12 === void 0 ? void 0 : _healthQuote$customer12.code,
          firstName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer13 = healthQuote.customer) !== null && _healthQuote$customer13 !== void 0 && _healthQuote$customer13.firstName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer14 = healthQuote.customer) === null || _healthQuote$customer14 === void 0 ? void 0 : _healthQuote$customer14.firstName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer15 = healthQuote.customer) === null || _healthQuote$customer15 === void 0 ? void 0 : (_healthQuote$customer16 = _healthQuote$customer15.indv_detail) === null || _healthQuote$customer16 === void 0 ? void 0 : _healthQuote$customer16.first_name,
          middleName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer17 = healthQuote.customer) !== null && _healthQuote$customer17 !== void 0 && _healthQuote$customer17.middleName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer18 = healthQuote.customer) === null || _healthQuote$customer18 === void 0 ? void 0 : _healthQuote$customer18.middleName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer19 = healthQuote.customer) === null || _healthQuote$customer19 === void 0 ? void 0 : (_healthQuote$customer20 = _healthQuote$customer19.indv_detail) === null || _healthQuote$customer20 === void 0 ? void 0 : _healthQuote$customer20.middle_name,
          lastName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer21 = healthQuote.customer) !== null && _healthQuote$customer21 !== void 0 && _healthQuote$customer21.lastName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer22 = healthQuote.customer) === null || _healthQuote$customer22 === void 0 ? void 0 : _healthQuote$customer22.lastName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer23 = healthQuote.customer) === null || _healthQuote$customer23 === void 0 ? void 0 : (_healthQuote$customer24 = _healthQuote$customer23.indv_detail) === null || _healthQuote$customer24 === void 0 ? void 0 : _healthQuote$customer24.surname,
          fullName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer25 = healthQuote.customer) !== null && _healthQuote$customer25 !== void 0 && _healthQuote$customer25.fullName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer26 = healthQuote.customer) === null || _healthQuote$customer26 === void 0 ? void 0 : _healthQuote$customer26.fullName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer27 = healthQuote.customer) === null || _healthQuote$customer27 === void 0 ? void 0 : (_healthQuote$customer28 = _healthQuote$customer27.indv_detail) === null || _healthQuote$customer28 === void 0 ? void 0 : _healthQuote$customer28.full_name,
          emailID: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer29 = healthQuote.customer) !== null && _healthQuote$customer29 !== void 0 && _healthQuote$customer29.emailID ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer30 = healthQuote.customer) === null || _healthQuote$customer30 === void 0 ? void 0 : _healthQuote$customer30.emailID : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer31 = healthQuote.customer) === null || _healthQuote$customer31 === void 0 ? void 0 : (_healthQuote$customer32 = _healthQuote$customer31.contact) === null || _healthQuote$customer32 === void 0 ? void 0 : _healthQuote$customer32.email,
          mobileNo: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer33 = healthQuote.customer) !== null && _healthQuote$customer33 !== void 0 && _healthQuote$customer33.mobileNo ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer34 = healthQuote.customer) === null || _healthQuote$customer34 === void 0 ? void 0 : _healthQuote$customer34.mobileNo : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer35 = healthQuote.customer) === null || _healthQuote$customer35 === void 0 ? void 0 : (_healthQuote$customer36 = _healthQuote$customer35.contact) === null || _healthQuote$customer36 === void 0 ? void 0 : _healthQuote$customer36.mobile,
          proposerDOB: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer37 = healthQuote.customer) !== null && _healthQuote$customer37 !== void 0 && _healthQuote$customer37.proposerDOB ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer38 = healthQuote.customer) === null || _healthQuote$customer38 === void 0 ? void 0 : _healthQuote$customer38.proposerDOB : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer39 = healthQuote.customer) === null || _healthQuote$customer39 === void 0 ? void 0 : (_healthQuote$customer40 = _healthQuote$customer39.indv_detail) === null || _healthQuote$customer40 === void 0 ? void 0 : _healthQuote$customer40.date_of_birth,
          orgName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer41 = healthQuote.customer) !== null && _healthQuote$customer41 !== void 0 && _healthQuote$customer41.orgName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer42 = healthQuote.customer) === null || _healthQuote$customer42 === void 0 ? void 0 : _healthQuote$customer42.orgName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer43 = healthQuote.customer) === null || _healthQuote$customer43 === void 0 ? void 0 : (_healthQuote$customer44 = _healthQuote$customer43.org_detail) === null || _healthQuote$customer44 === void 0 ? void 0 : _healthQuote$customer44.org_name,
          orgType: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer45 = healthQuote.customer) !== null && _healthQuote$customer45 !== void 0 && _healthQuote$customer45.orgType ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer46 = healthQuote.customer) === null || _healthQuote$customer46 === void 0 ? void 0 : _healthQuote$customer46.orgType : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer47 = healthQuote.customer) === null || _healthQuote$customer47 === void 0 ? void 0 : (_healthQuote$customer48 = _healthQuote$customer47.org_detail) === null || _healthQuote$customer48 === void 0 ? void 0 : (_healthQuote$customer49 = _healthQuote$customer48.org_type) === null || _healthQuote$customer49 === void 0 ? void 0 : _healthQuote$customer49.code,
          contactName: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer50 = healthQuote.customer) !== null && _healthQuote$customer50 !== void 0 && _healthQuote$customer50.contactName ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer51 = healthQuote.customer) === null || _healthQuote$customer51 === void 0 ? void 0 : _healthQuote$customer51.contactName : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer52 = healthQuote.customer) === null || _healthQuote$customer52 === void 0 ? void 0 : (_healthQuote$customer53 = _healthQuote$customer52.org_detail) === null || _healthQuote$customer53 === void 0 ? void 0 : _healthQuote$customer53.contact_name
        },
        lob: lobCode,
        product: productCode,
        productName: productName,
        location: {
          pinCode: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location = healthQuote.location) === null || _healthQuote$location === void 0 ? void 0 : _healthQuote$location.pincode,
          state: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location2 = healthQuote.location) === null || _healthQuote$location2 === void 0 ? void 0 : _healthQuote$location2.state,
          stateCode: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location3 = healthQuote.location) === null || _healthQuote$location3 === void 0 ? void 0 : _healthQuote$location3.stateCode,
          district: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location4 = healthQuote.location) === null || _healthQuote$location4 === void 0 ? void 0 : _healthQuote$location4.district,
          districtCode: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location5 = healthQuote.location) === null || _healthQuote$location5 === void 0 ? void 0 : _healthQuote$location5.districtCode,
          city: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location6 = healthQuote.location) === null || _healthQuote$location6 === void 0 ? void 0 : _healthQuote$location6.city,
          cityCode: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location7 = healthQuote.location) === null || _healthQuote$location7 === void 0 ? void 0 : _healthQuote$location7.cityCode,
          zone: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$location8 = healthQuote.location) === null || _healthQuote$location8 === void 0 ? void 0 : _healthQuote$location8.zone
        },
        policyNumber: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.policyNumber,
        employeeNumber: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.employeeNumber,
        members: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.members.filter(function (mem) {
          return mem.selected;
        }).map(function (member) {
          return {
            relationship: member === null || member === void 0 ? void 0 : member.relationship,
            gender: member === null || member === void 0 ? void 0 : member.gender,
            dob: member === null || member === void 0 ? void 0 : member.dob,
            age: member === null || member === void 0 ? void 0 : member.age.toString()
          };
        }),
        cover: {
          type: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover = healthQuote.cover) === null || _healthQuote$cover === void 0 ? void 0 : _healthQuote$cover.type,
          sumInsured: parseInt(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover2 = healthQuote.cover) === null || _healthQuote$cover2 === void 0 ? void 0 : _healthQuote$cover2.sum_insured),
          tenure: healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$cover3 = healthQuote.cover) === null || _healthQuote$cover3 === void 0 ? void 0 : _healthQuote$cover3.tenure
        },
        plans: plans === null || plans === void 0 ? void 0 : (_plans$filter = plans.filter(function (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.isSelected;
        })) === null || _plans$filter === void 0 ? void 0 : _plans$filter.map(function (plan) {
          var _plan$premium, _plan$premium2, _plan$premium3, _plan$premium4, _plan$premium5, _plan$premium6, _plan$premium7, _plan$premium7$loadin, _plan$premium8, _plan$premium8$discou, _plan$premium9;

          return {
            name: plan === null || plan === void 0 ? void 0 : plan.name,
            code: plan === null || plan === void 0 ? void 0 : plan.code,
            covers: plan === null || plan === void 0 ? void 0 : plan.covers.map(function (cover) {
              return {
                name: cover === null || cover === void 0 ? void 0 : cover.name,
                index: cover === null || cover === void 0 ? void 0 : cover.index
              };
            }),
            packs: plan === null || plan === void 0 ? void 0 : plan.packs.map(function (pack) {
              return {
                name: pack === null || pack === void 0 ? void 0 : pack.name,
                index: pack === null || pack === void 0 ? void 0 : pack.index,
                addOnCovers: pack === null || pack === void 0 ? void 0 : pack.addOnCovers.map(function (addOn) {
                  return {
                    name: addOn === null || addOn === void 0 ? void 0 : addOn.name,
                    index: addOn === null || addOn === void 0 ? void 0 : addOn.index,
                    selected: addOn === null || addOn === void 0 ? void 0 : addOn.selected
                  };
                })
              };
            }),
            premium: {
              basePremium: plan === null || plan === void 0 ? void 0 : (_plan$premium = plan.premium) === null || _plan$premium === void 0 ? void 0 : _plan$premium.basePremium,
              loadingDiscount: plan === null || plan === void 0 ? void 0 : (_plan$premium2 = plan.premium) === null || _plan$premium2 === void 0 ? void 0 : _plan$premium2.loadingDiscount,
              netPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium3 = plan.premium) === null || _plan$premium3 === void 0 ? void 0 : _plan$premium3.netPremium,
              gst: plan === null || plan === void 0 ? void 0 : (_plan$premium4 = plan.premium) === null || _plan$premium4 === void 0 ? void 0 : _plan$premium4.gst,
              stampDuty: plan === null || plan === void 0 ? void 0 : (_plan$premium5 = plan.premium) === null || _plan$premium5 === void 0 ? void 0 : _plan$premium5.stampDuty,
              totalPremium: plan === null || plan === void 0 ? void 0 : (_plan$premium6 = plan.premium) === null || _plan$premium6 === void 0 ? void 0 : _plan$premium6.totalPremium,
              loading: plan === null || plan === void 0 ? void 0 : (_plan$premium7 = plan.premium) === null || _plan$premium7 === void 0 ? void 0 : (_plan$premium7$loadin = _plan$premium7.loading) === null || _plan$premium7$loadin === void 0 ? void 0 : _plan$premium7$loadin.map(function (loading) {
                return {
                  name: loading === null || loading === void 0 ? void 0 : loading.name,
                  amount: loading === null || loading === void 0 ? void 0 : loading.amount
                };
              }),
              discount: plan === null || plan === void 0 ? void 0 : (_plan$premium8 = plan.premium) === null || _plan$premium8 === void 0 ? void 0 : (_plan$premium8$discou = _plan$premium8.discount) === null || _plan$premium8$discou === void 0 ? void 0 : _plan$premium8$discou.map(function (discount) {
                return {
                  name: discount === null || discount === void 0 ? void 0 : discount.name,
                  amount: discount === null || discount === void 0 ? void 0 : discount.amount
                };
              }),
              breakup: plan === null || plan === void 0 ? void 0 : (_plan$premium9 = plan.premium) === null || _plan$premium9 === void 0 ? void 0 : _plan$premium9.breakup.map(function (brkup) {
                return {
                  relationship: brkup === null || brkup === void 0 ? void 0 : brkup.relationship,
                  gender: brkup === null || brkup === void 0 ? void 0 : brkup.gender,
                  age: brkup === null || brkup === void 0 ? void 0 : brkup.age,
                  premium: brkup === null || brkup === void 0 ? void 0 : brkup.premium
                };
              })
            }
          };
        }),
        deductibleSumInsured: healthQuote !== null && healthQuote !== void 0 && healthQuote.deductSumInsured ? healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.deductSumInsured : 0,
        fieldUserCode: selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode
      },
      quoteNumber: healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationNo
    };
  };

  var enableSave = function enableSave() {
    var premiumCalculated = 0;
    healthPlans.plans.forEach(function (plan) {
      if (plan.premium && plan.isSelected) premiumCalculated = premiumCalculated + 1;
    });
    return premiumCalculated !== 0;
  };

  var getIntermediaryName = function getIntermediaryName(code) {
    var _myIntermediaries$fin3;

    return myIntermediaries ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin3 = myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === code;
    })) === null || _myIntermediaries$fin3 === void 0 ? void 0 : _myIntermediaries$fin3.intermediaryName : code;
  };

  var getBusinessLocation = function getBusinessLocation(intermediarycode, locationCode) {
    var _myIntermediaries$fin4, _myIntermediaries$fin5, _myIntermediaries$fin6;

    return myIntermediaries && intermediarycode && locationCode ? myIntermediaries !== null && myIntermediaries !== void 0 && myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === intermediarycode;
    }) ? myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin4 = myIntermediaries.find(function (intermediary) {
      return (intermediary === null || intermediary === void 0 ? void 0 : intermediary.intermediaryCode) === intermediarycode;
    })) === null || _myIntermediaries$fin4 === void 0 ? void 0 : (_myIntermediaries$fin5 = _myIntermediaries$fin4.businessLocations) === null || _myIntermediaries$fin5 === void 0 ? void 0 : (_myIntermediaries$fin6 = _myIntermediaries$fin5.find(function (location) {
      return (location === null || location === void 0 ? void 0 : location.code) === locationCode;
    })) === null || _myIntermediaries$fin6 === void 0 ? void 0 : _myIntermediaries$fin6.name : locationCode : '';
  };

  var data = [healthQuote !== null && healthQuote !== void 0 && healthQuote.proposalNumber ? {
    label: healthQuote.proposalNumber ? 'Proposal Number' : undefined,
    text: healthQuote.proposalNumber
  } : undefined, healthQuote !== null && healthQuote !== void 0 && healthQuote.quotationNo ? {
    label: healthQuote.quotationNo ? 'Quotation Number' : undefined,
    text: healthQuote.quotationNo
  } : undefined, {
    label: 'Business Type',
    text: getDomainData(businessTypeList, healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.quotationType, 'code', 'value')
  }, healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed3 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed3 !== void 0 && _healthQuote$intermed3.code || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.intermediaryCode || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.intermediaryName ? {
    label: 'Partner',
    text: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed4 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed4 !== void 0 && _healthQuote$intermed4.code || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.intermediaryCode ? "".concat(getIntermediaryName((healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed5 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed5 === void 0 ? void 0 : _healthQuote$intermed5.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode)), " (", "".concat((healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed6 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed6 === void 0 ? void 0 : _healthQuote$intermed6.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode)), ")") : selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryName
  } : undefined, healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed7 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed7 !== void 0 && _healthQuote$intermed7.location || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.branchOfficeCode || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.branchOfficeName ? {
    label: 'Branch Office',
    text: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed8 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed8 !== void 0 && _healthQuote$intermed8.location || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.branchOfficeCode ? getBusinessLocation((healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed9 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed9 === void 0 ? void 0 : _healthQuote$intermed9.code) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode), (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed10 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed10 === void 0 ? void 0 : _healthQuote$intermed10.location) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeCode)) : selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.branchOfficeName
  } : undefined, healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed11 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed11 !== void 0 && _healthQuote$intermed11.fieldUserCode || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserCode || selectedIntermediary !== null && selectedIntermediary !== void 0 && selectedIntermediary.fieldUserName ? {
    label: 'Field User',
    text: healthQuote !== null && healthQuote !== void 0 && healthQuote.intermediaryDetails && healthQuote !== null && healthQuote !== void 0 && (_healthQuote$intermed12 = healthQuote.intermediaryDetails) !== null && _healthQuote$intermed12 !== void 0 && _healthQuote$intermed12.fieldUserCode && (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed13 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed13 === void 0 ? void 0 : _healthQuote$intermed13.fieldUserCode) !== '' ? /*#__PURE__*/React.createElement(GetFieldUserName, {
      code: (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed14 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed14 === void 0 ? void 0 : _healthQuote$intermed14.fieldUserCode) || (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.fieldUserCode)
    }) : (healthQuote === null || healthQuote === void 0 ? void 0 : healthQuote.intermediaryDetails.code) !== '' && (healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$intermed15 = healthQuote.intermediaryDetails) === null || _healthQuote$intermed15 === void 0 ? void 0 : _healthQuote$intermed15.fieldUserCode) === '' ? '' : selectedIntermediary.fieldUserName
  } : undefined, {
    text:
    /*#__PURE__*/
    // <TransactionComponent>
    React.createElement(Button, {
      disabled: healthQuote.quotationNo !== '' || healthQuote.currentTab === 'members' ? true : !enableSave() || saveLoading,
      size: "medium",
      className: "mt-2 w-full max-h-10",
      onClick: function onClick(_) {
        return setSaveQuoteDisplay(true);
      },
      flat: true,
      iconPre: saveLoading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true,
        className: "".concat((healthQuote.quotationNo !== '' ? true : !enableSave() || saveLoading) ? 'ml-4' : 'ml-6')
      }) : saveError ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faExclamationTriangle,
        className: (healthQuote.quotationNo !== '' ? true : !enableSave() || saveLoading) ? 'ml-4' : 'ml-6'
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSave,
        className: (healthQuote.quotationNo !== '' ? true : !enableSave() || saveLoading) ? 'ml-4' : 'ml-6'
      })
    }, saveLoading ? "Saving..." : 'Save Quote') // </TransactionComponent>

  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      disabled: healthQuote.quotationNo === '' ? true : loadingDownload,
      size: "medium",
      className: "mt-2 w-full max-h-10",
      flat: true,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEnvelope,
        className: !enableSave() ? 'ml-4' : 'ml-6'
      }),
      onClick: function onClick(e) {
        return setShowEmail(true);
      }
    }, "Email Quote")
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      disabled: healthQuote.quotationNo === '' ? true : loadingDownload,
      size: "medium",
      className: "mt-2 w-full max-h-10",
      flat: true,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSms,
        className: !enableSave() ? 'ml-4' : 'ml-6'
      }),
      onClick: function onClick(e) {
        return setShowSms(true);
      }
    }, "Message Quote")
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      disabled: healthQuote.quotationNo === '' || loadingDownload ? true : false,
      size: "medium",
      className: "mt-2 w-full max-h-10",
      flat: true,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: loadingDownload ? faSpinner : faDownload,
        spin: loadingDownload,
        className: !enableSave() ? 'ml-4' : 'ml-6'
      }),
      onClick: function onClick(_) {
        setShowDownload(true); // try {
        //   setLoadingDownload(true);
        //   let quotePDFBase64String = mutateQuery({
        //     mutation: SEND_QUOTE_PDF,
        //     variables: getBase64Var(healthQuote, healthPlans),
        //   });
        //   let { data: dataBase64String } =
        //     await quotePDFBase64String;
        //   const { sendQuotePDF } = dataBase64String;
        //   const { base64Pdf: downloadBase64String } =
        //     sendQuotePDF;
        //   setLoadingDownload(false);
        //   let byteCharacters = atob(
        //     downloadBase64String.toString(),
        //   );
        //   let byteNumbers = new Array(byteCharacters.length);
        //   for (let i = 0; i < byteCharacters.length; i++) {
        //     byteNumbers[i] = byteCharacters.charCodeAt(i);
        //   }
        //   let byteArray = new Uint8Array(byteNumbers);
        //   let file = new Blob([byteArray], {
        //     type: 'application/pdf;base64',
        //   });
        //   let fileURL = URL.createObjectURL(file);
        //   window.open(fileURL);
        // } catch (error) {
        //   setAlerts([
        //     {
        //       id: Date.now(),
        //       content: (
        //         <div className="flex flex-col w-full h-full">
        //           <Text type="normal">{error.message}</Text>
        //         </div>
        //       ),
        //       type: 'error',
        //       timeout: null,
        //       disableClose: false,
        //     },
        //   ]);
        //   setLoadingDownload(false);
        //   window.scrollTo({ top: 0, behavior: 'smooth' });
        // }
      }
    }, loadingDownload ? 'Downloading...' : 'Download Quote')
  }].filter(function (d) {
    return d;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pb-2"
  }, /*#__PURE__*/React.createElement(DataGrid, {
    textType: "normal",
    data: data,
    repeat: 1
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalSaveQuote, {
    saveQuoteDisplay: saveQuoteDisplay,
    setSaveQuoteDisplay: setSaveQuoteDisplay,
    setCustomerNameQuoteSaved: setCustomerNameQuoteSaved,
    doSaveQuote: doSaveQuote,
    productCode: productCode,
    lobCode: lobCode,
    selectedIntermediary: selectedIntermediary
  })), /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts,
    resetAlerts: function resetAlerts(idx) {
      var alertToBeRemovedPos = alerts.findIndex(function (a) {
        return a.id === idx;
      });
      setAlerts([].concat(_toConsumableArray(alerts.slice(0, alertToBeRemovedPos)), _toConsumableArray(alerts.slice(alertToBeRemovedPos + 1, alerts.length))));
    }
  }), /*#__PURE__*/React.createElement(ModalSendEmail, {
    setShowEmail: setShowEmail,
    showEmail: showEmail,
    initialEmail: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer54 = healthQuote.customer) !== null && _healthQuote$customer54 !== void 0 && _healthQuote$customer54.emailID ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer55 = healthQuote.customer) === null || _healthQuote$customer55 === void 0 ? void 0 : _healthQuote$customer55.emailID : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer56 = healthQuote.customer) === null || _healthQuote$customer56 === void 0 ? void 0 : (_healthQuote$customer57 = _healthQuote$customer56.contact) === null || _healthQuote$customer57 === void 0 ? void 0 : _healthQuote$customer57.email,
    getPayLoad: function getPayLoad(email, plans, ccEmailIds) {
      return _objectSpread2(_objectSpread2({}, getBase64Var(healthQuote, plans, myIntermediaries)), {}, {
        email: email,
        ccEmailIds: ccEmailIds
      });
    },
    SEND_EMAIL_QUERY: SEND_QUOTE_EMAIL_ALERT,
    productCode: productCode,
    productName: productName,
    lobCode: lobCode,
    quoteNumber: quoteNumber,
    plans: healthPlans === null || healthPlans === void 0 ? void 0 : healthPlans.plans
  }), /*#__PURE__*/React.createElement(ModalSendSms, {
    setShowSms: setShowSms,
    showSms: showSms,
    initialMobile: healthQuote !== null && healthQuote !== void 0 && (_healthQuote$customer58 = healthQuote.customer) !== null && _healthQuote$customer58 !== void 0 && _healthQuote$customer58.mobileNo ? healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer59 = healthQuote.customer) === null || _healthQuote$customer59 === void 0 ? void 0 : _healthQuote$customer59.mobileNo : healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$customer60 = healthQuote.customer) === null || _healthQuote$customer60 === void 0 ? void 0 : (_healthQuote$customer61 = _healthQuote$customer60.contact) === null || _healthQuote$customer61 === void 0 ? void 0 : _healthQuote$customer61.mobile,
    getPayLoad: function getPayLoad(mobile, plans, alternateMobileNos, whatsappNo, modes) {
      return _objectSpread2(_objectSpread2({}, getBase64Var(healthQuote, plans)), {}, {
        mobile: mobile,
        alternateMobileNos: alternateMobileNos,
        whatsappNo: whatsappNo,
        modes: modes
      });
    },
    SEND_SMS_QUERY: SEND_QUOTE_SMS_ALERT,
    productCode: productCode,
    productName: productName,
    quoteNumber: quoteNumber,
    plans: healthPlans === null || healthPlans === void 0 ? void 0 : healthPlans.plans
  }), /*#__PURE__*/React.createElement(ModalDownloadQuote, {
    SEND_DOWNLOAD_QUERY: SEND_QUOTE_PDF,
    getPayLoad: function getPayLoad(plans) {
      return _objectSpread2({}, getBase64Var(healthQuote, plans, myIntermediaries));
    },
    plans: healthPlans === null || healthPlans === void 0 ? void 0 : healthPlans.plans,
    setShowDownload: setShowDownload,
    showDownload: showDownload,
    productName: productName,
    quoteNumber: quoteNumber
  }));
}

function QuickSearchHealth(_ref) {
  var myIntermediaries = _ref.myIntermediaries,
      setAdvancedSearch = _ref.setAdvancedSearch,
      loading = _ref.loading,
      setFieldValue = _ref.setFieldValue,
      _ref$voice = _ref.voice,
      voice = _ref$voice === void 0 ? false : _ref$voice,
      disabled = _ref.disabled;

  var _useQuantaFormikConte = useQuantaFormikContext(),
      errors = _useQuantaFormikConte.errors,
      setFieldValueCxt = _useQuantaFormikConte.setFieldValue,
      resetForm = _useQuantaFormikConte.resetForm;

  var submitRef = useRef();

  var submitForm = function submitForm() {
    submitRef.current.click();
  };

  var isMobile = useResponsiveParams({
    for_mobile: true,
    for_desktop: false
  });
  var voiceArgs = {
    title: 'Search Quotes',
    commands: [{
      command: ['(search) with customer name *', '(search) for customer *'],
      callback: function callback(customerName) {
        resetForm();
        setFieldValueCxt('customerName', customerName);
        submitForm();
      }
    }, {
      command: ['(search) with (phone) number *', '(search) with (mobile) number *'],
      callback: function callback(mobileNumber) {
        resetForm();
        setFieldValueCxt('customerMobile', mobileNumber.replace(/\s+/g, ''));
        submitForm();
      }
    }, {
      command: ['(search) with (customer) name * and (phone) number *', '(search) with (customer) name * and (mobile) number *'],
      callback: function callback(customerName, mobileNumber) {
        resetForm();
        setFieldValueCxt('customerName', customerName);
        setFieldValueCxt('customerMobile', mobileNumber.replace(/\s+/g, ''));
        submitForm();
      }
    }, {
      command: ['(search) with (phone) number * and (customer) name *', '(search) with (mobile) number * and (customer) name *'],
      callback: function callback(mobileNumber, customerName) {
        resetForm();
        setFieldValueCxt('customerName', customerName);
        setFieldValueCxt('customerMobile', mobileNumber.replace(/\s+/g, ''));
        submitForm();
      }
    }, {
      command: 'clear',
      callback: function callback(_ref2) {
        var resetTranscript = _ref2.resetTranscript;
        resetForm();
        resetTranscript();
      }
    }],
    examples: [/*#__PURE__*/React.createElement("span", null, "search with customer name ", /*#__PURE__*/React.createElement("code", null, "Robert")), /*#__PURE__*/React.createElement("span", null, "search with mobile number ", /*#__PURE__*/React.createElement("code", null, "9831098310")), /*#__PURE__*/React.createElement("span", null, "search with mobile number ", /*#__PURE__*/React.createElement("code", null, "9831098310"), " and name ", /*#__PURE__*/React.createElement("code", null, "Robert")), 'clear']
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-8 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: isMobile ? "px-2 mx-".concat(isMobile ? 0 : 8, " border bg-neutral-light shadow rounded-full") : 'hidden'
  }, /*#__PURE__*/React.createElement(QuantaSelect, {
    noerror: true,
    size: "full",
    className: 'border-0 margin-0 h-10 bg-neutral-light hover:bg-neutral',
    name: "intermediaryCode",
    data: myIntermediaries ? _toConsumableArray(myIntermediaries.map(function (intermediaryCode) {
      return {
        label: intermediaryCode.intermediaryName ? intermediaryCode.intermediaryName : '',
        value: intermediaryCode.intermediaryCode ? intermediaryCode.intermediaryCode : ''
      };
    })) : []
  }), /*#__PURE__*/React.createElement(Text, {
    severity: "error",
    type: "label"
  }, errors.intermediaryCode)), /*#__PURE__*/React.createElement("div", {
    className: "px-2 mx-".concat(isMobile ? 0 : 8, " border bg-neutral-light shadow rounded-full flex flex-row justify-between")
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-4 pr-2 flex flex-row space-x-2 w-full"
  }, /*#__PURE__*/React.createElement(QuantaSelect, {
    noerror: true,
    className: isMobile ? 'hidden' : 'border-0 margin-0 h-8 bg-neutral-light',
    name: "intermediaryCode",
    data: myIntermediaries ? _toConsumableArray(myIntermediaries.map(function (intermediaryCode) {
      return {
        label: intermediaryCode.intermediaryName ? intermediaryCode.intermediaryName : '',
        value: intermediaryCode.intermediaryCode ? intermediaryCode.intermediaryCode : ''
      };
    })) : []
  }), /*#__PURE__*/React.createElement("div", {
    className: isMobile ? 'hidden' : 'border-l-2 border-neutral-dark my-2'
  }), /*#__PURE__*/React.createElement("span", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(QuantaInput, {
    noerror: true,
    size: "full",
    type: "text",
    name: "fuzzySearch",
    className: "border-0 margin-0 h-8 rounded-none bg-neutral-light",
    placeholder: "Please enter quote number or customer name or mobile",
    onDataChange: function onDataChange(val) {
      if (val.startsWith('Q')) {
        setFieldValue('quoteNumber', val);
        setFieldValue('customerMobile', '');
        setFieldValue('customerName', '');
      } else if (Number(val)) {
        setFieldValue('customerMobile', val);
        setFieldValue('quoteNumber', '');
        setFieldValue('customerName', '');
      } else {
        setFieldValue('customerName', val);
        setFieldValue('quoteNumber', '');
        setFieldValue('customerMobile', '');
      }
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "py-2 flex flex-row space-x-2 items-center"
  }, voice && /*#__PURE__*/React.createElement(QuantaVoiceActions, voiceArgs), /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    type: "submit",
    ref: submitRef
  }, /*#__PURE__*/React.createElement(CircleButton, null, loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true,
    size: "2x"
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSearch,
    size: "2x"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between px-10 pt-2"
  }, isMobile ? /*#__PURE__*/React.createElement(Text, {
    severity: "error",
    type: "label"
  }, errors.fuzzySearch) : /*#__PURE__*/React.createElement("div", {
    className: "-mt-2"
  }, /*#__PURE__*/React.createElement(Text, {
    severity: "error",
    type: "label"
  }, errors.intermediaryCode), /*#__PURE__*/React.createElement(Text, {
    severity: "error",
    type: "label",
    className: "pl-56"
  }, errors.fuzzySearch)), /*#__PURE__*/React.createElement("span", {
    className: "quanta_link text-sm",
    onClick: function onClick(e) {
      setAdvancedSearch(true);
      setFieldValue('fuzzySearch', '');
    }
  }, "Advanced Search")));
}

var _excluded$1 = ["lob"];

var offset = 0;
var PAGE_SIZE = 4;
function SmartSearchPanelHealth(_ref) {
  var _myIntermediaries$fin, _ref2;

  var alerts = _ref.alerts,
      setAlerts = _ref.setAlerts,
      voice = _ref.voice,
      setCopyQuoteDisplay = _ref.setCopyQuoteDisplay,
      setMoveToPlans = _ref.setMoveToPlans;

  var _useParams = useParams(),
      productCodeFromURL = _useParams.product_code;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      searchData = _useState2[0],
      setSearchData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      searchQuoteMeta = _useState4[0],
      setSearchQuoteMeta = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isIdle = _useState8[0],
      setIdle = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      advancedSearch = _useState10[0],
      setAdvancedSearch = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      copying = _useState12[0],
      setCopying = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      copyFromQuoteNumber = _useState14[0],
      setCopyFromQuoteNumber = _useState14[1];

  var noOfColsMobile = 1,
      noOfColsDesktop = 3;
  var inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop
  });
  var screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop'
  });
  var fetchQuery = useFetchQuery();
  useEffect(function () {
    initBuyHealthPolicyVar();
    initBuyMotorPolicyVar();
    initBuyIpaPolicyVar(); // initBuyWmcPolicyVar();
  }, []);

  var _useQuery = useQuery(INTERMEDIARY_LIST),
      loadingIntermediary = _useQuery.loading,
      intermediaryData = _useQuery.data;

  var _useQuery2 = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingLobDropdown = _useQuery2.loading,
      lobDropdownDetais = _useQuery2.data;

  var _useQuery3 = useQuery(DATE_RANGE, {
    variables: {
      type: 'Quote'
    },
    fetchPolicy: 'cache-first'
  }),
      loadingDateRange = _useQuery3.loading,
      dateRangeData = _useQuery3.data;

  var _useQuery4 = useQuery(QUOTE_STATUS_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loadingQuoteStatusDropdown = _useQuery4.loading,
      quoteStatusDropdown = _useQuery4.data;

  if (loadingLobDropdown || loadingQuoteStatusDropdown || loadingIntermediary || loadingDateRange) {
    return /*#__PURE__*/React.createElement(Card, {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  var lobProductList = lobDropdownDetais.lobProductList;
  var dateRange = dateRangeData.dateRange;
  var quoteStatusList = quoteStatusDropdown.quoteStatusList;
  var myIntermediaries = intermediaryData.myIntermediaries;
  var initialValues = {
    intermediaryCode: (_myIntermediaries$fin = myIntermediaries.find(function (imd) {
      return imd.isSelected;
    })) === null || _myIntermediaries$fin === void 0 ? void 0 : _myIntermediaries$fin.intermediaryCode,
    startDate: moment().subtract(dateRange.min, 'months').format('DD/MM/YYYY').toString(),
    endDate: moment().format('DD/MM/YYYY').toString(),
    productCode: productCodeFromURL ? productCodeFromURL : '',
    customerName: '',
    customerMobile: '',
    quoteStatus: quoteStatusList[0].code,
    quoteNumber: '',
    lob: '',
    searchType: 'I have a Quotation Number',
    // registrationNumber: '',
    // registrationNumberParts: {
    //   part1: '',
    //   part2: '',
    //   part3: '',
    //   part4: '',
    // },
    fuzzySearch: ''
  };

  var formValidate = function formValidate(values) {
    var errors = {};

    if (!values.intermediaryCode) {
      errors.intermediaryCode = '* Required';
    }

    if (!values.quoteNumber && !values.customerName && !values.customerMobile && !advancedSearch) {
      errors.fuzzySearch = '* Required';
    }

    if (advancedSearch) {
      if (!values.startDate || values.startDate === '') {
        errors.startDate = '* Required';
      } else if (!values.endDate || values.endDate === '') {
        errors.endDate = '* Required';
      }

      if (!values.productCode || values.productCode === '') {
        errors.productCode = '* Required';
      }
    }

    if (values.startDate !== '' && values.endDate !== '') {
      if (moment(values.endDate, 'DD/MM/YYYY').diff(moment(values.startDate, 'DD/MM/YYYY'), 'months') > dateRange.max) {
        errors.endDate = "* Date Range cannot be greater than ".concat(dateRange.max, " months");
      }

      if (moment(values.endDate, 'DD/MM/YYYY').isBefore(moment(values.startDate, 'DD/MM/YYYY'))) {
        errors.endDate = '* To Date cannot be before From Date';
      }
    }

    if (values !== null && values !== void 0 && values.customerName) {
      if (values.customerName.match(/^[0-9]+$/)) {
        errors.customerName = '* Customer Name cannot be all numeric';
      } else if (values.customerName.match(/^[_@!$%*^()=./#&+-]*$/)) {
        errors.customerName = '* Customer Name cannot be all special characters';
      } else if (values.customerName.match(/\d/)) {
        errors.customerName = '* Customer Name cannot be alphanumeric';
      }
    }

    return errors;
  };

  var searchInput = {
    flow: 'cols',
    repeat: inputColSpans,
    gapX: 8,
    gapY: 1,
    // title: 'Search Quotes',
    data: _toConsumableArray(!advancedSearch ? [{
      type: 'render',
      size: 'full',
      colSpan: 4,
      component: function component(values, setFieldValue, resetForm) {
        return /*#__PURE__*/React.createElement(QuickSearchHealth, {
          myIntermediaries: myIntermediaries,
          setAdvancedSearch: setAdvancedSearch,
          loading: loading,
          values: values,
          setFieldValue: setFieldValue,
          voice: voice,
          disabled: copying
        });
      }
    } // {
    //   type: 'render',
    //   colSpan: inputColSpans,
    //   component: (values, setFieldValue, resetForm) => {
    //     return (
    //       <div className="flex justify-end space-x-2 mb-4">
    //         <Button
    //           flat={true}
    //           type="button"
    //           className="w-40"
    //           onClick={(_) => {
    //             const otherFormValues = {
    //               intermediaryCode: values?.intermediaryCode,
    //               lob: values?.lob,
    //               productCode: values?.productCode,
    //               customerName: values?.customerName,
    //               startDate: values?.startDate,
    //               endDate: values?.endDate,
    //               quoteStatus: values?.quoteStatus,
    //               searchType: values?.searchType,
    //             };
    //             resetForm(initialValues);
    //             Object.keys(otherFormValues).forEach((k) => {
    //               setFieldValue(k, otherFormValues[k]);
    //             });
    //             setProductCode(null);
    //             setLocalValues({
    //               intermediaryCode: values?.intermediaryCode,
    //               lob: values?.lob,
    //               productCode: values?.productCode,
    //               customerName: values?.customerName,
    //               startDate: values?.startDate,
    //               endDate: values?.endDate,
    //               quoteStatus: values?.quoteStatus,
    //               searchType: values?.searchType,
    //             });
    //           }}
    //         >
    //           Reset
    //         </Button>
    //         <Button
    //           flat={false}
    //           type="submit"
    //           className="w-40"
    //           disabled={loading}
    //           iconPre={
    //             loading ? (
    //               <FontAwesomeIcon
    //                 icon={faSpinner}
    //                 spin={true}
    //               />
    //             ) : (
    //               <FontAwesomeIcon
    //                 icon={faSearch}
    //                 className="mx-2"
    //               />
    //             )
    //           }
    //         >
    //           Search
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
    ] : (_ref2 = [{
      type: 'select',
      size: 'full',
      label: /*#__PURE__*/React.createElement("div", null, "Choose Intermediary ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'intermediaryCode',
      disableSelect: true,
      disabled: copying,
      data: myIntermediaries ? _toConsumableArray(myIntermediaries.map(function (intermediaryCode) {
        return {
          label: intermediaryCode.intermediaryName ? intermediaryCode.intermediaryName : '',
          value: intermediaryCode.intermediaryCode ? intermediaryCode.intermediaryCode : ''
        };
      })) : []
    }, {
      type: 'date',
      size: 'full',
      label: /*#__PURE__*/React.createElement("div", null, "From Date ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'startDate',
      scrollStopWhenCalendarOpen: false,
      disabled: copying
    }, {
      type: 'date',
      size: 'full',
      label: /*#__PURE__*/React.createElement("div", null, "To Date ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'endDate',
      scrollStopWhenCalendarOpen: false,
      disabled: copying
    }, {
      type: 'text',
      size: 'full',
      label: /*#__PURE__*/React.createElement("div", null, "Customer Name ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'customerName',
      disabled: copying
    }, {
      type: 'select',
      size: 'large',
      mega: true,
      label: /*#__PURE__*/React.createElement("div", null, "Product ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      name: 'productCode',
      disabled: true,
      data: lobProductList === null || lobProductList === void 0 ? void 0 : lobProductList.map(function (lob) {
        return {
          category: lob.lob_name,
          values: lob.products.map(function (product) {
            return {
              label: product.product_name,
              value: product.product_code
            };
          })
        };
      })
    }, {
      type: 'select',
      size: 'full',
      label: /*#__PURE__*/React.createElement("div", null, "Quote Status ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'quoteStatus',
      disabled: copying,
      disableSelect: true,
      data: quoteStatusList ? _toConsumableArray(quoteStatusList.map(function (quoteStatus) {
        return {
          label: quoteStatus.value ? quoteStatus.value : '',
          value: quoteStatus.code ? quoteStatus.code : ''
        };
      })) : []
    }, // lobProductList
    //   ?.find((lob) =>
    //     lob?.products?.find(
    //       (product) =>
    //         product?.product_code
    //           ?.toString()
    //           ?.toLowerCase() ===
    //         productCode?.toString()?.toLowerCase(),
    //     ),
    //   )
    //   ?.lob_name?.toString()
    //   ?.toLowerCase() === 'motor'
    //   ? {
    //       type: 'input-wrapper',
    //       size: 'full',
    //       fields: [
    //         'registrationNumberParts.part1',
    //         'registrationNumberParts.part2',
    //         'registrationNumberParts.part3',
    //         'registrationNumberParts.part4',
    //       ],
    //       children: (
    //         <>
    //           <QuantaInput
    //             name="registrationNumberParts.part1"
    //             maxLength="2"
    //             size="full"
    //             type="text"
    //             placeholder="MH"
    //             noerror
    //             className="uppercase"
    //             onKeyUp={(e) => {
    //               if (e.target.value.length === 2) {
    //                 document
    //                   .getElementsByName(
    //                     'registrationNumberParts.part2',
    //                   )
    //                   .forEach((e) => e.focus());
    //               }
    //             }}
    //             onDataChange={(val, setFieldValue) => {
    //               setFieldValue(
    //                 `registrationNumberParts.part1`,
    //                 val?.toString()?.toUpperCase(),
    //               );
    //             }}
    //           />
    //           <Text
    //             className={`flex items-center font-bold h-12`}
    //           >
    //             -
    //           </Text>
    //           <QuantaInput
    //             name="registrationNumberParts.part2"
    //             maxLength="2"
    //             size="full"
    //             type="text"
    //             placeholder="01"
    //             noerror
    //             onKeyUp={(e) => {
    //               if (e.target.value.length === 2) {
    //                 document
    //                   .getElementsByName(
    //                     'registrationNumberParts.part3',
    //                   )
    //                   .forEach((e) => e.focus());
    //               }
    //             }}
    //           />
    //           <Text
    //             className={`flex items-center font-bold h-12`}
    //           >
    //             -
    //           </Text>
    //           <QuantaInput
    //             name="registrationNumberParts.part3"
    //             maxLength="2"
    //             size="full"
    //             type="text"
    //             placeholder="CR"
    //             noerror
    //             className="uppercase"
    //             onKeyUp={(e) => {
    //               if (e.target.value.length === 2) {
    //                 document
    //                   .getElementsByName(
    //                     'registrationNumberParts.part4',
    //                   )
    //                   .forEach((e) => e.focus());
    //               }
    //             }}
    //             onDataChange={(val, setFieldValue) => {
    //               setFieldValue(
    //                 `registrationNumberParts.part3`,
    //                 val?.toString()?.toUpperCase(),
    //               );
    //             }}
    //           />
    //           <Text
    //             className={`flex items-center font-bold h-12`}
    //           >
    //             -
    //           </Text>
    //           <QuantaInput
    //             name="registrationNumberParts.part4"
    //             maxLength="4"
    //             size="full"
    //             type="text"
    //             placeholder="2845"
    //             noerror
    //           />
    //         </>
    //       ),
    //       label: (
    //         <Text type={'label'}>
    //           Vehicle Registration Number
    //         </Text>
    //       ),
    //       name: 'registrationNumber',
    //     }
    //   : null,
    {
      type: 'render',
      colSpan: inputColSpans,
      component: function component(values, setFieldValue, resetForm) {
        var _screenType$toString, _screenType$toString2, _screenType$toString3, _screenType$toString4, _screenType$toString5, _screenType$toString6, _screenType$toString7;

        return /*#__PURE__*/React.createElement("div", {
          className: "flex ".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) === 'mobile' ? 'flex-col space-y-2 justify-between items-center' : 'space-x-2 justify-end', " mb-4")
        }, /*#__PURE__*/React.createElement(Text, {
          className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString2 = screenType.toString()) === null || _screenType$toString2 === void 0 ? void 0 : _screenType$toString2.toLowerCase()) === 'mobile' ? 'w-full' : ''
        }, /*#__PURE__*/React.createElement(Button, {
          flat: true,
          type: "button",
          className: "w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString3 = screenType.toString()) === null || _screenType$toString3 === void 0 ? void 0 : _screenType$toString3.toLowerCase()) === 'mobile' ? 'full' : '40', " border-0"),
          onClick: function onClick(_) {
            return setAdvancedSearch(false);
          },
          disabled: copying
        }, "Quick Search")), /*#__PURE__*/React.createElement(Text, {
          className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString4 = screenType.toString()) === null || _screenType$toString4 === void 0 ? void 0 : _screenType$toString4.toLowerCase()) === 'mobile' ? 'w-full' : ''
        }, /*#__PURE__*/React.createElement(Button, {
          flat: true,
          type: "button",
          className: "w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString5 = screenType.toString()) === null || _screenType$toString5 === void 0 ? void 0 : _screenType$toString5.toLowerCase()) === 'mobile' ? 'full' : '40'),
          disabled: copying,
          onClick: function onClick(_) {
            var otherFormValues = {
              intermediaryCode: values === null || values === void 0 ? void 0 : values.intermediaryCode,
              quoteNumber: values === null || values === void 0 ? void 0 : values.quoteNumber,
              searchType: values === null || values === void 0 ? void 0 : values.searchType
            };
            resetForm(initialValues);
            Object.keys(otherFormValues).forEach(function (k) {
              setFieldValue(k, otherFormValues[k]);
            });
          }
        }, "Reset")), /*#__PURE__*/React.createElement(Text, {
          className: (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString6 = screenType.toString()) === null || _screenType$toString6 === void 0 ? void 0 : _screenType$toString6.toLowerCase()) === 'mobile' ? 'w-full' : ''
        }, /*#__PURE__*/React.createElement(Button, {
          flat: false,
          type: "submit",
          className: "w-".concat((screenType === null || screenType === void 0 ? void 0 : (_screenType$toString7 = screenType.toString()) === null || _screenType$toString7 === void 0 ? void 0 : _screenType$toString7.toLowerCase()) === 'mobile' ? 'full' : '40'),
          disabled: loading || copying,
          iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faSpinner,
            spin: true
          }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faSearch,
            className: "mx-2"
          })
        }, "Search")));
      }
    }]) === null || _ref2 === void 0 ? void 0 : _ref2.filter(function (d) {
      return d;
    })),
    initialValues: initialValues,
    validate: formValidate,
    onSearch: function () {
      var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var requestBody, queryOutput, _yield$queryOutput, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setSearchData([]);
                setAlerts([]);
                requestBody = _objectWithoutProperties(values, _excluded$1);
                requestBody.startDate = moment(requestBody.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                requestBody.endDate = moment(requestBody.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                queryOutput = fetchQuery({
                  query: SEARCH_QUOTES,
                  variables: advancedSearch ? {
                    filter: {
                      intermediaryCode: values === null || values === void 0 ? void 0 : values.intermediaryCode,
                      productCode: values === null || values === void 0 ? void 0 : values.productCode,
                      customerName: values === null || values === void 0 ? void 0 : values.customerName,
                      startDate: requestBody === null || requestBody === void 0 ? void 0 : requestBody.startDate,
                      endDate: requestBody === null || requestBody === void 0 ? void 0 : requestBody.endDate,
                      quoteStatus: values === null || values === void 0 ? void 0 : values.quoteStatus,
                      //   vehicleRegNum: `${values?.registrationNumberParts?.part1}${values?.registrationNumberParts?.part2}${values?.registrationNumberParts?.part3}${values?.registrationNumberParts?.part4}`,
                      isFuzzySearch: false
                    }
                  } : values !== null && values !== void 0 && values.customerName ? {
                    filter: {
                      intermediaryCode: values === null || values === void 0 ? void 0 : values.intermediaryCode,
                      customerName: values === null || values === void 0 ? void 0 : values.customerName,
                      productCode: values === null || values === void 0 ? void 0 : values.productCode,
                      isFuzzySearch: true
                    }
                  } : values !== null && values !== void 0 && values.customerMobile ? {
                    filter: {
                      intermediaryCode: values === null || values === void 0 ? void 0 : values.intermediaryCode,
                      mobileNumber: values === null || values === void 0 ? void 0 : values.customerMobile,
                      productCode: values === null || values === void 0 ? void 0 : values.productCode,
                      isFuzzySearch: true
                    }
                  } : {
                    filter: {
                      intermediaryCode: values === null || values === void 0 ? void 0 : values.intermediaryCode,
                      quoteNumber: values === null || values === void 0 ? void 0 : values.quoteNumber,
                      productCode: values === null || values === void 0 ? void 0 : values.productCode,
                      isFuzzySearch: true
                    }
                  },
                  fetchPolicy: 'network-only'
                });
                setLoading(true);
                _context.next = 10;
                return queryOutput;

              case 10:
                _yield$queryOutput = _context.sent;
                data = _yield$queryOutput.data;
                setLoading(false);

                if (data.searchQuotes.length === 0 && data._quote_meta.metaMessage) {
                  setAlerts([{
                    header: data._quote_meta.metaMessage.header,
                    id: 1,
                    content: /*#__PURE__*/React.createElement("div", {
                      className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                    }, /*#__PURE__*/React.createElement("span", null, data._quote_meta.metaMessage.message)),
                    type: data._quote_meta.metaMessage.type,
                    timeout: null,
                    disableClose: false
                  }]); //   setCardSummaryDetail(undefined);
                } // if (data.searchQuotes.length === 1 && systemConfig?.searchRedirect === true) {
                //   history.push(
                //     `/quote/saved/${data?.searchQuotes[0]?.lob?.lobCode}/${data?.searchQuotes[0]?.lob?.lobName}/${data?.searchQuotes[0]?.product?.productCode}/${data?.searchQuotes[0]?.product?.productName}/${data.searchQuotes[0].quoteNumber}`,
                //   );
                // }
                //setSearchData(data?.searchQuotes?.filter((quote)=>quote?.product?.productCode?.toString()?.toLowerCase() === productCodeFromURL?.toString()?.toLowerCase()));


                setSearchData(data.searchQuotes);
                setSearchQuoteMeta(data._quote_meta);
                setIdle(false);
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                setAlerts([{
                  header: 'Quotes fetch failed',
                  id: 1,
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, /*#__PURE__*/React.createElement("span", null, _context.t0.message)),
                  type: 'error',
                  timeout: null,
                  disableClose: false
                }]);
                setLoading(false);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      function onSearch(_x) {
        return _onSearch.apply(this, arguments);
      }

      return onSearch;
    }()
  };
  var searchResults = {
    data: searchData,
    onIdle: function onIdle() {
      if (loading) return /*#__PURE__*/React.createElement(Loading, null);else if (isIdle) return /*#__PURE__*/React.createElement(React.Fragment, null);
      return undefined;
    },
    columns: [{
      Header: 'Customer Name',
      Cell: function Cell(_ref3) {
        var _row$original, _row$original$custome, _row$original$custome2, _row$original2, _row$original2$custom, _row$original2$custom2, _row$original3, _row$original3$custom, _row$original3$custom2, _row$original4, _row$original4$custom, _row$original4$custom2, _row$original5, _row$original5$custom, _row$original5$custom2, _row$original5$custom3, _row$original6, _row$original6$custom, _row$original6$custom2, _row$original6$custom3, _row$original7, _row$original7$custom, _row$original7$custom2, _row$original7$custom3;

        var row = _ref3.row;
        return /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col justify-center break-normal max-w-xs"
        }, /*#__PURE__*/React.createElement("span", null, (_row$original = row.original) !== null && _row$original !== void 0 && (_row$original$custome = _row$original.customer) !== null && _row$original$custome !== void 0 && (_row$original$custome2 = _row$original$custome.org_detail) !== null && _row$original$custome2 !== void 0 && _row$original$custome2.org_name ? (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : (_row$original2$custom = _row$original2.customer) === null || _row$original2$custom === void 0 ? void 0 : (_row$original2$custom2 = _row$original2$custom.org_detail) === null || _row$original2$custom2 === void 0 ? void 0 : _row$original2$custom2.org_name : (_row$original3 = row.original) !== null && _row$original3 !== void 0 && (_row$original3$custom = _row$original3.customer) !== null && _row$original3$custom !== void 0 && (_row$original3$custom2 = _row$original3$custom.indv_detail) !== null && _row$original3$custom2 !== void 0 && _row$original3$custom2.full_name ? (_row$original4 = row.original) === null || _row$original4 === void 0 ? void 0 : (_row$original4$custom = _row$original4.customer) === null || _row$original4$custom === void 0 ? void 0 : (_row$original4$custom2 = _row$original4$custom.indv_detail) === null || _row$original4$custom2 === void 0 ? void 0 : _row$original4$custom2.full_name : [(_row$original5 = row.original) === null || _row$original5 === void 0 ? void 0 : (_row$original5$custom = _row$original5.customer) === null || _row$original5$custom === void 0 ? void 0 : (_row$original5$custom2 = _row$original5$custom.indv_detail) === null || _row$original5$custom2 === void 0 ? void 0 : (_row$original5$custom3 = _row$original5$custom2.first_name) === null || _row$original5$custom3 === void 0 ? void 0 : _row$original5$custom3.trim(), (_row$original6 = row.original) === null || _row$original6 === void 0 ? void 0 : (_row$original6$custom = _row$original6.customer) === null || _row$original6$custom === void 0 ? void 0 : (_row$original6$custom2 = _row$original6$custom.indv_detail) === null || _row$original6$custom2 === void 0 ? void 0 : (_row$original6$custom3 = _row$original6$custom2.middle_name) === null || _row$original6$custom3 === void 0 ? void 0 : _row$original6$custom3.trim(), (_row$original7 = row.original) === null || _row$original7 === void 0 ? void 0 : (_row$original7$custom = _row$original7.customer) === null || _row$original7$custom === void 0 ? void 0 : (_row$original7$custom2 = _row$original7$custom.indv_detail) === null || _row$original7$custom2 === void 0 ? void 0 : (_row$original7$custom3 = _row$original7$custom2.surname) === null || _row$original7$custom3 === void 0 ? void 0 : _row$original7$custom3.trim()].join(' ')));
      }
    }, {
      Header: 'Contact',
      Cell: function Cell(_ref4) {
        var row = _ref4.row;
        return /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col justify-center"
        }, /*#__PURE__*/React.createElement("span", null, row.original.customer && row.original.customer.contact && row.original.customer.contact.email ? row.original.customer.contact.email : null), /*#__PURE__*/React.createElement("span", null, row.original.customer && row.original.customer.contact && row.original.customer.contact.mobile ? row.original.customer.contact.mobile : null));
      }
    }, {
      Header: 'Quote Reference Number',
      accessor: 'quoteNumber'
    }, {
      Header: 'Quote Status / Saved On',
      Cell: function Cell(_ref5) {
        var _row$original8, _row$original9;

        var row = _ref5.row;
        return /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col justify-center"
        }, /*#__PURE__*/React.createElement("span", null, (_row$original8 = row.original) === null || _row$original8 === void 0 ? void 0 : _row$original8.quoteStatus), /*#__PURE__*/React.createElement("span", null, (_row$original9 = row.original) === null || _row$original9 === void 0 ? void 0 : _row$original9.quoteCreationDate));
      }
    }, {
      Header: ' ',
      Cell: function Cell(_ref6) {
        var _row$original12, _row$original13, _row$original14;

        var row = _ref6.row;
        return /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end w-full"
        }, /*#__PURE__*/React.createElement(Button, {
          type: 'button',
          flat: false,
          onClick: /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
              var _row$original10, _row$original11, _quoteDetailsData$vie, _healthQuote$members, _quoteDetailsData$vie4, _quoteDetailsData$vie5, _quoteDetailsData$vie6, _quoteDetailsData$vie7, _quoteDetailsData$vie8, _quoteDetailsData$vie9, _quoteDetailsData$vie10, _quoteDetailsData$vie11, _quoteDetailsData$vie12, _quoteDetailsData$vie13, _quoteDetailsData$vie14, _quoteDetailsData$vie15, _quoteDetailsData$vie16, _quoteDetailsData$vie17, _quoteDetailsData$vie18, _quoteDetailsData$vie19, _window, fetchQuoteDetails, getHealthQuoteVar, _yield$fetchQuoteDeta, quoteDetailsData, _yield$getHealthQuote, healthReactiveVarData, healthQuote;

              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      e.stopPropagation();
                      _context2.prev = 1;
                      fetchQuoteDetails = fetchQuery({
                        query: VIEW_QUOTE_HEALTH,
                        variables: {
                          input: {
                            quoteNumber: row === null || row === void 0 ? void 0 : (_row$original10 = row.original) === null || _row$original10 === void 0 ? void 0 : _row$original10.quoteNumber
                          }
                        }
                      });
                      getHealthQuoteVar = fetchQuery({
                        query: QUERY_STATE
                      });
                      setAlerts([]);
                      setCopyFromQuoteNumber(row === null || row === void 0 ? void 0 : (_row$original11 = row.original) === null || _row$original11 === void 0 ? void 0 : _row$original11.quoteNumber);
                      setCopying(true);
                      _context2.next = 9;
                      return fetchQuoteDetails;

                    case 9:
                      _yield$fetchQuoteDeta = _context2.sent;
                      quoteDetailsData = _yield$fetchQuoteDeta.data;
                      _context2.next = 13;
                      return getHealthQuoteVar;

                    case 13:
                      _yield$getHealthQuote = _context2.sent;
                      healthReactiveVarData = _yield$getHealthQuote.data;
                      healthQuote = healthReactiveVarData.healthQuote;
                      setCopying(false);
                      updateHealthQuote({
                        currentTab: 'plans',
                        captureMode: 'create',
                        location: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie === void 0 ? void 0 : _quoteDetailsData$vie.location,
                        members: [].concat(_toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$members = healthQuote.members) === null || _healthQuote$members === void 0 ? void 0 : _healthQuote$members.map(function (member) {
                          var _quoteDetailsData$vie2, _quoteDetailsData$vie3;

                          var searchMemObj = quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie2 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie2 === void 0 ? void 0 : (_quoteDetailsData$vie3 = _quoteDetailsData$vie2.members) === null || _quoteDetailsData$vie3 === void 0 ? void 0 : _quoteDetailsData$vie3.find(function (m) {
                            var _m$relationship, _m$relationship$toStr, _member$relationship, _member$relationship$;

                            return (m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : (_m$relationship$toStr = _m$relationship.toString()) === null || _m$relationship$toStr === void 0 ? void 0 : _m$relationship$toStr.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship = member.relationship) === null || _member$relationship === void 0 ? void 0 : (_member$relationship$ = _member$relationship.toString()) === null || _member$relationship$ === void 0 ? void 0 : _member$relationship$.toLowerCase());
                          });

                          if (searchMemObj) {
                            return {
                              relationship: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.relationship,
                              age: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.age,
                              gender: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.gender,
                              dob: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.dob,
                              selected: true,
                              maternitySelected: searchMemObj !== null && searchMemObj !== void 0 && searchMemObj.maternitySelected ? searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.maternitySelected : false
                            };
                          } else {
                            return _objectSpread2(_objectSpread2({}, member), {}, {
                              selected: false
                            });
                          }
                        })), _toConsumableArray((quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie4 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie4 === void 0 ? void 0 : (_quoteDetailsData$vie5 = _quoteDetailsData$vie4.members) === null || _quoteDetailsData$vie5 === void 0 ? void 0 : (_quoteDetailsData$vie6 = _quoteDetailsData$vie5.filter(function (member) {
                          var _healthQuote$members2;

                          return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members2 = healthQuote.members) !== null && _healthQuote$members2 !== void 0 && _healthQuote$members2.find(function (m) {
                            var _m$relationship2, _m$relationship2$toSt, _member$relationship2, _member$relationship3;

                            return (m === null || m === void 0 ? void 0 : (_m$relationship2 = m.relationship) === null || _m$relationship2 === void 0 ? void 0 : (_m$relationship2$toSt = _m$relationship2.toString()) === null || _m$relationship2$toSt === void 0 ? void 0 : _m$relationship2$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship2 = member.relationship) === null || _member$relationship2 === void 0 ? void 0 : (_member$relationship3 = _member$relationship2.toString()) === null || _member$relationship3 === void 0 ? void 0 : _member$relationship3.toLowerCase());
                          }));
                        })) === null || _quoteDetailsData$vie6 === void 0 ? void 0 : _quoteDetailsData$vie6.length) > 0 ? quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie7 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie7 === void 0 ? void 0 : (_quoteDetailsData$vie8 = _quoteDetailsData$vie7.members) === null || _quoteDetailsData$vie8 === void 0 ? void 0 : (_quoteDetailsData$vie9 = _quoteDetailsData$vie8.filter(function (member) {
                          var _healthQuote$members3;

                          return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members3 = healthQuote.members) !== null && _healthQuote$members3 !== void 0 && _healthQuote$members3.find(function (m) {
                            var _m$relationship3, _m$relationship3$toSt, _member$relationship4, _member$relationship5;

                            return (m === null || m === void 0 ? void 0 : (_m$relationship3 = m.relationship) === null || _m$relationship3 === void 0 ? void 0 : (_m$relationship3$toSt = _m$relationship3.toString()) === null || _m$relationship3$toSt === void 0 ? void 0 : _m$relationship3$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship4 = member.relationship) === null || _member$relationship4 === void 0 ? void 0 : (_member$relationship5 = _member$relationship4.toString()) === null || _member$relationship5 === void 0 ? void 0 : _member$relationship5.toLowerCase());
                          }));
                        })) === null || _quoteDetailsData$vie9 === void 0 ? void 0 : _quoteDetailsData$vie9.map(function (mem) {
                          return {
                            relationship: mem === null || mem === void 0 ? void 0 : mem.relationship,
                            age: mem === null || mem === void 0 ? void 0 : mem.age,
                            gender: mem === null || mem === void 0 ? void 0 : mem.gender,
                            dob: mem === null || mem === void 0 ? void 0 : mem.dob,
                            selected: true,
                            maternitySelected: mem !== null && mem !== void 0 && mem.maternitySelected ? mem === null || mem === void 0 ? void 0 : mem.maternitySelected : false
                          };
                        }) : [])),
                        cover: {
                          type: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie10 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie10 === void 0 ? void 0 : (_quoteDetailsData$vie11 = _quoteDetailsData$vie10.cover) === null || _quoteDetailsData$vie11 === void 0 ? void 0 : _quoteDetailsData$vie11.type,
                          sum_insured: "".concat(quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie12 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie12 === void 0 ? void 0 : (_quoteDetailsData$vie13 = _quoteDetailsData$vie12.cover) === null || _quoteDetailsData$vie13 === void 0 ? void 0 : _quoteDetailsData$vie13.sumInsured),
                          tenure: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie14 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie14 === void 0 ? void 0 : (_quoteDetailsData$vie15 = _quoteDetailsData$vie14.cover) === null || _quoteDetailsData$vie15 === void 0 ? void 0 : _quoteDetailsData$vie15.tenure
                        },
                        maternitySelectedCover: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie16 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie16 === void 0 ? void 0 : _quoteDetailsData$vie16.maternitySelectedCover,
                        quotationType: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie17 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie17 === void 0 ? void 0 : _quoteDetailsData$vie17.quotationType,
                        existingPolicyNumber: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie18 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie18 === void 0 ? void 0 : _quoteDetailsData$vie18.existingPolicyNumber,
                        isExistingEmployee: quoteDetailsData !== null && quoteDetailsData !== void 0 && (_quoteDetailsData$vie19 = quoteDetailsData.viewQuote) !== null && _quoteDetailsData$vie19 !== void 0 && _quoteDetailsData$vie19.isExistingEmployee ? 'Yes' : 'No'
                      });
                      initHealthPlansState();
                      setCopyQuoteDisplay(false);
                      setMoveToPlans(true);
                      document.body.classList.remove('overflow-y-hidden');
                      (_window = window) === null || _window === void 0 ? void 0 : _window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                      _context2.next = 30;
                      break;

                    case 25:
                      _context2.prev = 25;
                      _context2.t0 = _context2["catch"](1);
                      setCopying(false);
                      setCopyFromQuoteNumber('');
                      setAlerts([{
                        id: Date.now() + Math.random(),
                        content: /*#__PURE__*/React.createElement(Text, null, _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message),
                        type: 'error',
                        disableClose: false,
                        timeout: 3000
                      }]);

                    case 30:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[1, 25]]);
            }));

            return function (_x2) {
              return _ref7.apply(this, arguments);
            };
          }(),
          size: 'small',
          className: "flex items-center h-8 space-x-2 w-24",
          iconPre: copying && copyFromQuoteNumber === (row === null || row === void 0 ? void 0 : (_row$original12 = row.original) === null || _row$original12 === void 0 ? void 0 : _row$original12.quoteNumber) ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faSpinner,
            spin: true
          }) : undefined,
          iconPost: copying && copyFromQuoteNumber === (row === null || row === void 0 ? void 0 : (_row$original13 = row.original) === null || _row$original13 === void 0 ? void 0 : _row$original13.quoteNumber) ? undefined : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faChevronRight
          }),
          disabled: copying
        }, copying && copyFromQuoteNumber === (row === null || row === void 0 ? void 0 : (_row$original14 = row.original) === null || _row$original14 === void 0 ? void 0 : _row$original14.quoteNumber) ? 'Importing...' : 'Import'));
      }
    }].filter(function (d) {
      return d.Header !== undefined;
    }),
    grid: {
      repeat: 1,
      gap: 2,
      gapX: 2,
      gapY: 2,
      gridClassName: 'w-full',
      gridItemsArr: (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 0 ? searchData === null || searchData === void 0 ? void 0 : searchData.map(function (quoteData) {
        var _quoteData$product, _quoteData$customer, _quoteData$customer$i, _quoteData$customer2, _quoteData$customer2$, _quoteData$lob, _quoteData$lob$lobNam, _quoteData$lob$lobNam2, _quoteData$customer3, _quoteData$customer3$, _quoteData$customer4, _quoteData$customer4$, _quoteData$customer5, _quoteData$customer5$, _quoteData$customer6, _quoteData$customer6$, _quoteData$customer7, _quoteData$customer7$, _quoteData$customer8, _quoteData$customer8$;

        return {
          id: "".concat(quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber),
          content: /*#__PURE__*/React.createElement(Paper, {
            className: "border-2 rounded p-4 min-h-full \n                    ".concat('hover:bg-neutral-light', "\n                    ")
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col w-full justify-between h-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex items-center justify-between h-full w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold flex space-x-2 items-start w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col justify-start items-center'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: "border-2 w-14 flex flex-col items-center justify-center h-12 rounded-lg bg-white mr-1.5"
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faHeartbeat,
            size: '2x'
          }))), /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col h-full justify-between w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'font-semibold w-full flex space-x-2 justify-between'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber, ",", quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$product = quoteData.product) === null || _quoteData$product === void 0 ? void 0 : _quoteData$product.productName), /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteStatus)), /*#__PURE__*/React.createElement(Text, {
            type: 'label',
            className: 'w-full h-full mb-5 text-neutral-darker'
          }, "Saved on ", quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteCreationDate), /*#__PURE__*/React.createElement(Text, {
            className: 'w-full h-full'
          }, /*#__PURE__*/React.createElement(Grid, {
            repeat: 4,
            className: 'w-full h-full'
          }, quoteData !== null && quoteData !== void 0 && (_quoteData$customer = quoteData.customer) !== null && _quoteData$customer !== void 0 && (_quoteData$customer$i = _quoteData$customer.indv_detail) !== null && _quoteData$customer$i !== void 0 && _quoteData$customer$i.full_name || quoteData !== null && quoteData !== void 0 && (_quoteData$customer2 = quoteData.customer) !== null && _quoteData$customer2 !== void 0 && (_quoteData$customer2$ = _quoteData$customer2.org_detail) !== null && _quoteData$customer2$ !== void 0 && _quoteData$customer2$.org_name ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: (quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$lob = quoteData.lob) === null || _quoteData$lob === void 0 ? void 0 : (_quoteData$lob$lobNam = _quoteData$lob.lobName) === null || _quoteData$lob$lobNam === void 0 ? void 0 : (_quoteData$lob$lobNam2 = _quoteData$lob$lobNam.toString()) === null || _quoteData$lob$lobNam2 === void 0 ? void 0 : _quoteData$lob$lobNam2.toLowerCase()) === 'fire' ? 3 : 1,
            className: 'flex space-x-2 w-full justify-start'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUser
          })), /*#__PURE__*/React.createElement(Text, null, (quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer3 = quoteData.customer) === null || _quoteData$customer3 === void 0 ? void 0 : (_quoteData$customer3$ = _quoteData$customer3.indv_detail) === null || _quoteData$customer3$ === void 0 ? void 0 : _quoteData$customer3$.full_name) || (quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer4 = quoteData.customer) === null || _quoteData$customer4 === void 0 ? void 0 : (_quoteData$customer4$ = _quoteData$customer4.org_detail) === null || _quoteData$customer4$ === void 0 ? void 0 : _quoteData$customer4$.org_name))) : '', quoteData !== null && quoteData !== void 0 && (_quoteData$customer5 = quoteData.customer) !== null && _quoteData$customer5 !== void 0 && (_quoteData$customer5$ = _quoteData$customer5.contact) !== null && _quoteData$customer5$ !== void 0 && _quoteData$customer5$.mobile ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMobileAlt
          })), /*#__PURE__*/React.createElement(Text, null, quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer6 = quoteData.customer) === null || _quoteData$customer6 === void 0 ? void 0 : (_quoteData$customer6$ = _quoteData$customer6.contact) === null || _quoteData$customer6$ === void 0 ? void 0 : _quoteData$customer6$.mobile)) : '', quoteData !== null && quoteData !== void 0 && (_quoteData$customer7 = quoteData.customer) !== null && _quoteData$customer7 !== void 0 && (_quoteData$customer7$ = _quoteData$customer7.contact) !== null && _quoteData$customer7$ !== void 0 && _quoteData$customer7$.email ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full'
          }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faEnvelope
          })), /*#__PURE__*/React.createElement(Text, null, quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer8 = quoteData.customer) === null || _quoteData$customer8 === void 0 ? void 0 : (_quoteData$customer8$ = _quoteData$customer8.contact) === null || _quoteData$customer8$ === void 0 ? void 0 : _quoteData$customer8$.email)) : '', /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full justify-end'
          }, /*#__PURE__*/React.createElement(Text, {
            className: "flex justify-end"
          }, /*#__PURE__*/React.createElement(Button, {
            type: 'button',
            flat: false,
            onClick: /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                var _quoteDetailsData$vie20, _healthQuote$members4, _quoteDetailsData$vie23, _quoteDetailsData$vie24, _quoteDetailsData$vie25, _quoteDetailsData$vie26, _quoteDetailsData$vie27, _quoteDetailsData$vie28, _quoteDetailsData$vie29, _quoteDetailsData$vie30, _quoteDetailsData$vie31, _quoteDetailsData$vie32, _quoteDetailsData$vie33, _quoteDetailsData$vie34, _quoteDetailsData$vie35, _quoteDetailsData$vie36, _quoteDetailsData$vie37, _quoteDetailsData$vie38, _window2, fetchQuoteDetails, getHealthQuoteVar, _yield$fetchQuoteDeta2, quoteDetailsData, _yield$getHealthQuote2, healthReactiveVarData, healthQuote;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        e.stopPropagation();
                        _context3.prev = 1;
                        fetchQuoteDetails = fetchQuery({
                          query: VIEW_QUOTE_HEALTH,
                          fetchPolicy: 'network-only',
                          variables: {
                            input: {
                              quoteNumber: quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber
                            }
                          }
                        });
                        getHealthQuoteVar = fetchQuery({
                          query: QUERY_STATE
                        });
                        setAlerts([]);
                        setCopyFromQuoteNumber(quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber);
                        setCopying(true);
                        _context3.next = 9;
                        return fetchQuoteDetails;

                      case 9:
                        _yield$fetchQuoteDeta2 = _context3.sent;
                        quoteDetailsData = _yield$fetchQuoteDeta2.data;
                        _context3.next = 13;
                        return getHealthQuoteVar;

                      case 13:
                        _yield$getHealthQuote2 = _context3.sent;
                        healthReactiveVarData = _yield$getHealthQuote2.data;
                        healthQuote = healthReactiveVarData.healthQuote;
                        setCopying(false);
                        updateHealthQuote({
                          currentTab: 'plans',
                          captureMode: 'create',
                          location: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie20 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie20 === void 0 ? void 0 : _quoteDetailsData$vie20.location,
                          members: [].concat(_toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$members4 = healthQuote.members) === null || _healthQuote$members4 === void 0 ? void 0 : _healthQuote$members4.map(function (member) {
                            var _quoteDetailsData$vie21, _quoteDetailsData$vie22;

                            var searchMemObj = quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie21 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie21 === void 0 ? void 0 : (_quoteDetailsData$vie22 = _quoteDetailsData$vie21.members) === null || _quoteDetailsData$vie22 === void 0 ? void 0 : _quoteDetailsData$vie22.find(function (m) {
                              var _m$relationship4, _m$relationship4$toSt, _member$relationship6, _member$relationship7;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship4 = m.relationship) === null || _m$relationship4 === void 0 ? void 0 : (_m$relationship4$toSt = _m$relationship4.toString()) === null || _m$relationship4$toSt === void 0 ? void 0 : _m$relationship4$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship6 = member.relationship) === null || _member$relationship6 === void 0 ? void 0 : (_member$relationship7 = _member$relationship6.toString()) === null || _member$relationship7 === void 0 ? void 0 : _member$relationship7.toLowerCase());
                            });

                            if (searchMemObj) {
                              return {
                                relationship: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.relationship,
                                age: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.age,
                                gender: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.gender,
                                dob: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.dob,
                                selected: true,
                                maternitySelected: searchMemObj !== null && searchMemObj !== void 0 && searchMemObj.maternitySelected ? searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.maternitySelected : false
                              };
                            } else {
                              return _objectSpread2(_objectSpread2({}, member), {}, {
                                selected: false
                              });
                            }
                          })), _toConsumableArray((quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie23 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie23 === void 0 ? void 0 : (_quoteDetailsData$vie24 = _quoteDetailsData$vie23.members) === null || _quoteDetailsData$vie24 === void 0 ? void 0 : (_quoteDetailsData$vie25 = _quoteDetailsData$vie24.filter(function (member) {
                            var _healthQuote$members5;

                            return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members5 = healthQuote.members) !== null && _healthQuote$members5 !== void 0 && _healthQuote$members5.find(function (m) {
                              var _m$relationship5, _m$relationship5$toSt, _member$relationship8, _member$relationship9;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship5 = m.relationship) === null || _m$relationship5 === void 0 ? void 0 : (_m$relationship5$toSt = _m$relationship5.toString()) === null || _m$relationship5$toSt === void 0 ? void 0 : _m$relationship5$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship8 = member.relationship) === null || _member$relationship8 === void 0 ? void 0 : (_member$relationship9 = _member$relationship8.toString()) === null || _member$relationship9 === void 0 ? void 0 : _member$relationship9.toLowerCase());
                            }));
                          })) === null || _quoteDetailsData$vie25 === void 0 ? void 0 : _quoteDetailsData$vie25.length) > 0 ? quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie26 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie26 === void 0 ? void 0 : (_quoteDetailsData$vie27 = _quoteDetailsData$vie26.members) === null || _quoteDetailsData$vie27 === void 0 ? void 0 : (_quoteDetailsData$vie28 = _quoteDetailsData$vie27.filter(function (member) {
                            var _healthQuote$members6;

                            return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members6 = healthQuote.members) !== null && _healthQuote$members6 !== void 0 && _healthQuote$members6.find(function (m) {
                              var _m$relationship6, _m$relationship6$toSt, _member$relationship10, _member$relationship11;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship6 = m.relationship) === null || _m$relationship6 === void 0 ? void 0 : (_m$relationship6$toSt = _m$relationship6.toString()) === null || _m$relationship6$toSt === void 0 ? void 0 : _m$relationship6$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship10 = member.relationship) === null || _member$relationship10 === void 0 ? void 0 : (_member$relationship11 = _member$relationship10.toString()) === null || _member$relationship11 === void 0 ? void 0 : _member$relationship11.toLowerCase());
                            }));
                          })) === null || _quoteDetailsData$vie28 === void 0 ? void 0 : _quoteDetailsData$vie28.map(function (mem) {
                            return {
                              relationship: mem === null || mem === void 0 ? void 0 : mem.relationship,
                              age: mem === null || mem === void 0 ? void 0 : mem.age,
                              gender: mem === null || mem === void 0 ? void 0 : mem.gender,
                              dob: mem === null || mem === void 0 ? void 0 : mem.dob,
                              selected: true,
                              maternitySelected: mem !== null && mem !== void 0 && mem.maternitySelected ? mem === null || mem === void 0 ? void 0 : mem.maternitySelected : false
                            };
                          }) : [])),
                          cover: {
                            type: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie29 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie29 === void 0 ? void 0 : (_quoteDetailsData$vie30 = _quoteDetailsData$vie29.cover) === null || _quoteDetailsData$vie30 === void 0 ? void 0 : _quoteDetailsData$vie30.type,
                            sum_insured: "".concat(quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie31 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie31 === void 0 ? void 0 : (_quoteDetailsData$vie32 = _quoteDetailsData$vie31.cover) === null || _quoteDetailsData$vie32 === void 0 ? void 0 : _quoteDetailsData$vie32.sumInsured),
                            tenure: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie33 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie33 === void 0 ? void 0 : (_quoteDetailsData$vie34 = _quoteDetailsData$vie33.cover) === null || _quoteDetailsData$vie34 === void 0 ? void 0 : _quoteDetailsData$vie34.tenure
                          },
                          maternitySelectedCover: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie35 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie35 === void 0 ? void 0 : _quoteDetailsData$vie35.maternitySelectedCover,
                          quotationType: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie36 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie36 === void 0 ? void 0 : _quoteDetailsData$vie36.quotationType,
                          existingPolicyNumber: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie37 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie37 === void 0 ? void 0 : _quoteDetailsData$vie37.existingPolicyNumber,
                          isExistingEmployee: quoteDetailsData !== null && quoteDetailsData !== void 0 && (_quoteDetailsData$vie38 = quoteDetailsData.viewQuote) !== null && _quoteDetailsData$vie38 !== void 0 && _quoteDetailsData$vie38.isExistingEmployee ? 'Yes' : 'No'
                        });
                        initHealthPlansState();
                        setCopyQuoteDisplay(false);
                        setMoveToPlans(true);
                        document.body.classList.remove('overflow-y-hidden');
                        (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollTo({
                          top: 0,
                          behavior: 'smooth'
                        });
                        _context3.next = 30;
                        break;

                      case 25:
                        _context3.prev = 25;
                        _context3.t0 = _context3["catch"](1);
                        setCopyFromQuoteNumber('');
                        setCopying(false);
                        setAlerts([{
                          id: Date.now() + Math.random(),
                          content: /*#__PURE__*/React.createElement(Text, null, _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message),
                          type: 'error',
                          disableClose: false,
                          timeout: 3000
                        }]);

                      case 30:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 25]]);
              }));

              return function (_x3) {
                return _ref8.apply(this, arguments);
              };
            }(),
            size: 'small',
            className: "flex items-center h-8 space-x-2",
            iconPre: copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faSpinner,
              spin: true
            }) : undefined,
            iconPost: copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? undefined : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faChevronRight
            }),
            disabled: copying
          }, copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? 'Importing...' : 'Import')))))))))),
          colSpan: 1 // onClick: async () => {
          //   try {
          //     const fetchQuoteDetails = fetchQuery({
          //       query: VIEW_QUOTE_HEALTH,
          //       variables: {
          //         input: {
          //           quoteNumber: quoteData?.quoteNumber
          //         }
          //       }
          //     });
          //     const { data: quoteDetailsData} = await fetchQuoteDetails;
          //     updateHealthQuote({
          //       currentTab: 'plans',
          //       captureMode: 'create',
          //       location: quoteDetailsData?.viewQuote?.location,
          //       members: quoteDetailsData?.viewQuote?.members?.map((mem) => {
          //         return {
          //           relationship: mem?.relationship,
          //           age: mem?.age,
          //           gender: mem?.gender,
          //           dob: mem?.dob,
          //           selected: true,
          //         };
          //       }),
          //       cover: {
          //         type: quoteDetailsData?.viewQuote?.cover?.type,
          //         sum_insured: `${quoteDetailsData?.viewQuote?.cover?.sumInsured}`,
          //         tenure: quoteDetailsData?.viewQuote?.cover?.tenure,
          //       },
          //       quotationType: quoteDetailsData?.viewQuote?.quotationType,
          //       existingPolicyNumber: quoteDetailsData?.viewQuote?.existingPolicyNumber,
          //       isExistingEmployee: quoteDetailsData?.viewQuote?.isExistingEmployee
          //         ? 'Yes'
          //         : 'No',
          //     });
          //     setCopyQuoteDisplay(false);
          //     setMoveToPlans(true);
          //     document.body.classList.remove('overflow-y-hidden');
          //   }
          //   catch(error) {
          //   }
          // },

        };
      }) : []
    },
    card: {
      gap: 2,
      gapX: 2,
      gapY: 2,
      cardClassName: 'w-full',
      cardItemsArr: (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 0 ? searchData === null || searchData === void 0 ? void 0 : searchData.map(function (quoteData) {
        var _quoteData$product2, _quoteData$customer9, _quoteData$customer9$, _quoteData$customer10, _quoteData$customer11, _quoteData$customer12, _quoteData$customer13, _quoteData$customer14, _quoteData$customer15, _quoteData$customer16, _quoteData$customer17, _quoteData$customer18, _quoteData$customer19, _quoteData$customer20, _quoteData$customer21, _quoteData$customer22, _quoteData$customer23;

        return {
          id: "".concat(quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber),
          content: /*#__PURE__*/React.createElement(Paper, {
            className: "border-2 rounded p-4 min-h-full ".concat( //   cardSummaryDetail?.quoteNumber
            //     .toString()
            //     ?.toLowerCase() ===
            //   quoteData?.quoteNumber
            //     ?.toString()
            //     ?.toLowerCase()
            //     ? 'bg-neutral'
            //     :
            'hover:bg-neutral-light')
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col w-full justify-between h-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex items-center justify-between h-full w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold flex space-x-2 items-start w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'flex flex-col h-full justify-between w-full'
          }, /*#__PURE__*/React.createElement(Text, {
            severity: 'info',
            className: 'font-semibold w-full flex space-x-2 items-center justify-between'
          }, /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber, ",", quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$product2 = quoteData.product) === null || _quoteData$product2 === void 0 ? void 0 : _quoteData$product2.productName), /*#__PURE__*/React.createElement(Text, {
            className: 'font-semibold'
          }, quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteStatus)), /*#__PURE__*/React.createElement(Text, {
            type: 'label',
            className: 'w-full h-full mb-5 text-neutral-darker'
          }, "Saved on ", quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteCreationDate), /*#__PURE__*/React.createElement(Text, {
            className: 'w-full h-full'
          }, /*#__PURE__*/React.createElement(Grid, {
            repeat: 2,
            className: 'w-full h-full'
          }, quoteData !== null && quoteData !== void 0 && (_quoteData$customer9 = quoteData.customer) !== null && _quoteData$customer9 !== void 0 && (_quoteData$customer9$ = _quoteData$customer9.indv_detail) !== null && _quoteData$customer9$ !== void 0 && _quoteData$customer9$.full_name || quoteData !== null && quoteData !== void 0 && (_quoteData$customer10 = quoteData.customer) !== null && _quoteData$customer10 !== void 0 && (_quoteData$customer11 = _quoteData$customer10.org_detail) !== null && _quoteData$customer11 !== void 0 && _quoteData$customer11.org_name ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full justify-start'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faUser
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, (quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer12 = quoteData.customer) === null || _quoteData$customer12 === void 0 ? void 0 : (_quoteData$customer13 = _quoteData$customer12.indv_detail) === null || _quoteData$customer13 === void 0 ? void 0 : _quoteData$customer13.full_name) || (quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer14 = quoteData.customer) === null || _quoteData$customer14 === void 0 ? void 0 : (_quoteData$customer15 = _quoteData$customer14.org_detail) === null || _quoteData$customer15 === void 0 ? void 0 : _quoteData$customer15.org_name))) : '', quoteData !== null && quoteData !== void 0 && (_quoteData$customer16 = quoteData.customer) !== null && _quoteData$customer16 !== void 0 && (_quoteData$customer17 = _quoteData$customer16.contact) !== null && _quoteData$customer17 !== void 0 && _quoteData$customer17.mobile ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: screenType === 'mobile' ? 'flex space-x-2 w-full justify-end' : 'flex space-x-2 w-full justify-start'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faMobileAlt
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer18 = quoteData.customer) === null || _quoteData$customer18 === void 0 ? void 0 : (_quoteData$customer19 = _quoteData$customer18.contact) === null || _quoteData$customer19 === void 0 ? void 0 : _quoteData$customer19.mobile)) : '', quoteData !== null && quoteData !== void 0 && (_quoteData$customer20 = quoteData.customer) !== null && _quoteData$customer20 !== void 0 && (_quoteData$customer21 = _quoteData$customer20.contact) !== null && _quoteData$customer21 !== void 0 && _quoteData$customer21.email ? /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full break-all'
          }, /*#__PURE__*/React.createElement(Text, {
            type: 'label'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faEnvelope
          })), /*#__PURE__*/React.createElement(Text, {
            type: 'label',
            className: 'break-all'
          }, quoteData === null || quoteData === void 0 ? void 0 : (_quoteData$customer22 = quoteData.customer) === null || _quoteData$customer22 === void 0 ? void 0 : (_quoteData$customer23 = _quoteData$customer22.contact) === null || _quoteData$customer23 === void 0 ? void 0 : _quoteData$customer23.email)) : '', /*#__PURE__*/React.createElement(GridItem, {
            colSpan: 1,
            className: 'flex space-x-2 w-full justify-end'
          }, /*#__PURE__*/React.createElement(Text, {
            className: "flex justify-end"
          }, /*#__PURE__*/React.createElement(Button, {
            type: 'button',
            flat: false,
            onClick: /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                var _quoteDetailsData$vie39, _healthQuote$members7, _quoteDetailsData$vie42, _quoteDetailsData$vie43, _quoteDetailsData$vie44, _quoteDetailsData$vie45, _quoteDetailsData$vie46, _quoteDetailsData$vie47, _quoteDetailsData$vie48, _quoteDetailsData$vie49, _quoteDetailsData$vie50, _quoteDetailsData$vie51, _quoteDetailsData$vie52, _quoteDetailsData$vie53, _quoteDetailsData$vie54, _quoteDetailsData$vie55, _quoteDetailsData$vie56, _quoteDetailsData$vie57, _window3, fetchQuoteDetails, getHealthQuoteVar, _yield$fetchQuoteDeta3, quoteDetailsData, _yield$getHealthQuote3, healthReactiveVarData, healthQuote;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        e.stopPropagation();
                        _context4.prev = 1;
                        fetchQuoteDetails = fetchQuery({
                          query: VIEW_QUOTE_HEALTH,
                          variables: {
                            input: {
                              quoteNumber: quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber
                            }
                          }
                        });
                        getHealthQuoteVar = fetchQuery({
                          query: QUERY_STATE
                        });
                        setAlerts([]);
                        setCopyFromQuoteNumber(quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber);
                        setCopying(true);
                        _context4.next = 9;
                        return fetchQuoteDetails;

                      case 9:
                        _yield$fetchQuoteDeta3 = _context4.sent;
                        quoteDetailsData = _yield$fetchQuoteDeta3.data;
                        _context4.next = 13;
                        return getHealthQuoteVar;

                      case 13:
                        _yield$getHealthQuote3 = _context4.sent;
                        healthReactiveVarData = _yield$getHealthQuote3.data;
                        healthQuote = healthReactiveVarData.healthQuote;
                        setCopying(false);
                        updateHealthQuote({
                          currentTab: 'plans',
                          captureMode: 'create',
                          location: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie39 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie39 === void 0 ? void 0 : _quoteDetailsData$vie39.location,
                          members: [].concat(_toConsumableArray(healthQuote === null || healthQuote === void 0 ? void 0 : (_healthQuote$members7 = healthQuote.members) === null || _healthQuote$members7 === void 0 ? void 0 : _healthQuote$members7.map(function (member) {
                            var _quoteDetailsData$vie40, _quoteDetailsData$vie41;

                            var searchMemObj = quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie40 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie40 === void 0 ? void 0 : (_quoteDetailsData$vie41 = _quoteDetailsData$vie40.members) === null || _quoteDetailsData$vie41 === void 0 ? void 0 : _quoteDetailsData$vie41.find(function (m) {
                              var _m$relationship7, _m$relationship7$toSt, _member$relationship12, _member$relationship13;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship7 = m.relationship) === null || _m$relationship7 === void 0 ? void 0 : (_m$relationship7$toSt = _m$relationship7.toString()) === null || _m$relationship7$toSt === void 0 ? void 0 : _m$relationship7$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship12 = member.relationship) === null || _member$relationship12 === void 0 ? void 0 : (_member$relationship13 = _member$relationship12.toString()) === null || _member$relationship13 === void 0 ? void 0 : _member$relationship13.toLowerCase());
                            });

                            if (searchMemObj) {
                              return {
                                relationship: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.relationship,
                                age: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.age,
                                gender: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.gender,
                                dob: searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.dob,
                                selected: true,
                                maternitySelected: searchMemObj !== null && searchMemObj !== void 0 && searchMemObj.maternitySelected ? searchMemObj === null || searchMemObj === void 0 ? void 0 : searchMemObj.maternitySelected : false
                              };
                            } else {
                              return _objectSpread2(_objectSpread2({}, member), {}, {
                                selected: false
                              });
                            }
                          })), _toConsumableArray((quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie42 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie42 === void 0 ? void 0 : (_quoteDetailsData$vie43 = _quoteDetailsData$vie42.members) === null || _quoteDetailsData$vie43 === void 0 ? void 0 : (_quoteDetailsData$vie44 = _quoteDetailsData$vie43.filter(function (member) {
                            var _healthQuote$members8;

                            return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members8 = healthQuote.members) !== null && _healthQuote$members8 !== void 0 && _healthQuote$members8.find(function (m) {
                              var _m$relationship8, _m$relationship8$toSt, _member$relationship14, _member$relationship15;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship8 = m.relationship) === null || _m$relationship8 === void 0 ? void 0 : (_m$relationship8$toSt = _m$relationship8.toString()) === null || _m$relationship8$toSt === void 0 ? void 0 : _m$relationship8$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship14 = member.relationship) === null || _member$relationship14 === void 0 ? void 0 : (_member$relationship15 = _member$relationship14.toString()) === null || _member$relationship15 === void 0 ? void 0 : _member$relationship15.toLowerCase());
                            }));
                          })) === null || _quoteDetailsData$vie44 === void 0 ? void 0 : _quoteDetailsData$vie44.length) > 0 ? quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie45 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie45 === void 0 ? void 0 : (_quoteDetailsData$vie46 = _quoteDetailsData$vie45.members) === null || _quoteDetailsData$vie46 === void 0 ? void 0 : (_quoteDetailsData$vie47 = _quoteDetailsData$vie46.filter(function (member) {
                            var _healthQuote$members9;

                            return !(healthQuote !== null && healthQuote !== void 0 && (_healthQuote$members9 = healthQuote.members) !== null && _healthQuote$members9 !== void 0 && _healthQuote$members9.find(function (m) {
                              var _m$relationship9, _m$relationship9$toSt, _member$relationship16, _member$relationship17;

                              return (m === null || m === void 0 ? void 0 : (_m$relationship9 = m.relationship) === null || _m$relationship9 === void 0 ? void 0 : (_m$relationship9$toSt = _m$relationship9.toString()) === null || _m$relationship9$toSt === void 0 ? void 0 : _m$relationship9$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship16 = member.relationship) === null || _member$relationship16 === void 0 ? void 0 : (_member$relationship17 = _member$relationship16.toString()) === null || _member$relationship17 === void 0 ? void 0 : _member$relationship17.toLowerCase());
                            }));
                          })) === null || _quoteDetailsData$vie47 === void 0 ? void 0 : _quoteDetailsData$vie47.map(function (mem) {
                            return {
                              relationship: mem === null || mem === void 0 ? void 0 : mem.relationship,
                              age: mem === null || mem === void 0 ? void 0 : mem.age,
                              gender: mem === null || mem === void 0 ? void 0 : mem.gender,
                              dob: mem === null || mem === void 0 ? void 0 : mem.dob,
                              selected: true,
                              maternitySelected: mem !== null && mem !== void 0 && mem.maternitySelected ? mem === null || mem === void 0 ? void 0 : mem.maternitySelected : false
                            };
                          }) : [])),
                          cover: {
                            type: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie48 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie48 === void 0 ? void 0 : (_quoteDetailsData$vie49 = _quoteDetailsData$vie48.cover) === null || _quoteDetailsData$vie49 === void 0 ? void 0 : _quoteDetailsData$vie49.type,
                            sum_insured: "".concat(quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie50 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie50 === void 0 ? void 0 : (_quoteDetailsData$vie51 = _quoteDetailsData$vie50.cover) === null || _quoteDetailsData$vie51 === void 0 ? void 0 : _quoteDetailsData$vie51.sumInsured),
                            tenure: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie52 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie52 === void 0 ? void 0 : (_quoteDetailsData$vie53 = _quoteDetailsData$vie52.cover) === null || _quoteDetailsData$vie53 === void 0 ? void 0 : _quoteDetailsData$vie53.tenure
                          },
                          maternitySelectedCover: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie54 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie54 === void 0 ? void 0 : _quoteDetailsData$vie54.maternitySelectedCover,
                          quotationType: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie55 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie55 === void 0 ? void 0 : _quoteDetailsData$vie55.quotationType,
                          existingPolicyNumber: quoteDetailsData === null || quoteDetailsData === void 0 ? void 0 : (_quoteDetailsData$vie56 = quoteDetailsData.viewQuote) === null || _quoteDetailsData$vie56 === void 0 ? void 0 : _quoteDetailsData$vie56.existingPolicyNumber,
                          isExistingEmployee: quoteDetailsData !== null && quoteDetailsData !== void 0 && (_quoteDetailsData$vie57 = quoteDetailsData.viewQuote) !== null && _quoteDetailsData$vie57 !== void 0 && _quoteDetailsData$vie57.isExistingEmployee ? 'Yes' : 'No'
                        });
                        initHealthPlansState();
                        setCopyQuoteDisplay(false);
                        setMoveToPlans(true);
                        document.body.classList.remove('overflow-y-hidden');
                        (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.scrollTo({
                          top: 0,
                          behavior: 'smooth'
                        });
                        _context4.next = 30;
                        break;

                      case 25:
                        _context4.prev = 25;
                        _context4.t0 = _context4["catch"](1);
                        setCopying(false);
                        setCopyFromQuoteNumber('');
                        setAlerts([{
                          id: Date.now() + Math.random(),
                          content: /*#__PURE__*/React.createElement(Text, null, _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message),
                          type: 'error',
                          disableClose: false,
                          timeout: 3000
                        }]);

                      case 30:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[1, 25]]);
              }));

              return function (_x4) {
                return _ref9.apply(this, arguments);
              };
            }(),
            size: 'small',
            className: "flex items-center h-8 space-x-2",
            iconPre: copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faSpinner,
              spin: true
            }) : undefined,
            iconPost: copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? undefined : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faChevronRight
            }),
            disabled: copying
          }, copying && copyFromQuoteNumber === (quoteData === null || quoteData === void 0 ? void 0 : quoteData.quoteNumber) ? 'Importing...' : 'Import')))))))))),
          colSpan: 1
        };
      }) : []
    },
    isSortRequired: false,
    list: searchData.map(function (viewQuote) {
      var _viewQuote$customer, _viewQuote$customer$o, _viewQuote$customer2, _viewQuote$customer2$, _viewQuote$customer3, _viewQuote$customer3$, _viewQuote$customer4, _viewQuote$customer4$, _viewQuote$customer5, _viewQuote$customer5$, _viewQuote$customer5$2, _viewQuote$customer6, _viewQuote$customer6$, _viewQuote$customer6$2, _viewQuote$customer7, _viewQuote$customer7$, _viewQuote$customer7$2;

      return {
        id: "".concat(viewQuote.quoteNumber),
        title: "".concat(viewQuote.quoteNumber),
        subtitle: /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col"
        }, /*#__PURE__*/React.createElement("span", null, viewQuote !== null && viewQuote !== void 0 && (_viewQuote$customer = viewQuote.customer) !== null && _viewQuote$customer !== void 0 && (_viewQuote$customer$o = _viewQuote$customer.org_detail) !== null && _viewQuote$customer$o !== void 0 && _viewQuote$customer$o.org_name ? viewQuote === null || viewQuote === void 0 ? void 0 : (_viewQuote$customer2 = viewQuote.customer) === null || _viewQuote$customer2 === void 0 ? void 0 : (_viewQuote$customer2$ = _viewQuote$customer2.org_detail) === null || _viewQuote$customer2$ === void 0 ? void 0 : _viewQuote$customer2$.org_name : viewQuote !== null && viewQuote !== void 0 && (_viewQuote$customer3 = viewQuote.customer) !== null && _viewQuote$customer3 !== void 0 && (_viewQuote$customer3$ = _viewQuote$customer3.indv_detail) !== null && _viewQuote$customer3$ !== void 0 && _viewQuote$customer3$.full_name ? viewQuote === null || viewQuote === void 0 ? void 0 : (_viewQuote$customer4 = viewQuote.customer) === null || _viewQuote$customer4 === void 0 ? void 0 : (_viewQuote$customer4$ = _viewQuote$customer4.indv_detail) === null || _viewQuote$customer4$ === void 0 ? void 0 : _viewQuote$customer4$.full_name : [viewQuote === null || viewQuote === void 0 ? void 0 : (_viewQuote$customer5 = viewQuote.customer) === null || _viewQuote$customer5 === void 0 ? void 0 : (_viewQuote$customer5$ = _viewQuote$customer5.indv_detail) === null || _viewQuote$customer5$ === void 0 ? void 0 : (_viewQuote$customer5$2 = _viewQuote$customer5$.first_name) === null || _viewQuote$customer5$2 === void 0 ? void 0 : _viewQuote$customer5$2.trim(), viewQuote === null || viewQuote === void 0 ? void 0 : (_viewQuote$customer6 = viewQuote.customer) === null || _viewQuote$customer6 === void 0 ? void 0 : (_viewQuote$customer6$ = _viewQuote$customer6.indv_detail) === null || _viewQuote$customer6$ === void 0 ? void 0 : (_viewQuote$customer6$2 = _viewQuote$customer6$.middle_name) === null || _viewQuote$customer6$2 === void 0 ? void 0 : _viewQuote$customer6$2.trim(), viewQuote === null || viewQuote === void 0 ? void 0 : (_viewQuote$customer7 = viewQuote.customer) === null || _viewQuote$customer7 === void 0 ? void 0 : (_viewQuote$customer7$ = _viewQuote$customer7.indv_detail) === null || _viewQuote$customer7$ === void 0 ? void 0 : (_viewQuote$customer7$2 = _viewQuote$customer7$.surname) === null || _viewQuote$customer7$2 === void 0 ? void 0 : _viewQuote$customer7$2.trim()].join(' ')), /*#__PURE__*/React.createElement("span", null, viewQuote === null || viewQuote === void 0 ? void 0 : viewQuote.quoteStatus, ' , ', viewQuote === null || viewQuote === void 0 ? void 0 : viewQuote.quotationType)),
        onClick: function onClick() {
          return undefined;
        } //   history.push(
        //     `/quote/saved/${viewQuote?.lob?.lobCode}/${viewQuote?.lob?.lobName}/${viewQuote?.product?.productCode}/${viewQuote?.product?.productName}/${viewQuote?.quoteNumber}`,
        //   ),

      };
    })
  };
  var paginationInput = {
    offset: offset,
    PAGE_SIZE: PAGE_SIZE // onClickPrev: () => setCardSummaryDetail(undefined),
    // onClickNext: () => setCardSummaryDetail(undefined),

  };

  var onMessage = function onMessage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (searchQuoteMeta === null || searchQuoteMeta === void 0 ? void 0 : searchQuoteMeta.resultCount) > (searchQuoteMeta === null || searchQuoteMeta === void 0 ? void 0 : searchQuoteMeta.maxRow) && /*#__PURE__*/React.createElement(Text, {
      severity: "warning",
      className: "space-x-1"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faExclamationTriangle,
      size: "lg"
    }), /*#__PURE__*/React.createElement("span", null, "Search results are truncated to first", ' ', searchQuoteMeta === null || searchQuoteMeta === void 0 ? void 0 : searchQuoteMeta.maxRow, " records.", '\t', "Please refine your search to get more accurate quote data.")));
  };

  return (
    /*#__PURE__*/
    // <Card className="lg:h-full min-h-screen">
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchResultsAdvanced, {
      searchInput: searchInput,
      searchResults: searchResults,
      paginationInput: paginationInput,
      onMessage: onMessage,
      switchViewEnabled: true,
      firstRowClickRequired: false
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
      items: alerts
    }))) // </Card>

  );
}

var _excluded = ["copyQuoteDisplay", "setCopyQuoteDisplay", "setMoveToPlans"];
function ImportQuoteModal(_ref) {
  var copyQuoteDisplay = _ref.copyQuoteDisplay,
      setCopyQuoteDisplay = _ref.setCopyQuoteDisplay,
      setMoveToPlans = _ref.setMoveToPlans,
      props = _objectWithoutProperties(_ref, _excluded);

  var voice = props.voice;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'full',
    for_iPad: 'full'
  });

  var onModalClose = function onModalClose() {
    setCopyQuoteDisplay(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: copyQuoteDisplay,
    size: modalSize,
    title: 'Import Quote',
    className: "min-h-screen flex flex-col justify-start",
    onClose: onModalClose,
    severity: 'action',
    direction: 'down'
  }, /*#__PURE__*/React.createElement(SmartSearchPanelHealth, {
    alerts: alerts,
    setAlerts: setAlerts,
    voice: voice,
    setCopyQuoteDisplay: setCopyQuoteDisplay,
    setMoveToPlans: setMoveToPlans
  }));
}

var BulbIcon = function BulbIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-8 w-8",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
  }));
};

function CopyQuote(_ref) {
  var _data$healthQuote4, _data$healthQuote4$cu, _data$healthQuote4$cu2, _data$healthQuote5, _screenType$toString;

  var setMoveToPlans = _ref.setMoveToPlans,
      quoteNumber = _ref.quoteNumber,
      productCode = _ref.productCode,
      productName = _ref.productName,
      lobCode = _ref.lobCode;
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      copyQuoteDisplay = _useState2[0],
      setCopyQuoteDisplay = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copyQuoteCardDisplay = _useState4[0],
      setCopyQuoteCardDisplay = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2);
      _useState6[0];
      _useState6[1];

  var screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
    for_iPad: 'ipad'
  });

  var _useQuery = useQuery(QUERY_STATE, {
    fetchPolicy: 'cache-first' // onCompleted: (data) => setInitLoad(true),
    // skip:initLoad

  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var CopyQuoteCard = function CopyQuoteCard() {
    return /*#__PURE__*/React.createElement(Card, {
      className: "h-full p-0 mb-4"
    }, /*#__PURE__*/React.createElement(Text, {
      className: "flex flex-col w-full h-full space-y-4"
    }, /*#__PURE__*/React.createElement(Text, {
      className: 'flex space-x-2 items-center'
    }, /*#__PURE__*/React.createElement(Text, {
      severity: 'info'
    }, /*#__PURE__*/React.createElement(BulbIcon, null)), /*#__PURE__*/React.createElement(Text, {
      severity: 'info',
      type: 'title'
    }, "Do you know ?")), /*#__PURE__*/React.createElement(Text, null, quoteNumber ? 'You can copy this already saved quote to a new quote.' : 'You can save time by copying from an existing quote.'), /*#__PURE__*/React.createElement(Text, {
      className: 'w-full h-full mt-4 quanta_link p-2 text-center',
      onClick: function onClick(_) {
        if (quoteNumber) {
          var _init_state_quote$mem, _data$healthQuote3, _data$healthQuote3$me;

          updateHealthQuote({
            show_plans: true,
            quotationNo: '',
            isQuoteSaving: false,
            quotationStatus: '',
            quoteCreationDate: '',
            proposalNumber: '',
            currentTab: 'plans',
            captureMode: 'create',
            isCopyFromOutside: true,
            isQuoteCopied: true,
            members: [].concat(_toConsumableArray(init_state_quote === null || init_state_quote === void 0 ? void 0 : (_init_state_quote$mem = init_state_quote.members) === null || _init_state_quote$mem === void 0 ? void 0 : _init_state_quote$mem.map(function (member) {
              var _data$healthQuote, _data$healthQuote$mem;

              if (data !== null && data !== void 0 && (_data$healthQuote = data.healthQuote) !== null && _data$healthQuote !== void 0 && (_data$healthQuote$mem = _data$healthQuote.members) !== null && _data$healthQuote$mem !== void 0 && _data$healthQuote$mem.find(function (m) {
                var _m$relationship, _m$relationship$toStr, _member$relationship, _member$relationship$;

                return (m === null || m === void 0 ? void 0 : (_m$relationship = m.relationship) === null || _m$relationship === void 0 ? void 0 : (_m$relationship$toStr = _m$relationship.toString()) === null || _m$relationship$toStr === void 0 ? void 0 : _m$relationship$toStr.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship = member.relationship) === null || _member$relationship === void 0 ? void 0 : (_member$relationship$ = _member$relationship.toString()) === null || _member$relationship$ === void 0 ? void 0 : _member$relationship$.toLowerCase());
              })) {
                var _data$healthQuote2, _data$healthQuote2$me;

                var sameMember = data === null || data === void 0 ? void 0 : (_data$healthQuote2 = data.healthQuote) === null || _data$healthQuote2 === void 0 ? void 0 : (_data$healthQuote2$me = _data$healthQuote2.members) === null || _data$healthQuote2$me === void 0 ? void 0 : _data$healthQuote2$me.find(function (m) {
                  var _m$relationship2, _m$relationship2$toSt, _member$relationship2, _member$relationship3;

                  return (m === null || m === void 0 ? void 0 : (_m$relationship2 = m.relationship) === null || _m$relationship2 === void 0 ? void 0 : (_m$relationship2$toSt = _m$relationship2.toString()) === null || _m$relationship2$toSt === void 0 ? void 0 : _m$relationship2$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship2 = member.relationship) === null || _member$relationship2 === void 0 ? void 0 : (_member$relationship3 = _member$relationship2.toString()) === null || _member$relationship3 === void 0 ? void 0 : _member$relationship3.toLowerCase());
                });
                return sameMember;
              } else {
                return member;
              }
            })), _toConsumableArray(data === null || data === void 0 ? void 0 : (_data$healthQuote3 = data.healthQuote) === null || _data$healthQuote3 === void 0 ? void 0 : (_data$healthQuote3$me = _data$healthQuote3.members) === null || _data$healthQuote3$me === void 0 ? void 0 : _data$healthQuote3$me.filter(function (member) {
              var _init_state_quote$mem2;

              return !(init_state_quote !== null && init_state_quote !== void 0 && (_init_state_quote$mem2 = init_state_quote.members) !== null && _init_state_quote$mem2 !== void 0 && _init_state_quote$mem2.find(function (m) {
                var _m$relationship3, _m$relationship3$toSt, _member$relationship4, _member$relationship5;

                return (m === null || m === void 0 ? void 0 : (_m$relationship3 = m.relationship) === null || _m$relationship3 === void 0 ? void 0 : (_m$relationship3$toSt = _m$relationship3.toString()) === null || _m$relationship3$toSt === void 0 ? void 0 : _m$relationship3$toSt.toLowerCase()) === (member === null || member === void 0 ? void 0 : (_member$relationship4 = member.relationship) === null || _member$relationship4 === void 0 ? void 0 : (_member$relationship5 = _member$relationship4.toString()) === null || _member$relationship5 === void 0 ? void 0 : _member$relationship5.toLowerCase());
              }));
            })))
          });
          updateHealthQuotePlans(data === null || data === void 0 ? void 0 : data.healthPlans.plans, true);
          history === null || history === void 0 ? void 0 : history.push("/quote/Health/".concat(lobCode, "/").concat(productName, "/").concat(productCode));
          setTimeout(function () {
            var _window;

            (_window = window) === null || _window === void 0 ? void 0 : _window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }, 200);
          document.body.classList.remove('overflow-y-hidden');
        } else {
          setCopyQuoteDisplay(true);
          setCopyQuoteCardDisplay(false);
        }
      }
    }, quoteNumber ? 'Copy this Quote' : 'Click here to try')));
  };

  if (loading) {
    return /*#__PURE__*/React.createElement(Card, {
      className: 'h-full p-0 mb-4'
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error) {
    return /*#__PURE__*/React.createElement(Card, {
      className: 'h-full p-0 mb-4'
    }, /*#__PURE__*/React.createElement(Error$1, {
      error: error
    }));
  }

  return (quoteNumber ? true : (data === null || data === void 0 ? void 0 : (_data$healthQuote4 = data.healthQuote) === null || _data$healthQuote4 === void 0 ? void 0 : (_data$healthQuote4$cu = _data$healthQuote4.currentTab) === null || _data$healthQuote4$cu === void 0 ? void 0 : (_data$healthQuote4$cu2 = _data$healthQuote4$cu.toString()) === null || _data$healthQuote4$cu2 === void 0 ? void 0 : _data$healthQuote4$cu2.toLowerCase()) === 'members' && !(data !== null && data !== void 0 && (_data$healthQuote5 = data.healthQuote) !== null && _data$healthQuote5 !== void 0 && _data$healthQuote5.quotationNo)) ? (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) === 'desktop' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CopyQuoteCard, null), /*#__PURE__*/React.createElement(ImportQuoteModal, {
    copyQuoteDisplay: copyQuoteDisplay,
    setCopyQuoteDisplay: setCopyQuoteDisplay,
    setMoveToPlans: setMoveToPlans
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    display: copyQuoteCardDisplay,
    severity: 'action',
    onClose: function onClose(_) {
      setCopyQuoteCardDisplay(false);
    },
    useFragment: true,
    fragmentSizeRequired: true,
    fragmentSize: 'small',
    className: 'h-auto'
  }, /*#__PURE__*/React.createElement(CopyQuoteCard, null)), /*#__PURE__*/React.createElement(Text, {
    className: "fixed bottom-48 right-4 z-40"
  }, /*#__PURE__*/React.createElement(CircleButton, {
    size: "medium",
    onClick: function onClick(e) {
      return setCopyQuoteCardDisplay(true);
    }
  }, /*#__PURE__*/React.createElement(BulbIcon, null))), /*#__PURE__*/React.createElement(ImportQuoteModal, {
    copyQuoteDisplay: copyQuoteDisplay,
    setCopyQuoteDisplay: setCopyQuoteDisplay,
    setMoveToPlans: setMoveToPlans
  })) : null;
}

function CaptureHealthDetails(_ref) {
  var _lobProductList$find, _lobProductList$find$, _ref2, _screenType$toString, _screenType$toString2, _screenType$toString3;

  var productName = _ref.productName,
      productCode = _ref.productCode,
      lobCode = _ref.lobCode,
      quoteNumber = _ref.quoteNumber,
      breadcrumbNav = _ref.breadcrumbNav;
  var nav = ['Quote', 'Get Quote'];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      moveToPlans = _useState2[0],
      setMoveToPlans = _useState2[1];

  var product_name = productName ? productName : useParams().product_name;
  var product_code = productCode ? productCode : useParams().product_code;
  var lob_code = lobCode ? lobCode : useParams().lob_code;
  var quote_number = quoteNumber ? quoteNumber : undefined;

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      saveProceedDisplay = _useState4[0],
      setsaveProceedDisplay = _useState4[1];

  var textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl'
  });
  var screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
    for_iPad: 'ipad'
  });
  useEffect(function () {
    if (quote_number === undefined || quote_number === null) {
      var res = initHealthQuoteState(true);

      if (res) {
        setMoveToPlans(true);
      } //  initHealthPlansState();


      initBuyHealthPolicyVar();
    }
  }, [quote_number]);

  var _useQuery = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first'
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }

  if (error) {
    return /*#__PURE__*/React.createElement(Error, {
      error: error
    });
  }

  var lobProductList = data.lobProductList;
  return /*#__PURE__*/React.createElement(Layout, {
    nav: breadcrumbNav ? breadcrumbNav : nav,
    service_type: ClientService,
    title: "Your ".concat(product_name, " Quote")
  }, lobProductList !== null && lobProductList !== void 0 && (_lobProductList$find = lobProductList.find(function (lob) {
    var _lob$lob_code, _lob$lob_code$toStrin, _lob_code$toString;

    return (lob === null || lob === void 0 ? void 0 : (_lob$lob_code = lob.lob_code) === null || _lob$lob_code === void 0 ? void 0 : (_lob$lob_code$toStrin = _lob$lob_code.toString()) === null || _lob$lob_code$toStrin === void 0 ? void 0 : _lob$lob_code$toStrin.toLowerCase()) === (lob_code === null || lob_code === void 0 ? void 0 : (_lob_code$toString = lob_code.toString()) === null || _lob_code$toString === void 0 ? void 0 : _lob_code$toString.toLowerCase());
  })) !== null && _lobProductList$find !== void 0 && (_lobProductList$find$ = _lobProductList$find.products) !== null && _lobProductList$find$ !== void 0 && _lobProductList$find$.find(function (product) {
    var _product$product_code, _product$product_code2, _product_code$toStrin, _product$product_name, _product$product_name2, _product_name$toStrin;

    return (product === null || product === void 0 ? void 0 : (_product$product_code = product.product_code) === null || _product$product_code === void 0 ? void 0 : (_product$product_code2 = _product$product_code.toString()) === null || _product$product_code2 === void 0 ? void 0 : _product$product_code2.toLowerCase()) === (product_code === null || product_code === void 0 ? void 0 : (_product_code$toStrin = product_code.toString()) === null || _product_code$toStrin === void 0 ? void 0 : _product_code$toStrin.toLowerCase()) && (product === null || product === void 0 ? void 0 : (_product$product_name = product.product_name) === null || _product$product_name === void 0 ? void 0 : (_product$product_name2 = _product$product_name.toString()) === null || _product$product_name2 === void 0 ? void 0 : _product$product_name2.toLowerCase()) === (product_name === null || product_name === void 0 ? void 0 : (_product_name$toStrin = product_name.toString()) === null || _product_name$toStrin === void 0 ? void 0 : _product_name$toStrin.toLowerCase());
  }) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SummaryLayout, {
    summary: /*#__PURE__*/React.createElement("div", {
      className: "".concat((_ref2 = ['mobile', 'ipad']) !== null && _ref2 !== void 0 && _ref2.includes(screenType === null || screenType === void 0 ? void 0 : (_screenType$toString = screenType.toString()) === null || _screenType$toString === void 0 ? void 0 : _screenType$toString.toLowerCase()) ? '' : 'sticky', " top-0")
    }, (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString2 = screenType.toString()) === null || _screenType$toString2 === void 0 ? void 0 : _screenType$toString2.toLowerCase()) === 'desktop' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col justify-start h-auto"
    }, /*#__PURE__*/React.createElement(CopyQuote, {
      productCode: product_code,
      productName: product_name,
      lobCode: lob_code,
      quoteNumber: quote_number,
      setMoveToPlans: setMoveToPlans
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col justify-start h-auto"
    }, /*#__PURE__*/React.createElement(Card, {
      className: "h-full p-0",
      title: "Quotation"
    }, /*#__PURE__*/React.createElement(QuoteSummary, {
      productCode: product_code,
      productName: product_name,
      lobCode: lob_code,
      quoteNumber: quote_number,
      setsaveProceedDisplay: setsaveProceedDisplay
    })))),
    showFloatingSummary: true,
    summaryIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSave,
      size: "2x"
    })
  }, /*#__PURE__*/React.createElement(Card, {
    className: "xl:min-h-full min-h-screen"
  }, /*#__PURE__*/React.createElement(QuoteWizard, {
    lobCode: lob_code,
    productName: product_name,
    productCode: product_code,
    quoteNumber: quote_number,
    moveToPlans: moveToPlans,
    setMoveToPlans: setMoveToPlans,
    saveProceedDisplay: saveProceedDisplay
  }))), (screenType === null || screenType === void 0 ? void 0 : (_screenType$toString3 = screenType.toString()) === null || _screenType$toString3 === void 0 ? void 0 : _screenType$toString3.toLowerCase()) !== 'desktop' && /*#__PURE__*/React.createElement(CopyQuote, {
    productCode: product_code,
    productName: product_name,
    lobCode: lob_code,
    quoteNumber: quote_number,
    setMoveToPlans: setMoveToPlans
  })) : /*#__PURE__*/React.createElement(Card, {
    className: "h-screen",
    severity: "error"
  }, /*#__PURE__*/React.createElement(Text, {
    severity: 'error',
    className: "w-full h-full text-center text-".concat(textSize, " flex items-center justify-center")
  }, "Given Lob/Product Information is not Available or Invalid")));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': CaptureHealthDetails
});

export { MOBILE_NUMBER_STARTING_WITH$1 as A, COVER_TYPE_LIMIT as B, CaptureHealthDetails as C, SEARCH_QUOTES as D, QUOTE_STATUS_LIST as E, DATE_RANGE as F, GetFieldUserName as G, LOB_PRODUCT_LIST as H, ImportQuoteModal as I, FETCH_ROLE as J, SAVE_QUOTE_TYPE as K, LOOKUP_FIELDUSER as L, Members as M, CROSS_SELL_ROLE_LIMIT as N, EXCEPTION_ROLE_LIMIT as O, Plans as P, QuoteSummary as Q, EXISTING_POLICY_DTLS as R, ShowPlans as S, index as T, VIEW_QUOTE_HEALTH as V, QuoteWizard as a, QuoteData as b, ShowPremium as c, CopyQuote as d, ModalAddOthers as e, ModalSaveQuote as f, ModalSendEmail as g, ModalSendSms as h, QUERY_STATE as i, PIN_CODE_LOOKUP as j, GET_PRODUCT_DETAILS as k, GET_PLAN_COVER_DETAILS as l, CALCULATE_PREMIUM as m, SAVE_QUOTE as n, SAVE_PLAN_PREDICTION_DATA as o, PREDICT_HEALTH_PLAN as p, SEARCH_CUSTOMERS as q, SEARCH_CUSTOMER_BY_NUMBER as r, GET_CUSTOMER_TYPE_DOMAIN as s, CUSTOMER_DROPDOWN_DETAILS as t, SEND_QUOTE_EMAIL_ALERT as u, SEND_QUOTE_SMS_ALERT as v, SEND_QUOTE_PDF as w, PRODUCT_TYPE_LIST as x, INTERMEDIARY_LIST as y, CHARACTER_LIMIT_LIST as z };
